export const QUESTIONS = [
  {
    "id": 1,
    "question": "Which activity best reflects effective organizational governance in IT risk management?",
    "choice_a": "Selecting security tools based on industry trends",
    "choice_b": "Aligning IT risk activities with business objectives",
    "choice_c": "Performing penetration testing annually",
    "choice_d": "Delegating all risk decisions to IT management",
    "correct_answer": "B",
    "explanation": "Organizational governance requires alignment of IT risk management with business strategy, goals, and objectives. When they are aligned, IT risk decisions made by management are more likely to reflect the organization\u2019s risk appetite. Security tools should be selected based on identified risks and local IT standards. Annual penetration tests are essential, but not an indicator of business alignment. Risk decisions are made by business leaders, and rarely, if ever, by IT management.",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      116,
      115,
      123,
      126,
      117
    ],
    "source": "373666_AssessmentTest"
  },
  {
    "id": 2,
    "question": "Which factor most directly influences the organization\u2019s risk appetite?",
    "choice_a": "Number of identified vulnerabilities",
    "choice_b": "Regulatory enforcement activity",
    "choice_c": "Business strategy and objectives",
    "choice_d": "Frequency of control testing",
    "correct_answer": "C",
    "explanation": "Risk appetite is defined by leadership, based on strategic objectives and acceptable risk levels. Risk appetite is not influenced by the number of vulnerabilities or the frequency of control testing. Regulatory enforcement could influence risk appetite, but it is not the best answer.",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      116,
      126,
      115,
      118,
      123
    ],
    "source": "373666_AssessmentTest"
  },
  {
    "id": 3,
    "question": "In threat modeling, what is the primary purpose of identifying threat agents?",
    "choice_a": "Understanding sources and capabilities of threats",
    "choice_b": "Assigning control ownership",
    "choice_c": "Quantifying residual risk",
    "choice_d": "Determining compliance gaps",
    "correct_answer": "A",
    "explanation": "Threat agents are identified to understand their motivations, who or what may exploit vulnerabilities, and how they do so. Identifying threat agents is unrelated to control ownership, residual risk, and compliance gaps.",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      133,
      132,
      142,
      144,
      148
    ],
    "source": "373666_AssessmentTest"
  },
  {
    "id": 4,
    "question": "What is the primary output of a business impact analysis (BIA)?",
    "choice_a": "Risk appetite statement",
    "choice_b": "Control testing results",
    "choice_c": "Threat likelihood estimates",
    "choice_d": "Impact and recovery requirements",
    "correct_answer": "D",
    "explanation": "A BIA identifies the most critical business processes and their dependencies, business impacts, and defines recovery priorities, such as recovery time objectives (RTOs) and recovery point objectives (RPOs). A BIA is unrelated to risk appetite, control testing results, and threat estimates.",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      151,
      138,
      149,
      142,
      154
    ],
    "source": "373666_AssessmentTest"
  },
  {
    "id": 5,
    "question": "Which situation most clearly indicates misalignment between risk appetite and risk tolerance?",
    "choice_a": "Risks exceeding tolerance but approved through formal exceptions",
    "choice_b": "Risks documented in the risk register",
    "choice_c": "Controls mapped to multiple frameworks",
    "choice_d": "KRIs reported quarterly",
    "correct_answer": "A",
    "explanation": "Approving risks beyond tolerance without revisiting appetite indicates governance misalignment. Risks in the risk register, mapped controls, and KRI reporting are normal risk management activities and do not indicate misalignment.",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      126,
      116,
      123,
      125,
      118
    ],
    "source": "373666_AssessmentTest"
  },
  {
    "id": 6,
    "question": "Which activity best validates that risk responses were implemented as approved?",
    "choice_a": "Threat modeling",
    "choice_b": "Risk reassessment",
    "choice_c": "Control testing and monitoring",
    "choice_d": "Policy review",
    "correct_answer": "C",
    "explanation": "Control testing and monitoring confirm that approved risk responses are operating effectively. While essential, threat modeling and policy reviews are unrelated. Risk reassessments may serve as validation, but control testing and monitoring are the preferred methods.",
    "topic_id": 3,
    "practice_test_id": 1,
    "related_articles": [
      179,
      178,
      177,
      186,
      188
    ],
    "source": "373666_AssessmentTest"
  },
  {
    "id": 7,
    "question": "Which reporting method best supports executive-level risk decision-making?",
    "choice_a": "Detailed vulnerability scan reports",
    "choice_b": "Heatmaps and dashboards",
    "choice_c": "Technical configuration baselines",
    "choice_d": "Incident response playbooks",
    "correct_answer": "B",
    "explanation": "Aggregated visual reporting supports timely, risk-based decisions by senior management. Vulnerability scan reports, configuration baselines, and incident response playbooks, while essential, are unrelated to executive-level risk decision-making.",
    "topic_id": 3,
    "practice_test_id": 1,
    "related_articles": [
      183,
      180,
      185,
      184,
      179
    ],
    "source": "373666_AssessmentTest"
  },
  {
    "id": 8,
    "question": "Which principle ensures personnel understand their responsibilities for protecting information assets?",
    "choice_a": "Enterprise architecture",
    "choice_b": "Security awareness training",
    "choice_c": "Data classification",
    "choice_d": "Change management",
    "correct_answer": "B",
    "explanation": "Security awareness training promotes a risk-aware culture by educating personnel on information security responsibilities. Enterprise architecture, data classification, and change management are all essential activities that staff can learn from, but are not as effective as security awareness training.",
    "topic_id": 4,
    "practice_test_id": 1,
    "related_articles": [
      238,
      237,
      239,
      229,
      230
    ],
    "source": "373666_AssessmentTest"
  },
  {
    "id": 9,
    "question": "Which scenario best represents a control deficiency?",
    "choice_a": "A risk with high inherent impact",
    "choice_b": "A policy not formally approved",
    "choice_c": "A control that exists but fails to operate as intended",
    "choice_d": "A threat actor targeting a system",
    "correct_answer": "C",
    "explanation": "Control deficiencies occur when controls are ineffective or not operating as designed. The other choices represent risk but are not necessarily control deficiencies, as there may be no controls in these areas.",
    "topic_id": 3,
    "practice_test_id": 1,
    "related_articles": [
      177,
      172,
      173,
      176,
      179
    ],
    "source": "373666_AssessmentTest"
  },
  {
    "id": 10,
    "question": "What is the primary purpose of assigning risk ownership?",
    "choice_a": "Ensuring audit independence",
    "choice_b": "Establishing accountability for risk decisions",
    "choice_c": "Centralizing control testing",
    "choice_d": "Reducing inherent risk",
    "correct_answer": "B",
    "explanation": "Risk ownership establishes accountability for managing and responding to identified risks. Risk ownership is unrelated to audit independence and control testing and does not influence inherent risk.",
    "topic_id": 3,
    "practice_test_id": 1,
    "related_articles": [
      162,
      181,
      160,
      171,
      175
    ],
    "source": "373666_AssessmentTest"
  },
  {
    "id": 11,
    "question": "Which metric is most appropriate for monitoring changes in risk exposure over time?",
    "choice_a": "KPI",
    "choice_b": "KCI",
    "choice_c": "KRI",
    "choice_d": "SLA",
    "correct_answer": "C",
    "explanation": "Key Risk Indicators (KRIs) are designed to signal changes in risk levels. Key Performance Indicators (KPIs) and Key Control Indicators (KCIs) are essential in risk management but are not well-suited to monitoring changes in risk exposure. Service Level Agreements (SLAs) are not used to monitor changes in risk; they define service response levels.",
    "topic_id": 3,
    "practice_test_id": 1,
    "related_articles": [
      185,
      179,
      184,
      186,
      180
    ],
    "source": "373666_AssessmentTest"
  },
  {
    "id": 12,
    "question": "Which risk response option involves accepting risk without additional mitigation?",
    "choice_a": "Avoid",
    "choice_b": "Mitigate",
    "choice_c": "Transfer",
    "choice_d": "Accept",
    "correct_answer": "D",
    "explanation": "Risk acceptance occurs when management determines that the risk is within its appetite and does not require further action. Risk avoidance involves discontinuing the activity that introduced the risk. Risk mitigation involves changes to processes or systems to reduce risk. Risk transfer involves the process of transferring risk to an external party.",
    "topic_id": 3,
    "practice_test_id": 1,
    "related_articles": [
      160,
      161,
      171,
      181,
      180
    ],
    "source": "373666_AssessmentTest"
  },
  {
    "id": 13,
    "question": "Which control type is intended to identify undesirable events after they occur?",
    "choice_a": "Preventive",
    "choice_b": "Detective",
    "choice_c": "Corrective",
    "choice_d": "Compensating",
    "correct_answer": "B",
    "explanation": "Detective controls identify and report events that have already occurred. Preventive controls are designed to keep unwanted events or conditions from occurring. Corrective and compensating controls are used to correct a condition and compensate for the absence or weakness of another control, respectively.",
    "topic_id": 3,
    "practice_test_id": 1,
    "related_articles": [
      173,
      172,
      177,
      179,
      186
    ],
    "source": "373666_AssessmentTest"
  },
  {
    "id": 14,
    "question": "When evaluating residual risk, which factor is most critical?",
    "choice_a": "Number of implemented controls",
    "choice_b": "Control design intent",
    "choice_c": "Effectiveness of controls in operation",
    "choice_d": "Historical loss data only",
    "correct_answer": "C",
    "explanation": "Residual risk depends on how effectively controls reduce inherent risk in practice. The number of controls and their intent are unrelated. Historic data loss may inform future decisions, but it is not as critical as the effectiveness of controls in operation.",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      152,
      132,
      135,
      134,
      142
    ],
    "source": "373666_AssessmentTest"
  },
  {
    "id": 15,
    "question": "Which IT discipline ensures systems support business requirements throughout their lifecycle?",
    "choice_a": "IT operations management",
    "choice_b": "SDLC",
    "choice_c": "Disaster recovery management",
    "choice_d": "Enterprise architecture",
    "correct_answer": "B",
    "explanation": "The systems (or software) development lifecycle (SDLC) governs system design, development, testing, implementation, and maintenance. IT operations management is essential, but it does not support business requirements throughout a system\u2019s lifecycle. Disaster recovery management and enterprise architecture are generally essential, but they are unrelated.",
    "topic_id": 4,
    "practice_test_id": 1,
    "related_articles": [
      211,
      212,
      216,
      214,
      215
    ],
    "source": "373666_AssessmentTest"
  },
  {
    "id": 16,
    "question": "Which document is primarily used to record identified IT risks and their attributes?",
    "choice_a": "Control matrix",
    "choice_b": "Incident log",
    "choice_c": "Business impact analysis",
    "choice_d": "Risk register",
    "correct_answer": "D",
    "explanation": "The risk register is the authoritative record for documenting risks, including likelihood, impact, ownership, and status. A control matrix is like a heatmap and is used to depict risks visually. An incident log and a business impact analysis (BIA) contain helpful information, but are not used to record IT risks.",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      149,
      150,
      142,
      152,
      138
    ],
    "source": "373666_AssessmentTest"
  },
  {
    "id": 17,
    "question": "Which risk response is MOST appropriate when a third party introduces systemic risk that cannot be fully mitigated internally?",
    "choice_a": "Accept",
    "choice_b": "Avoid",
    "choice_c": "Transfer",
    "choice_d": "Mitigate",
    "correct_answer": "C",
    "explanation": "Risk transfer, such as through contractual terms or insurance, is appropriate for third-party risks that cannot be fully mitigated internally. Accepting risk leaves the systemic risk in place. Avoiding risk is often impractical, as the organization would have to discontinue the activity(ies) that introduced the risk in the first place.",
    "topic_id": 3,
    "practice_test_id": 1,
    "related_articles": [
      160,
      163,
      171,
      181,
      180
    ],
    "source": "373666_AssessmentTest"
  },
  {
    "id": 18,
    "question": "Which condition most strongly justifies escalation of IT risk to enterprise risk management (ERM)?",
    "choice_a": "Risk exceeding business-defined tolerance thresholds",
    "choice_b": "High-likelihood, low-impact technical risk",
    "choice_c": "Lack of documented controls",
    "choice_d": "Frequent operational incidents",
    "correct_answer": "A",
    "explanation": "Risks exceeding tolerance thresholds require enterprise-level visibility and decision-making. The other risks shown are less likely to result in an escalation to ERM.",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      116,
      123,
      126,
      125,
      120
    ],
    "source": "373666_AssessmentTest"
  },
  {
    "id": 19,
    "question": "Which activity best supports management of emerging risk?",
    "choice_a": "Annual compliance audits",
    "choice_b": "Static risk registers",
    "choice_c": "Continuous environmental scanning",
    "choice_d": "Control self-assessments",
    "correct_answer": "C",
    "explanation": "Emerging risks require ongoing monitoring of internal and external environments. Annual compliance audits, static risk registers, and control self-assessments are not designed to identify emerging risks.",
    "topic_id": 3,
    "practice_test_id": 1,
    "related_articles": [
      168,
      179,
      180,
      185,
      166
    ],
    "source": "373666_AssessmentTest"
  },
  {
    "id": 20,
    "question": "What is the primary objective of issue, finding, and exception management?",
    "choice_a": "Eliminating all residual risk",
    "choice_b": "Ensuring deviations are tracked and resolved",
    "choice_c": "Replacing formal risk assessments",
    "choice_d": "Delegating accountability to auditors",
    "correct_answer": "B",
    "explanation": "These processes ensure identified issues and exceptions are documented, tracked, and remediated. Issue, finding, and exception management are essential activities in a risk management program for addressing these matters formally. They do little, if anything, to reduce or eliminate residual risk, and they do not replace formal risk assessments. Risk accountability is rarely, if ever, delegated to auditors.",
    "topic_id": 3,
    "practice_test_id": 1,
    "related_articles": [
      167,
      166,
      162,
      181,
      180
    ],
    "source": "373666_AssessmentTest"
  },
  {
    "id": 21,
    "question": "An organization is subject to healthcare regulations that govern the protection requirements of individual health data. Which of the following describes this type of governance?",
    "choice_a": "External",
    "choice_b": "Internal",
    "choice_c": "Regulatory",
    "choice_d": "Professional",
    "correct_answer": "A",
    "explanation": "Laws and regulations are a form of external governance. They can also be considered as external inputs to an organization\u2019s governance program. Other examples of external inputs include market conditions, customer requirements, and supplier availability. Internal inputs include culture and policy.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      115,
      123,
      128,
      119,
      116
    ],
    "source": "373666_Ch01"
  },
  {
    "id": 22,
    "question": "Your company handles credit card transaction processing as part of its business processes. Which of the following best describes the source and type of governance it may incur because of these business processes?",
    "choice_a": "Internal, policies and procedures",
    "choice_b": "External, industry standards",
    "choice_c": "External, laws and regulations",
    "choice_d": "Internal, industry standards",
    "correct_answer": "B",
    "explanation": "This describes an external source of governance in the form of industry standards, specifically the Payment Card Industry Data Security Standard (PCI DSS).",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      128,
      123,
      115,
      120,
      119
    ],
    "source": "373666_Ch01"
  },
  {
    "id": 23,
    "question": "Your organization is structured into various departments, and each of these has its own activities that support the mission, goals, and objectives of the organization. These activities are composed at a high level and include various tasks to support the various business units. Which of the following best describes these activities?",
    "choice_a": "Operational management",
    "choice_b": "Organizational strategy",
    "choice_c": "Business processes",
    "choice_d": "Risk management functions",
    "correct_answer": "C",
    "explanation": "Business processes are the activities that support the organizational mission and can be broad or broken down into detailed activities and tasks. Business processes often involve direct human activity, although IT automation enables autonomous business processes, such as the online activation of a new email account.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      120,
      116,
      115,
      117,
      119
    ],
    "source": "373666_Ch01"
  },
  {
    "id": 24,
    "question": "An organizational culture that is averse to risk and change is more likely to have which of the following in terms of risk appetite and tolerance?",
    "choice_a": "High risk appetite, low risk tolerance",
    "choice_b": "Low risk appetite, high risk tolerance",
    "choice_c": "Low risk appetite, low risk tolerance",
    "choice_d": "High risk appetite, high risk tolerance",
    "correct_answer": "C",
    "explanation": "A risk-averse organization is likely to have both a low risk appetite and a low risk tolerance. Risk appetite is how much risk an organization is willing to deal with in any given situation, while risk tolerance is the acceptable deviation from risk appetite for a particular matter.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      126,
      118,
      116,
      123,
      125
    ],
    "source": "373666_Ch01"
  },
  {
    "id": 25,
    "question": "Which of the following roles is the lowest level of responsibility in terms of risk ownership for a business process or unit?",
    "choice_a": "Organizational CEO or president",
    "choice_b": "VP for risk management",
    "choice_c": "Risk practitioner",
    "choice_d": "Business process owner",
    "correct_answer": "D",
    "explanation": "Although various levels of organizational management may be responsible and accountable for risk, the lowest level of risk ownership for a business process or unit is the business process owner.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      120,
      117,
      125,
      127,
      116
    ],
    "source": "373666_Ch01"
  },
  {
    "id": 26,
    "question": "Which of the following is the level of variation or deviance an organization is willing to accept for a particular business venture?",
    "choice_a": "Risk appetite",
    "choice_b": "Risk tolerance",
    "choice_c": "Risk acceptance",
    "choice_d": "Risk capacity",
    "correct_answer": "B",
    "explanation": "Risk tolerance is the amount of variation or deviation an organization is willing to accept from its risk appetite that a particular business venture may incur. Risk appetite is the amount of risk an organization is willing to undertake. Risk capacity is the amount of loss that an organization can incur while being able to continue operations. Risk acceptance is one of four risk treatment options (the others being mitigate, transfer, and avoid).",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      126,
      116,
      123,
      124,
      125
    ],
    "source": "373666_Ch01"
  },
  {
    "id": 27,
    "question": "A small business unit in the production department is incurring risk for one of its lower-level business processes. Although this risk is focused on the business process and not at the organizational level, it must be accounted for in the overall organizational risk assessment. At what level should this risk be considered?",
    "choice_a": "Organizational risk",
    "choice_b": "Operational risk",
    "choice_c": "Strategic risk",
    "choice_d": "Tactical risk",
    "correct_answer": "D",
    "explanation": "Tactical risks are those encountered by smaller production sections\u2014those that carry out the day-to-day work of the organization. A lower-level business process may be considered to have a tactical risk. Strategic and organizational risks are broad and may affect multiple departments or business units. Operational risks are related to ongoing, internal business operations.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      117,
      120,
      123,
      124,
      126
    ],
    "source": "373666_Ch01"
  },
  {
    "id": 28,
    "question": "An organization needs to establish its internal risk management program, which begins with risk governance. Which of the following should the organization create first?",
    "choice_a": "Risk strategy",
    "choice_b": "Risk management policy",
    "choice_c": "Risk assessment procedure",
    "choice_d": "Risk management methodology",
    "correct_answer": "A",
    "explanation": "The risk strategy for the organization should be created first because it provides long-term direction for the risk management program. The risk management strategy also supports external governance. Policies and procedures are subsequently created to support the strategy and implement external governance.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      116,
      123,
      119,
      115,
      126
    ],
    "source": "373666_Ch01"
  },
  {
    "id": 29,
    "question": "Which of the following describes why the organization exists?",
    "choice_a": "Organizational mission statement",
    "choice_b": "Organizational strategy",
    "choice_c": "External governance",
    "choice_d": "Organizational policy",
    "correct_answer": "A",
    "explanation": "The organization develops an organizational mission statement to describe its overall purpose, which is its primary reason for existence.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      116,
      115,
      123,
      120,
      118
    ],
    "source": "373666_Ch01"
  },
  {
    "id": 30,
    "question": "Which of the following activities is considered foundational, without which other management activities, such as vulnerability management, incident management, and data security, could not be accomplished?",
    "choice_a": "Configuration management",
    "choice_b": "Risk management",
    "choice_c": "Asset management",
    "choice_d": "Financial management",
    "correct_answer": "C",
    "explanation": "Asset management is one of the foundational activities on which other activities depend (vulnerability management, configuration management, and so on) because assets must be inventoried and accounted for first.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      121,
      122,
      120,
      124,
      127
    ],
    "source": "373666_Ch01"
  },
  {
    "id": 31,
    "question": "A corporate policy document has a statement that reads, \u201cFor critical business processes, the organization permits no more than a low residual risk level, defined as maintaining system availability above 99.5%, preventing any unauthorized access events, and resolving identified high-severity vulnerabilities within 15 days.\u201d What type of statement is this?",
    "choice_a": "Risk culture statement",
    "choice_b": "Risk capacity statement",
    "choice_c": "Risk tolerance statement",
    "choice_d": "Risk appetite statement",
    "correct_answer": "C",
    "explanation": "A typical risk tolerance statement describes context-specific parameters that represent thresholds that would trigger escalations if exceeded.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      126,
      116,
      119,
      127,
      123
    ],
    "source": "373666_Ch01"
  },
  {
    "id": 32,
    "question": "Which of the following requires that a risk practitioner perform duties professionally, with due diligence and care, as required by professional standards?",
    "choice_a": "Risk IT Framework",
    "choice_b": "NIST Risk Management Framework",
    "choice_c": "ISACA Code of Professional Ethics",
    "choice_d": "Laws and regulations",
    "correct_answer": "C",
    "explanation": "The ISACA Code of Professional Ethics establishes requirements for ethical conduct and behavior that all certified professionals must adhere to, including the requirement to perform all duties professionally, with due diligence and care, as required by professional standards.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      129,
      128,
      118,
      119,
      123
    ],
    "source": "373666_Ch01"
  },
  {
    "id": 33,
    "question": "A risk manager is analyzing a risk item and has determined that the organization may not survive if the risk is realized. Which of the following must the risk manager consider to make this determination?",
    "choice_a": "Risk awareness",
    "choice_b": "Risk capacity",
    "choice_c": "Risk tolerance",
    "choice_d": "Risk appetite",
    "correct_answer": "B",
    "explanation": "Risk capacity refers to the amount of loss an organization can incur without jeopardizing its ongoing operations.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      126,
      116,
      123,
      124,
      120
    ],
    "source": "373666_Ch01"
  },
  {
    "id": 34,
    "question": "The organization\u2019s legal counsel is considering the prospect of real estate prices, including office space leasing costs, increasing significantly in the next five years. What level of risk management should be used to manage this risk?",
    "choice_a": "Asset",
    "choice_b": "ERM",
    "choice_c": "Program",
    "choice_d": "Market",
    "correct_answer": "B",
    "explanation": "A risk matter, such as macroeconomic risk, is generally managed by an organization\u2019s enterprise risk management (ERM) program.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      123,
      124,
      116,
      125,
      127
    ],
    "source": "373666_Ch01"
  },
  {
    "id": 35,
    "question": "All of the following are factors that influence an organization\u2019s culture, except:",
    "choice_a": "Published values",
    "choice_b": "Policies",
    "choice_c": "Leadership behavior",
    "choice_d": "Behavioral norms",
    "correct_answer": "B",
    "explanation": "Of the available choices, an organization\u2019s policies are the least likely to influence an organization\u2019s culture.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      118,
      116,
      117,
      115,
      126
    ],
    "source": "373666_Ch01"
  },
  {
    "id": 36,
    "question": "Which of the following types of organizations is most likely to have a high risk appetite and a high risk tolerance?",
    "choice_a": "Insurance company",
    "choice_b": "Adult beverage producer",
    "choice_c": "Computer manufacturer",
    "choice_d": "AI agent software developer",
    "correct_answer": "D",
    "explanation": "Of the available choices, the AI agent software developer is most likely to have a high risk appetite and high risk tolerance. The other organizations have more regulations and market reputation to consider, which reduces their risk appetite and tolerance.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      126,
      116,
      118,
      123,
      128
    ],
    "source": "373666_Ch01"
  },
  {
    "id": 37,
    "question": "How frequently should an organization review its cybersecurity policies?",
    "choice_a": "Annually",
    "choice_b": "Monthly",
    "choice_c": "Whenever a breach occurs",
    "choice_d": "Every five years",
    "correct_answer": "A",
    "explanation": "The best practice for reviewing policies, including cybersecurity policies, is annually. Organizations should also review their policies when relevant regulations or technologies change, or when business conditions change.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      119,
      123,
      124,
      128,
      115
    ],
    "source": "373666_Ch01"
  },
  {
    "id": 38,
    "question": "A new cybersecurity leader is assessing an organization\u2019s risk governance documents and records and has been unable to find any written statements on risk appetite and risk tolerance. How can historic risk appetite and risk tolerance be identified in such a case?",
    "choice_a": "Interview business leaders",
    "choice_b": "Examine incident management records",
    "choice_c": "Examine risk treatment records",
    "choice_d": "Review recent penetration test results",
    "correct_answer": "C",
    "explanation": "In the absence of a formal, written risk appetite and risk tolerance, the best way to discern historic risk appetite and tolerance is to review the past few years\u2019 worth of risk treatment records. This will help the cyber leader better understand what management was willing to accept, versus what management required be mitigated, transferred, or avoided.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      126,
      116,
      120,
      123,
      127
    ],
    "source": "373666_Ch01"
  },
  {
    "id": 39,
    "question": "All of the following are risk management frameworks, except:",
    "choice_a": "NIST SP 800-37",
    "choice_b": "NIST SP 800-53",
    "choice_c": "COSO ERM",
    "choice_d": "ISO 31000",
    "correct_answer": "B",
    "explanation": "NIST SP 800-53 is a controls framework for U.S. government agencies and contractor organizations. The others are risk management frameworks.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      124,
      115,
      123,
      125,
      126
    ],
    "source": "373666_Ch01"
  },
  {
    "id": 40,
    "question": "A cybersecurity consultant has observed an organization where its cybersecurity department enacts policies and controls, corporate IT implements these controls, and internal audit assesses the effectiveness of these controls. Which model has the consultant observed?",
    "choice_a": "Deming cycle",
    "choice_b": "Enterprise risk management",
    "choice_c": "Systems development lifecycle",
    "choice_d": "Three lines model",
    "correct_answer": "D",
    "explanation": "The consultant observed the three lines model, also known as the three lines of defense model, in which key responsibilities are divided among three departments in a checks-and-balances model. The Deming Cycle is a lifecycle process. Enterprise risk management is those procedures and records concerning organization-wide risks of all types. The systems development lifecycle is a set of processes to implement a new system.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      125,
      117,
      119,
      123,
      124
    ],
    "source": "373666_Ch01"
  },
  {
    "id": 41,
    "question": "An organization experiences a brief system outage that does not exceed established impact thresholds and requires no escalation. How should this occurrence be classified for risk management purposes?",
    "choice_a": "A near miss with no relevance to risk analysis",
    "choice_b": "A vulnerability discovery",
    "choice_c": "A low-impact risk event",
    "choice_d": "A control deficiency",
    "correct_answer": "C",
    "explanation": "Even when impact thresholds are not exceeded, the occurrence of an outage constitutes a realized risk event, albeit with low impact, and should be considered in ongoing risk analysis and trend evaluation.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      139,
      142,
      149,
      152,
      137
    ],
    "source": "373666_Ch02"
  },
  {
    "id": 42,
    "question": "Which example best illustrates a risk event rather than a threat or vulnerability?",
    "choice_a": "Phishing emails targeting employees",
    "choice_b": "Lack of multifactor authentication on remote access",
    "choice_c": "Unauthorized access to customer data through compromised credentials",
    "choice_d": "Absence of a formal access control policy",
    "correct_answer": "C",
    "explanation": "Unauthorized access to customer data represents the realized outcome of a threat exploiting a vulnerability, making it a risk event rather than a threat condition or control weakness. The other choices are vulnerabilities or threats.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      132,
      139,
      133,
      134,
      152
    ],
    "source": "373666_Ch02"
  },
  {
    "id": 43,
    "question": "What is the maximum period of time that risk items should reside in a risk register?",
    "choice_a": "One year",
    "choice_b": "Seven years",
    "choice_c": "Until the risk is accepted",
    "choice_d": "Indefinitely",
    "correct_answer": "D",
    "explanation": "Individual risk register items should remain in the risk register for as long as the risk they describe continues to exist\u2014indefinitely, even.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      149,
      150,
      152,
      157,
      138
    ],
    "source": "373666_Ch02"
  },
  {
    "id": 44,
    "question": "A risk manager reviewing a business process has identified a control gap. What steps should the risk manager take to determine the best course of action?",
    "choice_a": "Perform a risk analysis to determine the magnitude of the risk.",
    "choice_b": "Determine whether the control gap represents a significant risk.",
    "choice_c": "See whether a risk already exists in the risk register.",
    "choice_d": "Create an entry in the security incident log.",
    "correct_answer": "A",
    "explanation": "When a control gap is identified, the best first step is to perform a risk analysis to determine what risks (including compliance risk) exist that warrant consideration and action.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      134,
      142,
      135,
      152,
      149
    ],
    "source": "373666_Ch02"
  },
  {
    "id": 45,
    "question": "A security professional is performing a test with fuzzers and protocol analyzers. What is the most likely target of this test?",
    "choice_a": "Application vulnerability analysis",
    "choice_b": "Firewall rules review",
    "choice_c": "Data discovery",
    "choice_d": "Threat modeling",
    "correct_answer": "A",
    "explanation": "Fuzzers are most often used in an application vulnerability analysis. The role of a fuzzer is to present numerous inputs to input fields to determine whether the application is vulnerable to malicious inputs.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      134,
      143,
      135,
      132,
      144
    ],
    "source": "373666_Ch02"
  },
  {
    "id": 46,
    "question": "What is the primary purpose of risk scenario development?",
    "choice_a": "To identify the highest-rated risks",
    "choice_b": "To quantify the highest-rated risks",
    "choice_c": "To prepare an executive briefing",
    "choice_d": "To associate risks with business objectives",
    "correct_answer": "D",
    "explanation": "Risk scenario development is performed to associate specific risks with specific business objectives or business activities. Risk scenario development makes risks more tangible by describing their potential impact on the organization in business terms.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      138,
      142,
      151,
      149,
      139
    ],
    "source": "373666_Ch02"
  },
  {
    "id": 47,
    "question": "A risk manager seeks to gain a deeper understanding of the specific factors within particular business processes that could lead to an incident. What artifact would inform the risk manager of the urgency to perform this analysis?",
    "choice_a": "Risk appetite",
    "choice_b": "Privacy policy",
    "choice_c": "Business impact analysis",
    "choice_d": "Risk register",
    "correct_answer": "C",
    "explanation": "A business impact analysis (BIA) is used to determine the relative criticality of each business process in the organization. If the BIA determines that any particular business process is critical, this will signal that the business process warrants additional attention.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      151,
      142,
      148,
      137,
      154
    ],
    "source": "373666_Ch02"
  },
  {
    "id": 48,
    "question": "Hackers, cybercriminal organizations, disgruntled employees, and hurricanes are known as what?",
    "choice_a": "Threat agents",
    "choice_b": "Threat events",
    "choice_c": "Threats",
    "choice_d": "Attacks",
    "correct_answer": "A",
    "explanation": "Threat agents are the entities, human or not, that may perform actions that could cause harm to an organization, its processes, or its systems.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      132,
      133,
      142,
      144,
      148
    ],
    "source": "373666_Ch02"
  },
  {
    "id": 49,
    "question": "A risk manager is considering using an industry standard for performing risk assessments. Which of the following should the risk manager NOT consider?",
    "choice_a": "NIST RMF",
    "choice_b": "NIST SP 800-30",
    "choice_c": "OCTAVE",
    "choice_d": "IEC 31010",
    "correct_answer": "A",
    "explanation": "NIST RMF is a framework for overall risk management, but not for risk assessments. NIST SP 800-30, OCTAVE, and IEC 31010 are all risk assessment standards that warrant consideration.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      144,
      145,
      142,
      143,
      153
    ],
    "source": "373666_Ch02"
  },
  {
    "id": 50,
    "question": "What does NIST Special Publication 800-30 describe?",
    "choice_a": "A risk management methodology",
    "choice_b": "A risk assessment methodology",
    "choice_c": "Security and privacy controls",
    "choice_d": "Audit procedures for security and privacy controls",
    "correct_answer": "B",
    "explanation": "NIST SP 800-30, \u201cGuide for Conducting Risk Assessments,\u201d is a step-by-step guide to performing qualitative and quantitative risk assessments. The standard also briefly describes the overall risk management lifecycle process to provide context for individual risk assessments.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      144,
      142,
      143,
      153,
      145
    ],
    "source": "373666_Ch02"
  },
  {
    "id": 51,
    "question": "Why is it important to assess vulnerabilities and control deficiencies together?",
    "choice_a": "To eliminate the need for threat modeling",
    "choice_b": "To ensure all vulnerabilities are immediately remediated",
    "choice_c": "To understand how weaknesses affect risk exposure in context",
    "choice_d": "To prioritize technical controls over administrative controls",
    "correct_answer": "C",
    "explanation": "Assessing vulnerabilities and control deficiencies together provides context for how weaknesses interact with existing controls and influence overall risk exposure.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      134,
      135,
      152,
      142,
      148
    ],
    "source": "373666_Ch02"
  },
  {
    "id": 52,
    "question": "Which of the following is the best description of a risk register?",
    "choice_a": "A list of threat agents and threat actors",
    "choice_b": "A list of identified risks",
    "choice_c": "The root cause analysis (RCA) for a security incident",
    "choice_d": "A list of likely risk scenarios",
    "correct_answer": "B",
    "explanation": "A risk register is a master list of all credible risks that have been identified and are awaiting further analysis, treatment, or follow-up.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      149,
      150,
      132,
      142,
      138
    ],
    "source": "373666_Ch02"
  },
  {
    "id": 53,
    "question": "A risk manager performs risk analysis on a specific risk to better understand it and identify potential remedies. Various aspects of the initial risk and its potential remedies are scored on a scale of 1\u201310. What type of risk analysis is being performed?",
    "choice_a": "Qualitative risk analysis",
    "choice_b": "Quantitative risk analysis",
    "choice_c": "Semi-quantitative risk analysis",
    "choice_d": "Factor Analysis of Information Risk (FAIR)",
    "correct_answer": "C",
    "explanation": "Semi-quantitative risk analysis employs a scoring scheme, such as a simple numeric scale ranging from 1 to 3, 1 to 5, or 1 to 10.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      147,
      142,
      146,
      148,
      143
    ],
    "source": "373666_Ch02"
  },
  {
    "id": 54,
    "question": "An organization has performed a risk analysis of a complex scenario. Two different mitigation strategies have been approved that will reduce the original risk to a much lower level. The risk that remains after these mitigation strategies have been completed is known as what?",
    "choice_a": "Inherent risk",
    "choice_b": "Leftover risk",
    "choice_c": "Residual risk",
    "choice_d": "Accepted risk",
    "correct_answer": "C",
    "explanation": "Residual risk is the risk that remains after risk treatment (whether mitigation, transfer, or avoidance) has been completed.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      152,
      132,
      142,
      138,
      149
    ],
    "source": "373666_Ch02"
  },
  {
    "id": 55,
    "question": "Which of the following is the best method for managing residual risk?",
    "choice_a": "Subject it to risk analysis and risk treatment.",
    "choice_b": "Retain it on the risk register and consider it as accepted.",
    "choice_c": "Retain it on the risk register and label it as closed.",
    "choice_d": "Add it to the cumulative total of risk tolerance.",
    "correct_answer": "A",
    "explanation": "The best way to manage residual risk is to include it in the risk register and then subject it to the usual risk analysis, risk scenario development, and risk treatment.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      152,
      149,
      138,
      142,
      147
    ],
    "source": "373666_Ch02"
  },
  {
    "id": 56,
    "question": "Which activity best supports risk identification rather than risk analysis?",
    "choice_a": "Estimating loss expectancy using quantitative data",
    "choice_b": "Evaluating control effectiveness",
    "choice_c": "Discovering potential threat actors and vulnerabilities",
    "choice_d": "Assigning risk scores in a risk matrix",
    "correct_answer": "C",
    "explanation": "Risk identification focuses on finding threats, vulnerabilities, and assets that could lead to loss events. Analysis and evaluation follow to determine the likelihood, impact, and overall risk level.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      131,
      140,
      130,
      133,
      142
    ],
    "source": "373666_Ch02"
  },
  {
    "id": 57,
    "question": "In a semi-quantitative risk analysis, a risk manager assigns 4 = Likely for likelihood and 5 = Severe for impact, producing a risk score of 20. What is the primary advantage of this approach?",
    "choice_a": "It eliminates the need for expert judgment.",
    "choice_b": "It allows consistent ranking of risks without requiring precise financial data.",
    "choice_c": "It converts qualitative data directly into monetary loss.",
    "choice_d": "It ensures that results are statistically valid.",
    "correct_answer": "B",
    "explanation": "Semi-quantitative analysis bridges the gap between qualitative and quantitative methods by using numeric scales to consistently prioritize risks, without having to rely on detailed financial or statistical models.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      147,
      142,
      146,
      144,
      145
    ],
    "source": "373666_Ch02"
  },
  {
    "id": 58,
    "question": "What is the main purpose of a business impact analysis (BIA) within the IT risk assessment process?",
    "choice_a": "To calculate quantitative loss expectancy",
    "choice_b": "To identify critical business processes and the consequences of their disruption",
    "choice_c": "To assign risk ownership across business units",
    "choice_d": "To verify the effectiveness of existing controls",
    "correct_answer": "B",
    "explanation": "A BIA identifies essential processes, resources, interdependencies, and the potential business impacts of downtime, helping prioritize systems and processes for protection and recovery planning.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      151,
      142,
      154,
      138,
      149
    ],
    "source": "373666_Ch02"
  },
  {
    "id": 59,
    "question": "Which change most directly indicates a shift in an organization\u2019s threat landscape?",
    "choice_a": "Implementation of a new security awareness program.",
    "choice_b": "Emergence of new attacker techniques targeting the organization\u2019s industry.",
    "choice_c": "Completion of an internal control self-assessment.",
    "choice_d": "Adoption of a new enterprise risk management framework.",
    "correct_answer": "B",
    "explanation": "The threat landscape reflects the external and internal threat environment; changes in attacker capabilities, techniques, or targeting patterns directly alter the organization\u2019s threat landscape.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      133,
      132,
      150,
      142,
      144
    ],
    "source": "373666_Ch02"
  },
  {
    "id": 60,
    "question": "Which of the following best describes the purpose of threat modeling in an IT risk assessment?",
    "choice_a": "To simulate the financial impact of business disruptions",
    "choice_b": "To map potential attack paths and identify exploitable vulnerabilities in systems or processes",
    "choice_c": "To test system controls through active exploitation",
    "choice_d": "To document business impact and recovery objectives",
    "correct_answer": "B",
    "explanation": "Threat modeling systematically examines potential threat actors, attack vectors, and vulnerabilities to anticipate how an attack could occur and the potential damage that could result. It is a core risk identification technique preceding vulnerability testing and risk analysis.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      133,
      132,
      142,
      143,
      144
    ],
    "source": "373666_Ch02"
  },
  {
    "id": 61,
    "question": "You are the business process owner for your company\u2019s manufacturing department. A risk assessment identifies several data protection risks that could materially affect production operations. Mitigating controls are designed and operated by both the IT security and physical security functions, with performance metrics reported back to the business. Residual risk acceptance authority remains with the business. Which of the following most accurately describes risk and control ownership in this scenario?",
    "choice_a": "You are the risk owner, while IT and physical security are the control owners.",
    "choice_b": "You are the risk owner, and executive management is the control owner due to enterprise governance.",
    "choice_c": "IT and physical security own the risks because they design and operate the controls.",
    "choice_d": "Executive management owns the risks, while you and the security functions share control ownership.",
    "correct_answer": "A",
    "explanation": "As the business process owner, you are accountable for the risks affecting the manufacturing process and for accepting residual risk. IT security and physical security functions design, implement, and operate controls, making them the control owners. Ownership is not determined by who implements safeguards, but by accountability for risk outcomes.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      162,
      161,
      181,
      172,
      179
    ],
    "source": "373666_Ch03"
  },
  {
    "id": 62,
    "question": "As a risk practitioner in a larger organization, you are reviewing risk response options for a risk affecting a mission-critical business process. All feasible and cost-justified controls have been implemented, yet a measurable level of residual risk remains. The risk cannot be transferred to a third party, and discontinuing or materially altering the process would be unacceptable to the business. Executive management must determine the appropriate next action. Which risk response option is MOST appropriate in this situation?",
    "choice_a": "Risk avoidance by redesigning the business process",
    "choice_b": "Risk mitigation through the implementation of additional controls",
    "choice_c": "Risk acceptance with formal approval of residual risk",
    "choice_d": "Risk sharing through contractual or insurance mechanisms",
    "correct_answer": "C",
    "explanation": "When a risk affects a critical business process, cannot be transferred, and all reasonable mitigation measures have already been applied, the remaining exposure is residual risk. In this case, the appropriate response is formal risk acceptance by authorized management, supported by documentation and ongoing monitoring.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      161,
      160,
      171,
      181,
      179
    ],
    "source": "373666_Ch03"
  },
  {
    "id": 63,
    "question": "Your company has just established a contract with a third-party cloud services provider. Based on the contract language, in the event of a breach, the provider must disclose details of the event as well as allow an audit of the security controls that should have protected any data disclosed during the breach. The contract language, as well as laws and regulations, also stipulate that the third-party provider retains some legal liability for the loss. Which of the following accurately describes the responsibility and accountability borne by both your organization and the third-party provider during this event?",
    "choice_a": "All the responsibility and accountability are placed on the third-party provider.",
    "choice_b": "All of the responsibility and accountability are placed on the organization.",
    "choice_c": "The third-party provider is responsible for protecting the data, but the organization retains accountability.",
    "choice_d": "Both the third-party provider and the organization bear responsibility and accountability for the loss of the data, as well as legal liability.",
    "correct_answer": "D",
    "explanation": "Both the third-party provider and the organization bear some level of responsibility, accountability, and legal liability for the data loss, as the contract language and laws address this situation. However, it is likely that the organization will ultimately bear the most responsibility and accountability for the data loss to its customers.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      163,
      165,
      162,
      181,
      180
    ],
    "source": "373666_Ch03"
  },
  {
    "id": 64,
    "question": "An organization is integrating an emerging technology into its existing IT environment to support a critical business initiative. During planning, management identifies uncertainty related to how the new technology will interact with legacy systems, data flows, and existing controls. Which risk factor represents the MOST significant concern in this scenario?",
    "choice_a": "Adequacy of existing security mechanisms supporting the new technology",
    "choice_b": "Compatibility of data formats between legacy and new systems",
    "choice_c": "Long-term vendor support of the emerging technology",
    "choice_d": "Ability of the new technology to interoperate with existing systems and processes",
    "correct_answer": "D",
    "explanation": "For emerging technologies, interoperability is a primary risk because incompatibilities with legacy systems, interfaces, or control environments can disrupt operations, weaken controls, and introduce unanticipated risks. This uncertainty is a defining characteristic of emerging risk.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      168,
      178,
      166,
      171,
      181
    ],
    "source": "373666_Ch03"
  },
  {
    "id": 65,
    "question": "During control testing, a vulnerability scan identifies weaknesses that would normally require patching. However, testing confirms that applying the patches would disrupt several mission-critical line-of-business applications. The vulnerabilities cannot be immediately remediated without significant operational impact. What is the MOST appropriate next step?",
    "choice_a": "Proceed with patching and require business process owners to address any resulting application issues.",
    "choice_b": "Defer patching indefinitely because the affected applications are critical to business operations.",
    "choice_c": "Remove the affected systems from the vulnerability management program until replacement systems are implemented.",
    "choice_d": "Evaluate the residual risk, identify possible compensating controls, and obtain formal management approval for any control exceptions.",
    "correct_answer": "D",
    "explanation": "You should evaluate the risk of patching systems and suffering the impact to the line-of-business applications versus the security risk if the systems are not patched, and then allow management to decide based on that risk. Any exceptions should be formally approved and documented. You cannot simply ignore the risk. Taking any action without carefully considering it would be detrimental to the organization, whether it is choosing to break line-of-business applications or ignoring the security ramifications of the problem.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      161,
      171,
      166,
      167,
      181
    ],
    "source": "373666_Ch03"
  },
  {
    "id": 66,
    "question": "Your company has implemented several new controls to strengthen security inside its information processing facility. These controls include stronger steel doors with new cipher locks and two additional guard stations to block unauthorized personnel from entering sensitive areas. Which of the following types and functions would those new controls be considered?",
    "choice_a": "Physical, detective",
    "choice_b": "Physical, preventive",
    "choice_c": "Administrative, preventive",
    "choice_d": "Administrative, deterrent",
    "correct_answer": "B",
    "explanation": "The controls are physical because they use physical barriers to secure the facility\u2019s interior. The controls are also preventive because they prevent unauthorized entry into sensitive, restricted areas. The controls are not administrative because they do not involve written policy or procedures established by management.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      172,
      173,
      176,
      177,
      178
    ],
    "source": "373666_Ch03"
  },
  {
    "id": 67,
    "question": "Your company is now doing business internationally, and as a result, one of its key business partners overseas requires that it adopt international security standards. You examine several standards and are already using internally developed controls that may be mapped to a new standard. Which of the following control standards is the most appropriate to use when working with international partners?",
    "choice_a": "NIST SP 800-53",
    "choice_b": "CIS controls",
    "choice_c": "ISO/IEC 27001/27002",
    "choice_d": "SOC 2 controls",
    "correct_answer": "C",
    "explanation": "ISO/IEC 27001 and 27002 are international standards developed to ensure interoperability and translation of security controls across international boundaries. The other control sets, while they may be used in areas outside the United States, are unique to the United States.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      174,
      178,
      168,
      163,
      176
    ],
    "source": "373666_Ch03"
  },
  {
    "id": 68,
    "question": "An organization is implementing a new system that processes highly sensitive data. Existing security controls partially address protection requirements, but additional network security devices are being considered to meet heightened data sensitivity obligations under applicable laws and regulations. The organization must ensure that the selected controls both satisfy regulatory requirements and function effectively within the current environment. Which factor is MOST critical when selecting the new security controls?",
    "choice_a": "Cost of the new security devices relative to the existing control environment",
    "choice_b": "Ability of the controls to meet regulatory protection requirements",
    "choice_c": "Degree to which the controls reduce overall enterprise risk",
    "choice_d": "Compatibility of the controls with existing network architecture",
    "correct_answer": "B",
    "explanation": "When laws or regulations impose specific protection obligations for sensitive systems or data, those requirements establish a non-negotiable baseline for control design and selection. Controls that do not meet regulatory protection requirements are unacceptable, regardless of their cost efficiency, interoperability, or overall risk reduction benefits. Therefore, the primary consideration in selecting new security controls is their ability to satisfy applicable regulatory obligations.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      176,
      174,
      171,
      178,
      166
    ],
    "source": "373666_Ch03"
  },
  {
    "id": 69,
    "question": "A new network security device is deployed in parallel with existing infrastructure. Testing confirms that the device meets governance requirements and significantly reduces external attack risk. While most systems function as expected, several legacy and third-party systems experience intermittent connectivity failures when traffic is routed through the device. Which issue should be evaluated first?",
    "choice_a": "Interoperability between the new security device and existing systems",
    "choice_b": "Strength of authentication mechanisms enforced by the device",
    "choice_c": "Adequacy of encryption algorithms supported by the device",
    "choice_d": "Completeness of network protocol hardening configurations",
    "correct_answer": "A",
    "explanation": "Selective connectivity failures affecting only certain systems\u2014particularly legacy or third-party platforms\u2014are most commonly caused by interoperability issues. These can include incompatibilities in protocol handling, interface standards, traffic inspection methods, or unsupported features. Interoperability directly affects a control\u2019s ability to function effectively within an existing environment, even when governance, compliance, and risk-reduction objectives are met.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      178,
      168,
      166,
      177,
      176
    ],
    "source": "373666_Ch03"
  },
  {
    "id": 70,
    "question": "Your organization is preparing to implement many new security controls, including upgrading legacy network security devices. While a thorough risk analysis has been conducted, there remains uncertainty about how network devices will interact with the rest of the infrastructure. Management is concerned with interoperability issues and the ability to monitor the installation carefully. Which of the following will help the implementation go smoothly?",
    "choice_a": "Vulnerability assessment prior to installation",
    "choice_b": "Parallel cutover",
    "choice_c": "Risk analysis",
    "choice_d": "Change and configuration management processes",
    "correct_answer": "D",
    "explanation": "Proper change and configuration management processes will assist in an orderly implementation and change to the new network security devices. Management can carefully consider, test, and monitor infrastructure changes, as well as back out changes according to defined processes if something goes wrong.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      166,
      178,
      176,
      181,
      180
    ],
    "source": "373666_Ch03"
  },
  {
    "id": 71,
    "question": "You are preparing an annual risk and control effectiveness report for the board of directors using data collected from multiple internal and external sources. To ensure the report supports effective governance and decision-making, certain data characteristics must be evaluated before aggregation and presentation. Which characteristic is LEAST relevant in assessing the suitability of data for inclusion in the report?",
    "choice_a": "Completeness of data across all in-scope risk areas",
    "choice_b": "Accuracy of data obtained from source systems",
    "choice_c": "Reliability of data sources used in the analysis",
    "choice_d": "Level of technical detail contained within the data",
    "correct_answer": "D",
    "explanation": "Completeness, accuracy, and reliability directly affect the integrity and credibility of risk and control reporting. The level of technical detail, however, is a presentation concern, not a data suitability concern. Technical complexity can be managed during summarization and reporting without compromising data quality.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      182,
      180,
      183,
      177,
      178
    ],
    "source": "373666_Ch03"
  },
  {
    "id": 72,
    "question": "You are creating a schedule for risk reporting for various managers and events. Which of the following strategies should you employ regarding the reporting of risk treatment options and plans?",
    "choice_a": "Report on their progress periodically and as needed.",
    "choice_b": "Report annually to senior management and quarterly to middle management.",
    "choice_c": "Report results only when the risk treatment options have been implemented and are complete.",
    "choice_d": "Do not report on risk treatment options; report only on increases or decreases in risk, as required by governance.",
    "correct_answer": "A",
    "explanation": "You should report the progress of risk treatment options both periodically, as determined by organizational policy, and as needed, depending on the criticality or importance of the information and the desires of management.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      180,
      181,
      183,
      184,
      185
    ],
    "source": "373666_Ch03"
  },
  {
    "id": 73,
    "question": "An organization identifies a significant operational risk related to a core business process supported by IT controls. The risk owner and control owner are assigned to different roles within the organization. Which responsibility is MOST appropriately assigned to the control owner?",
    "choice_a": "Determining the organization\u2019s risk appetite for the process",
    "choice_b": "Accepting residual risk after control implementation",
    "choice_c": "Ensuring controls are designed, implemented, and operating effectively",
    "choice_d": "Prioritizing risks across the enterprise risk register",
    "correct_answer": "C",
    "explanation": "The control owner is responsible for the design, implementation, and ongoing operation of controls that mitigate identified risks. This includes maintaining control effectiveness and addressing control deficiencies.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      162,
      181,
      175,
      177,
      178
    ],
    "source": "373666_Ch03"
  },
  {
    "id": 74,
    "question": "An organization wants to improve management visibility into changes in overall control effectiveness and risk posture. The reporting approach must support timely awareness of significant changes, present information at an appropriate level for management decision-making, and allow access to more detailed underlying metrics when necessary. Which reporting technique BEST meets these requirements?",
    "choice_a": "Heat map summarizing inherent and residual risk levels by risk category",
    "choice_b": "Narrative report distributed periodically to executive management",
    "choice_c": "Centralized dashboard aggregating key risk and control indicators",
    "choice_d": "Scorecard measuring performance against pre-defined targets over time",
    "correct_answer": "C",
    "explanation": "A centralized dashboard supports effective risk and control reporting by aggregating key risk indicators (KRIs) and key control indicators (KCIs) into a single, continuously updated view for management. Dashboards are designed to highlight material changes in risk posture and control effectiveness, enabling timely decision-making without overwhelming executives with unnecessary detail. Unlike heat maps or scorecards, dashboards allow users to drill down into underlying metrics and source data as needed, while maintaining a high-level, management-focused perspective. This combination of timeliness, aggregation, and selective detail makes a centralized dashboard the most appropriate reporting technique in this scenario.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      183,
      179,
      180,
      185,
      186
    ],
    "source": "373666_Ch03"
  },
  {
    "id": 75,
    "question": "You are developing metrics for senior management on control effectiveness and the organization\u2019s risk posture. You need to create a metric that shows managers how the potential risk has been reduced by implementing several new controls over the past six months. You want to aggregate this measurement into one indicator. Which of the following would be the MOST effective indicator to show this reduction?",
    "choice_a": "Key performance indicator",
    "choice_b": "Key risk indicator",
    "choice_c": "Key management indicator",
    "choice_d": "Key control indicator",
    "correct_answer": "B",
    "explanation": "In this scenario, a key risk indicator (KRI) could be developed to show the risk reduction. A key performance indicator (KPI) would measure the performance of a control or other aspect of organizational security, not necessarily the risk reduction. A key control indicator (KCI) would show the effectiveness of a particular control, not the risk reduction. Key management indicators are published by executive management and cover various metrics they are concerned with regarding the overall performance of organizational objectives. They do not indicate a risk reduction.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      185,
      179,
      184,
      186,
      183
    ],
    "source": "373666_Ch03"
  },
  {
    "id": 76,
    "question": "An organization is reviewing its control environment after identifying multiple controls that provide overlapping protection with limited additional risk reduction. Management wants to reduce complexity and cost while ensuring continued compliance and effective risk mitigation. Which is the most appropriate first step in a control rationalization initiative?",
    "choice_a": "Eliminate redundant controls to reduce operational overhead",
    "choice_b": "Map existing controls to risk scenarios, control objectives, and regulatory requirements",
    "choice_c": "Replace redundant controls with alternative compensating controls",
    "choice_d": "Conduct penetration testing to determine which controls provide the strongest protection",
    "correct_answer": "B",
    "explanation": "Control rationalization begins with a structured analysis that maps existing controls to defined risk scenarios, control objectives, and applicable regulatory or framework requirements. This analysis establishes whether controls are necessary, duplicative, or misaligned with current risk exposure. Only after understanding how each control contributes to risk mitigation and compliance should management decide whether controls can be removed, consolidated, or replaced without increasing residual risk.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      175,
      177,
      176,
      162,
      171
    ],
    "source": "373666_Ch03"
  },
  {
    "id": 77,
    "question": "A cloud provider suffers a regional outage affecting your organization\u2019s systems. You review the shared responsibility model and confirm that the provider was responsible for infrastructure resilience. What is your organization\u2019s remaining accountability in this scenario?",
    "choice_a": "None; all responsibility transfers to the provider",
    "choice_b": "Accountability for data classification, access governance, and continuity planning",
    "choice_c": "Only legal liability, but not operational accountability",
    "choice_d": "Accountability for the provider\u2019s physical infrastructure controls",
    "correct_answer": "B",
    "explanation": "In shared responsibility models, the customer organization retains accountability for data governance, identity and access management, and continuity planning. Infrastructure resilience is the cloud provider\u2019s responsibility, but customer-level governance obligations remain. In this scenario, the customer organization should establish an alternate processing plan, such as a separate availability zone, a different cloud provider, or on-premise processing.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      165,
      162,
      163,
      181,
      171
    ],
    "source": "373666_Ch03"
  },
  {
    "id": 78,
    "question": "During risk reporting, you notice that one KRI has crossed its defined threshold for three consecutive reporting periods. Which action should occur next?",
    "choice_a": "Escalate the condition and initiate pre-defined response procedures",
    "choice_b": "Automatically accept the increased risk as unavoidable",
    "choice_c": "Replace the KRI with a KPI to improve performance tracking",
    "choice_d": "Perform a full enterprise risk assessment before acting",
    "correct_answer": "A",
    "explanation": "KRIs with breached thresholds require pre-defined escalation, investigation, and treatment steps. They act as early warnings and must trigger a response, not automatic acceptance or replacement.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      185,
      179,
      180,
      167,
      181
    ],
    "source": "373666_Ch03"
  },
  {
    "id": 79,
    "question": "A business unit requests an exception to a mandatory encryption control due to operational constraints affecting a time-critical system. The exception is approved as part of the organization\u2019s formal exception management process. Senior management requires assurance that the exception does not weaken governance or obscure accountability over time. Which combination of elements is MOST critical to include in the exception documentation to ensure effective risk oversight?",
    "choice_a": "Business justification for the exception and acknowledgment of increased risk by the requestor",
    "choice_b": "Defined expiration date, documented residual risk acceptance authority, and required interim mitigation measures",
    "choice_c": "Statement that the exception applies only to the requesting business unit and cannot be reused elsewhere",
    "choice_d": "Description of the control objective and confirmation that the exception aligns with enterprise risk appetite",
    "correct_answer": "C",
    "explanation": "Effective exception management requires that exceptions are temporary, controlled, and accountable. A defined expiration date ensures the exception is revisited, documented residual risk acceptance establishes clear ownership and authorization, and interim mitigation measures reduce exposure while the control is not fully enforced. Together, these elements preserve governance, enable monitoring, and prevent exceptions from becoming de facto permanent control failures. Exceptions must be time-bound and reassessed periodically, because this year\u2019s acceptable risk and accompanying exception may not be acceptable in future years.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      166,
      167,
      161,
      162,
      181
    ],
    "source": "373666_Ch03"
  },
  {
    "id": 80,
    "question": "Your organization is deploying a new AI-enabled analytics system. During the emerging risk review, which factor represents the most common risk associated with integrating new technologies into an existing environment?",
    "choice_a": "Vendor licensing model",
    "choice_b": "Interoperability and compatibility with existing controls and systems",
    "choice_c": "Number of developers trained on the platform",
    "choice_d": "The provider\u2019s marketing claims regarding system capabilities",
    "correct_answer": "B",
    "explanation": "Interoperability and compatibility risks are the most significant concerns with emerging technologies\u2014affecting integration, data flows, security controls, performance, and reliability.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      168,
      169,
      178,
      166,
      171
    ],
    "source": "373666_Ch03"
  },
  {
    "id": 81,
    "question": "An organization has identified a high inherent risk related to a critical business application. Management has approved a risk treatment plan that includes implementing additional controls and accepting a defined level of residual risk. Which activity is MOST important to include in the risk treatment plan to ensure its ongoing effectiveness?",
    "choice_a": "Documenting the organization\u2019s risk appetite statement",
    "choice_b": "Assigning risk ownership and defining monitoring metrics",
    "choice_c": "Updating the enterprise risk register annually",
    "choice_d": "Performing a one-time cost-benefit analysis of the selected controls",
    "correct_answer": "B",
    "explanation": "A risk treatment plan must clearly assign ownership and define metrics to monitor control performance and residual risk over time. This ensures accountability, supports ongoing oversight, and enables timely adjustments if the risk posture changes.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      181,
      162,
      179,
      184,
      180
    ],
    "source": "373666_Ch03"
  },
  {
    "id": 82,
    "question": "An enterprise uses multiple internal and third-party data sources to assess key risk indicators (KRIs) supporting risk response decisions. During a review, management discovers that risk reports are inconsistent across business units despite using the same underlying datasets. Which weakness is MOST likely the primary cause of this issue?",
    "choice_a": "Lack of formally defined risk appetite thresholds",
    "choice_b": "Insufficient frequency of data collection from source systems",
    "choice_c": "Failure to align KRIs with business objectives",
    "choice_d": "Inadequate validation of data transformation and aggregation logic",
    "correct_answer": "D",
    "explanation": "Inconsistent risk reporting across business units using the same datasets most commonly results from weaknesses in data transformation, aggregation, or normalization processes. Without proper validation controls, data may be interpreted or combined differently, leading to inconsistent analysis and unreliable risk response decisions.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      182,
      180,
      185,
      178,
      177
    ],
    "source": "373666_Ch03"
  },
  {
    "id": 83,
    "question": "An organization implements new security controls as part of a risk response initiative. Management wants to evaluate whether the controls are operating as intended and delivering expected outcomes. Which key performance indicator (KPI) is MOST appropriate for this purpose?",
    "choice_a": "Percentage of implemented controls meeting defined performance targets",
    "choice_b": "Number of risk events reported during the last reporting period",
    "choice_c": "Estimated financial impact of potential future risk scenarios",
    "choice_d": "Number of audit findings related to policy non-compliance",
    "correct_answer": "A",
    "explanation": "KPIs measure the performance and effectiveness of processes and controls. Tracking the percentage of controls meeting defined performance targets directly assesses whether risk response actions are operating as intended and achieving expected results.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      184,
      179,
      186,
      177,
      178
    ],
    "source": "373666_Ch03"
  },
  {
    "id": 84,
    "question": "An organization has implemented compensating controls to reduce residual risk associated with a critical business process. Management wants early warning signals that these controls may be weakening before a risk event occurs. Which metric BEST serves this purpose as a key control indicator (KCI)?",
    "choice_a": "Percentage of business objectives achieved during the quarter",
    "choice_b": "Total financial losses resulting from realized risk events",
    "choice_c": "Overall customer satisfaction score for the process",
    "choice_d": "Number of control exceptions identified during routine monitoring",
    "correct_answer": "D",
    "explanation": "KCIs are designed to provide early warning of control effectiveness degradation. Tracking control exceptions directly reflects whether controls are failing or being bypassed, allowing management to intervene before a risk event materializes.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      186,
      179,
      173,
      167,
      181
    ],
    "source": "373666_Ch03"
  },
  {
    "id": 85,
    "question": "You are managing a project that involves the installation of a new set of systems for the accounting division of your organization. You have just been told that there have been budget cuts, and the project team will not be able to purchase additional equipment needed for the installation. You must now identify additional areas to cut to fund the extra equipment. Which element of project management is most affected by this threat?",
    "choice_a": "Schedule",
    "choice_b": "Reporting",
    "choice_c": "Scope",
    "choice_d": "Quality",
    "correct_answer": "C",
    "explanation": "Scope is the element of a project most affected by insufficient funding. The project will need to shrink its scope to stay within budget.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      199,
      198,
      192,
      240,
      228
    ],
    "source": "373666_Ch04"
  },
  {
    "id": 86,
    "question": "An organization is integrating risk management practices into its systems development lifecycle (SDLC). During which SDLC phase is it MOST critical to formally validate that risk treatment options are aligned with business objectives and risk appetite before significant resources are committed?",
    "choice_a": "Requirements definition, when business needs are documented",
    "choice_b": "System design, when architectural and control decisions are finalized",
    "choice_c": "Development, when code and configurations are implemented",
    "choice_d": "Testing, when control effectiveness is verified",
    "correct_answer": "B",
    "explanation": "The system design phase is the point at which architectural choices, control selection, and risk treatment decisions are concretely defined. Validating alignment with business objectives and risk appetite at this stage prevents costly rework and ensures significant risks are addressed appropriately before committing development resources. Requirements definition identifies needs but does not finalize treatments, while development and testing occur after key risk decisions have already been made.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      211,
      215,
      213,
      190,
      228
    ],
    "source": "373666_Ch04"
  },
  {
    "id": 87,
    "question": "During a risk assessment, management discovers that sensitive data is being copied into test environments and retained after testing is complete. Which data lifecycle control would MOST effectively address this risk?",
    "choice_a": "Strengthening access controls on production systems",
    "choice_b": "Increasing backup frequency for test environment data",
    "choice_c": "Implementing data minimization and timely disposal in non-production environments",
    "choice_d": "Encrypting all data stored in production databases",
    "correct_answer": "C",
    "explanation": "Applying data lifecycle controls, such as data minimization and timely disposal, ensures that sensitive data is not retained longer than necessary, particularly in non-production environments. This directly reduces exposure risk. The other options do not address unnecessary retention outside the intended lifecycle stage.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      210,
      208,
      244,
      209,
      216
    ],
    "source": "373666_Ch04"
  },
  {
    "id": 88,
    "question": "Which of the following is the major risk factor associated with integrating new or emerging technologies into an existing IT infrastructure?",
    "choice_a": "Security mechanisms",
    "choice_b": "Data format",
    "choice_c": "Vendor supportability",
    "choice_d": "Interoperability",
    "correct_answer": "D",
    "explanation": "Interoperability is the primary risk when integrating new or emerging technologies into an existing IT infrastructure. Interoperability is the best answer, as it encompasses the individual factors in the other answers.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      218,
      189,
      191,
      222,
      221
    ],
    "source": "373666_Ch04"
  },
  {
    "id": 89,
    "question": "Which of the following is a short-term process primarily concerned with protecting personnel, facilities, and equipment immediately following a disaster or major incident?",
    "choice_a": "Disaster recovery",
    "choice_b": "Business continuity",
    "choice_c": "Business impact analysis",
    "choice_d": "Recovery point objective",
    "correct_answer": "A",
    "explanation": "Disaster recovery is a short-term process primarily focused on protecting personnel, facilities, and equipment immediately after a disaster or major incident.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      201,
      207,
      203,
      202,
      204
    ],
    "source": "373666_Ch04"
  },
  {
    "id": 90,
    "question": "Which of the following best explains why enterprise architecture (EA) reduces operational and technology risk?",
    "choice_a": "It documents firewall configurations for all network segments",
    "choice_b": "It standardizes technology layers and aligns them with business processes",
    "choice_c": "It enforces uniform programming languages across the enterprise",
    "choice_d": "It eliminates the need for system lifecycle management",
    "correct_answer": "B",
    "explanation": "EA reduces risk by creating a standardized, governed structure linking business processes, data, applications, and technology. This reduces interoperability failures, technical debt, and inconsistent control implementation.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      189,
      190,
      191,
      228,
      195
    ],
    "source": "373666_Ch04"
  },
  {
    "id": 91,
    "question": "As part of data lifecycle management, an organization is reviewing how data is handled after decommissioning a core business application. Which action is MOST important to reduce long-term risk while maintaining regulatory compliance?",
    "choice_a": "Retain all application data indefinitely in primary storage",
    "choice_b": "Immediately destroy all associated data to reduce storage costs",
    "choice_c": "Transfer all data ownership to the IT operations team",
    "choice_d": "Archive data according to defined retention and disposal requirements",
    "correct_answer": "D",
    "explanation": "Data lifecycle management requires that data be retained, archived, or disposed of in accordance with legal, regulatory, and business requirements. Archiving in accordance with defined retention and disposal requirements balances compliance obligations with risk reduction. Indefinite retention increases risk, while immediate destruction may violate regulations.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      210,
      208,
      216,
      245,
      244
    ],
    "source": "373666_Ch04"
  },
  {
    "id": 92,
    "question": "A heterogeneous platform environment increases risk primarily because it:",
    "choice_a": "Requires a single vendor for support contracts",
    "choice_b": "Reduces the number of required security controls",
    "choice_c": "Increases complexity and interoperability challenges",
    "choice_d": "Eliminates the need for patch management processes",
    "correct_answer": "C",
    "explanation": "Supporting multiple operating systems and architectures increases interoperability challenges, support overhead, and configuration complexity, all of which directly contribute to operational and security risks.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      197,
      189,
      196,
      192,
      218
    ],
    "source": "373666_Ch04"
  },
  {
    "id": 93,
    "question": "Which IT operations process most directly reduces the likelihood of configuration drift across systems?",
    "choice_a": "Incident management",
    "choice_b": "Configuration management",
    "choice_c": "Portfolio management",
    "choice_d": "Problem management",
    "correct_answer": "B",
    "explanation": "Configuration management maintains authoritative configuration records, baselines, and relationships, allowing consistent control of system states and preventing (or detecting) drift.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      193,
      214,
      200,
      228,
      230
    ],
    "source": "373666_Ch04"
  },
  {
    "id": 94,
    "question": "A project experiences repeated delays due to unclear definitions of required deliverables. Which project element is most directly at risk?",
    "choice_a": "Cost",
    "choice_b": "Quality",
    "choice_c": "Scope",
    "choice_d": "Staffing",
    "correct_answer": "C",
    "explanation": "Unclear or poorly defined deliverables indicate an incomplete scope, leading to misaligned expectations, rework, and schedule instability.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      199,
      214,
      217,
      213,
      228
    ],
    "source": "373666_Ch04"
  },
  {
    "id": 95,
    "question": "Which disaster recovery metric defines the maximum tolerable amount of data loss measured in time?",
    "choice_a": "RTO",
    "choice_b": "RCapO",
    "choice_c": "RPO",
    "choice_d": "MTTF",
    "correct_answer": "C",
    "explanation": "RPO (Recovery Point Objective) specifies the maximum acceptable data loss. It determines the required backup frequency or replication strategy.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      202,
      241,
      206,
      207,
      204
    ],
    "source": "373666_Ch04"
  },
  {
    "id": 96,
    "question": "An organization is introducing an IoT-enabled manufacturing system. The vendor requires multiple external connections to cloud APIs. During the risk assessment, the IT team identifies that the new system uses a proprietary authentication method incompatible with the enterprise identity service. What is the MOST significant risk associated with integrating this emerging technology?",
    "choice_a": "Increased bandwidth consumption across the manufacturing network",
    "choice_b": "Failure of the system to meet RCapO requirements",
    "choice_c": "Interoperability and security integration gaps with existing infrastructure",
    "choice_d": "Inability to migrate historical data during system upgrades",
    "correct_answer": "C",
    "explanation": "Proprietary authentication that is incompatible with enterprise identity systems creates major interoperability and security risks, including weakened access control, inconsistent policy enforcement, and an increased attack surface.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      218,
      219,
      231,
      189,
      214
    ],
    "source": "373666_Ch04"
  },
  {
    "id": 97,
    "question": "Which IT operations function addresses systemic causes of recurring incidents?",
    "choice_a": "Incident management",
    "choice_b": "Problem management",
    "choice_c": "Vendor management",
    "choice_d": "Lifecycle management",
    "correct_answer": "B",
    "explanation": "Problem management conducts root cause analysis (RCA) to identify and address the underlying causes of recurring incidents and reduce operational risk.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      193,
      195,
      192,
      228,
      227
    ],
    "source": "373666_Ch04"
  },
  {
    "id": 98,
    "question": "Which emerging technology risk is most commonly associated with integrating new systems into older enterprise environments?",
    "choice_a": "Increased storage efficiency",
    "choice_b": "Simplified authentication processes",
    "choice_c": "Interoperability and compatibility failures",
    "choice_d": "Guaranteed backward-compatible security controls",
    "correct_answer": "C",
    "explanation": "Emerging technologies often introduce challenges involving protocols, data formats, authentication, and interfaces.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      218,
      189,
      211,
      216,
      192
    ],
    "source": "373666_Ch04"
  },
  {
    "id": 99,
    "question": "A large enterprise experiences recurring incidents where unauthorized configuration changes cause outages in its virtualized server environment. Investigation reveals that VM templates are being manually altered by several administrators without documentation. Which control would MOST effectively reduce this risk?",
    "choice_a": "Increasing the frequency of DR tests",
    "choice_b": "Using immutable, version-controlled templates managed through configuration management",
    "choice_c": "Adding additional virtualization hosts to distribute workloads",
    "choice_d": "Implementing annual cybersecurity awareness training",
    "correct_answer": "B",
    "explanation": "Uncontrolled changes to VM templates cause configuration drift and unplanned outages. Enforcing template version control, baseline integrity, and configuration management directly mitigates this risk.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      193,
      214,
      220,
      230,
      192
    ],
    "source": "373666_Ch04"
  },
  {
    "id": 100,
    "question": "Which data governance activity ensures that only the correct individuals continue to have access to sensitive datasets?",
    "choice_a": "Data provenance",
    "choice_b": "Access review",
    "choice_c": "Data lineage analysis",
    "choice_d": "Database indexing",
    "correct_answer": "B",
    "explanation": "Access reviews confirm that users, groups, and roles still require the access they hold, reducing the risk of unauthorized access.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      232,
      208,
      231,
      229,
      237
    ],
    "source": "373666_Ch04"
  },
  {
    "id": 101,
    "question": "Which type of DR test provides the highest assurance but also the greatest operational risk?",
    "choice_a": "Full interruption test",
    "choice_b": "Parallel test",
    "choice_c": "Readthrough test",
    "choice_d": "Tabletop test",
    "correct_answer": "A",
    "explanation": "A full interruption test shuts down production systems and performs a full recovery, providing maximum assurance, but it also introduces substantial operational risk if the recovery system fails.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      205,
      207,
      204,
      206,
      241
    ],
    "source": "373666_Ch04"
  },
  {
    "id": 102,
    "question": "Which of the following creates the highest risk in a CI/CD pipeline?",
    "choice_a": "Frequent code deployments",
    "choice_b": "Storing secrets in build scripts",
    "choice_c": "Using multiple automated test suites",
    "choice_d": "Requiring peer reviews before merging code",
    "correct_answer": "B",
    "explanation": "Hard-coded secrets in pipelines expose credentials and other sensitive information, enabling compromise of build systems, repositories, or production environments.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      200,
      215,
      214,
      230,
      245
    ],
    "source": "373666_Ch04"
  },
  {
    "id": 103,
    "question": "Which practice best represents a \u201cshift left\u201d approach in a secure development process?",
    "choice_a": "Conducting penetration tests annually",
    "choice_b": "Executing DR tests in a separate environment",
    "choice_c": "Performing threat modeling before design is finalized",
    "choice_d": "Implementing MFA during system retirement",
    "correct_answer": "C",
    "explanation": "Shift left moves security earlier in the lifecycle: threat modeling before design is finalized ensures risks are addressed before development.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      213,
      217,
      215,
      212,
      211
    ],
    "source": "373666_Ch04"
  },
  {
    "id": 104,
    "question": "Alternate processing sites, such as hot or warm sites, are primarily used to satisfy which requirement?",
    "choice_a": "Minimizing the cost of vendor contracts",
    "choice_b": "Meeting RTO and maintaining service availability",
    "choice_c": "Reducing the number of DR tests required",
    "choice_d": "Eliminating the need for data backups",
    "correct_answer": "B",
    "explanation": "Alternate sites ensure critical systems can be restored quickly, directly supporting required RTOs and service resilience.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      203,
      241,
      207,
      206,
      240
    ],
    "source": "373666_Ch04"
  },
  {
    "id": 105,
    "question": "What is the primary objective of information security from a CRISC perspective?",
    "choice_a": "Preventing all security incidents",
    "choice_b": "Ensuring compliance with technical standards",
    "choice_c": "Reducing risk to acceptable levels aligned with business objectives",
    "choice_d": "Maximizing investment in security controls",
    "correct_answer": "C",
    "explanation": "CRISC emphasizes risk reduction aligned with business objectives, achieved through risk treatment. CRISC does not directly address absolute prevention or technology optimization. Not all security incidents can be prevented. Compliance with technical standards and maximizing control investment are important, but not the primary CRISC drivers.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      228,
      224,
      195,
      225,
      233
    ],
    "source": "373666_Ch05"
  },
  {
    "id": 106,
    "question": "What best distinguishes a security policy from a security standard?",
    "choice_a": "Policies are optional; standards are mandatory",
    "choice_b": "Policies define intent; standards define implementation requirements",
    "choice_c": "Policies apply externally; standards apply internally",
    "choice_d": "Policies are technical; standards are managerial",
    "correct_answer": "B",
    "explanation": "Policies state what must be achieved, while standards define how policies are implemented. Both policies and standards are mandatory and are applied according to the scope of the program.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      224,
      229,
      227,
      230,
      228
    ],
    "source": "373666_Ch05"
  },
  {
    "id": 107,
    "question": "Which activity best supports effective access management governance?",
    "choice_a": "Implementing multifactor authentication",
    "choice_b": "Performing periodic access reviews",
    "choice_c": "Encrypting authentication databases",
    "choice_d": "Centralizing authentication services",
    "correct_answer": "B",
    "explanation": "Access reviews validate the ongoing appropriateness of access, and support governance and risk oversight. MFA, encryption, and central authentication services may reduce risk and improve compliance, but are not governance drivers.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      232,
      228,
      208,
      230,
      194
    ],
    "source": "373666_Ch05"
  },
  {
    "id": 108,
    "question": "Which principle most directly limits the risk associated with excessive collection of personal data?",
    "choice_a": "Accuracy",
    "choice_b": "Purpose limitation",
    "choice_c": "Data minimization",
    "choice_d": "Transparency",
    "correct_answer": "C",
    "explanation": "Data minimization requires organizations to collect and retain only the personal data necessary for a defined purpose, reducing exposure and impact in the event of misuse or compromise. Purpose limitation addresses the ways in which PII is used.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      208,
      247,
      243,
      244,
      246
    ],
    "source": "373666_Ch05"
  },
  {
    "id": 109,
    "question": "Which factor most increases the likelihood that a control will degrade over time?",
    "choice_a": "Initial over-engineering",
    "choice_b": "Stable business processes",
    "choice_c": "Changes in technology and threat landscape",
    "choice_d": "Strong policy enforcement",
    "correct_answer": "C",
    "explanation": "Environmental change is a major cause of control degradation. Controls designed today to counter today\u2019s threats may be ineffective in the future when threats evolve.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      225,
      230,
      219,
      218,
      224
    ],
    "source": "373666_Ch05"
  },
  {
    "id": 110,
    "question": "Which activity best supports ongoing control effectiveness?",
    "choice_a": "One-time certification",
    "choice_b": "Periodic testing and monitoring",
    "choice_c": "Control documentation",
    "choice_d": "Control automation",
    "correct_answer": "B",
    "explanation": "Effectiveness depends on ongoing validation, not documentation alone. One-time certification is not enough: controls must be periodically examined to ensure they remain effective. Documentation is critical, while automation may make controls more efficient (and possibly more effective).",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      206,
      228,
      225,
      230,
      232
    ],
    "source": "373666_Ch05"
  },
  {
    "id": 111,
    "question": "Which principle is NOT part of the CIA triad?",
    "choice_a": "Accountability",
    "choice_b": "Availability",
    "choice_c": "Confidentiality",
    "choice_d": "Integrity",
    "correct_answer": "A",
    "explanation": "Accountability is important for governance, but is not part of the CIA triad. The CIA triad is confidentiality, integrity, and availability.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      223,
      231,
      230,
      228,
      227
    ],
    "source": "373666_Ch05"
  },
  {
    "id": 112,
    "question": "Which role is primarily accountable for accepting residual risk?",
    "choice_a": "Risk owner",
    "choice_b": "Control owner",
    "choice_c": "System administrator",
    "choice_d": "Internal auditor",
    "correct_answer": "A",
    "explanation": "Risk owners are accountable for risk acceptance decisions. Control owners are responsible for operating controls established as a result of risk assessments. System administrators are not business decision makers, but stewards of information systems. Internal auditors are independent parties that examine controls for effectiveness.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      228,
      224,
      225,
      195,
      233
    ],
    "source": "373666_Ch05"
  },
  {
    "id": 113,
    "question": "Which metric provides the strongest evidence that information security awareness training is influencing risk outcomes?",
    "choice_a": "Number of training modules completed per employee",
    "choice_b": "Trend in phishing simulation failure rates over time",
    "choice_c": "Percentage of employees passing post-training quizzes",
    "choice_d": "Cost of the training program per user",
    "correct_answer": "B",
    "explanation": "Changes in simulated phishing failure rates reflect real-world behavior and provide outcome-oriented evidence of reduced human-related security risk.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      239,
      238,
      237,
      234,
      233
    ],
    "source": "373666_Ch05"
  },
  {
    "id": 114,
    "question": "A privacy impact assessment identifies high risk, but no control changes are made. How should this be classified?",
    "choice_a": "Risk avoidance",
    "choice_b": "Risk transfer",
    "choice_c": "Risk elimination",
    "choice_d": "Risk acceptance",
    "correct_answer": "D",
    "explanation": "Identified risk without mitigation reflects risk acceptance, whether explicit or implicit. The other choices all involve some sort of operational change.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      228,
      225,
      246,
      230,
      237
    ],
    "source": "373666_Ch05"
  },
  {
    "id": 115,
    "question": "Which approach most directly aligns information security awareness training with enterprise risk management objectives?",
    "choice_a": "Delivering standardized training content to all employees",
    "choice_b": "Updating training materials annually based on industry trends",
    "choice_c": "Tailoring training content to roles, threat scenarios, and risk exposure",
    "choice_d": "Outsourcing training delivery to a third-party provider",
    "correct_answer": "C",
    "explanation": "Risk-aligned security awareness training focuses on role-specific threats and exposure, ensuring that awareness efforts address the organization\u2019s most significant risk scenarios.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      237,
      238,
      226,
      228,
      225
    ],
    "source": "373666_Ch05"
  },
  {
    "id": 116,
    "question": "Which practice best supports a risk-aware security culture?",
    "choice_a": "Integrating security awareness with risk awareness",
    "choice_b": "Increasing security tool deployment",
    "choice_c": "Limiting training to IT staff",
    "choice_d": "Publishing technical configuration guides",
    "correct_answer": "A",
    "explanation": "CRISC emphasizes behavioral and cultural risk reduction. The other choices may benefit the organization, but have little or no impact on culture.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      237,
      238,
      228,
      195,
      229
    ],
    "source": "373666_Ch05"
  },
  {
    "id": 117,
    "question": "What distinguishes GDPR from many U.S. sectoral privacy laws?",
    "choice_a": "GDPR applies only to government entities",
    "choice_b": "GDPR is principles-based and extraterritorial",
    "choice_c": "GDPR excludes enforcement penalties",
    "choice_d": "GDPR focuses solely on breach notification",
    "correct_answer": "B",
    "explanation": "GDPR applies broadly, even outside the EU, when EU data subjects are involved. GDPR applies to all parties, including government and industry, and includes enforcement penalties.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      248,
      247,
      227,
      246,
      208
    ],
    "source": "373666_Ch05"
  },
  {
    "id": 118,
    "question": "Which NIST CSF 2.0 Core Function was newly introduced?",
    "choice_a": "Identify",
    "choice_b": "Protect",
    "choice_c": "Govern",
    "choice_d": "Detect",
    "correct_answer": "C",
    "explanation": "NIST CSF 2.0 added the Govern function to emphasize governance and ERM alignment. The other CSF core functions: Identify, Protect, Detect, Respond, and Recover are in both 1.x and 2.0 versions of the CSF.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      226,
      224,
      191,
      195,
      229
    ],
    "source": "373666_Ch05"
  },
  {
    "id": 119,
    "question": "Which scenario best demonstrates ineffective incident response governance?",
    "choice_a": "An untested incident response plan with unclear escalation authority",
    "choice_b": "An incident response plan integrated with BCM",
    "choice_c": "Regular tabletop exercises",
    "choice_d": "Automated alerting tools",
    "correct_answer": "A",
    "explanation": "Lack of testing and unclear authority undermine effective incident response and risk management. The other choices do not indicate ineffective governance.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      233,
      228,
      205,
      206,
      204
    ],
    "source": "373666_Ch05"
  },
  {
    "id": 120,
    "question": "Which outcome best demonstrates that an information security awareness training program is effective?",
    "choice_a": "Measurable improvement in secure user behavior aligned to risk scenarios",
    "choice_b": "Completion of mandatory annual training by all employees",
    "choice_c": "Reduction in the number of reported security incidents",
    "choice_d": "Increased enforcement of disciplinary actions for policy violations",
    "correct_answer": "A",
    "explanation": "The effectiveness of an information security awareness training program is demonstrated by behavior change that reduces risk, not merely by training completion or enforcement activity.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      238,
      239,
      237,
      235,
      230
    ],
    "source": "373666_Ch05"
  },
  {
    "id": 121,
    "question": "Why does CRISC emphasize governance over technical detail in security frameworks?",
    "choice_a": "Governance replaces security controls",
    "choice_b": "Governance determines accountability, priorities, and risk decisions",
    "choice_c": "Technical controls are outside CRISC scope",
    "choice_d": "Governance ensures compliance automation",
    "correct_answer": "B",
    "explanation": "CRISC focuses on decision-making, ownership, and oversight rather than implementation details. Governance does not replace security controls; rather, it manages their introduction, operation, and effectiveness testing. Technical controls are enacted based on risk assessment results and risk treatment decisions. Compliance automation, while potentially helpful, is not relevant for CRISC.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      228,
      226,
      224,
      230,
      235
    ],
    "source": "373666_Ch05"
  },
  {
    "id": 122,
    "question": "Which document typically specifies mandatory implementation details for a policy?",
    "choice_a": "Standard",
    "choice_b": "Guideline",
    "choice_c": "Procedure",
    "choice_d": "Framework",
    "correct_answer": "A",
    "explanation": "Standards define mandatory requirements that support policy implementation. Guidelines represent optional implementation and/or operational guidance. While mandatory, procedures don\u2019t specify implementation details; they specify only operational activities. Frameworks are collections of policies, standards, or controls.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      224,
      229,
      227,
      225,
      230
    ],
    "source": "373666_Ch05"
  },
  {
    "id": 123,
    "question": "Which characteristic most increases privacy-related risk exposure?",
    "choice_a": "High system availability",
    "choice_b": "Minimal data retention",
    "choice_c": "Excessive collection of personal data",
    "choice_d": "Strong authentication controls",
    "correct_answer": "C",
    "explanation": "Collecting more personal data than necessary increases regulatory and breach impact risk. High availability, minimizing retention, and strong authentication are likely to reduce privacy-related exposure.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      208,
      243,
      244,
      245,
      246
    ],
    "source": "373666_Ch05"
  },
  {
    "id": 124,
    "question": "What is the primary risk addressed by incident response practices?",
    "choice_a": "Impact of realized risk events",
    "choice_b": "Threat modeling accuracy",
    "choice_c": "Control design completeness",
    "choice_d": "Vulnerability creation",
    "correct_answer": "A",
    "explanation": "Incident response limits the impact of events after risk has materialized. Threat modeling and control design influence risk independent of incident response practices. Vulnerabilities exist and are discovered, regardless of any organization\u2019s incident response capabilities.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      233,
      230,
      228,
      226,
      225
    ],
    "source": "373666_Ch05"
  },
  {
    "id": 125,
    "question": "Which document primarily defines how an organization will continue critical operations during a disruptive event?",
    "choice_a": "Incident response plan",
    "choice_b": "Business continuity plan",
    "choice_c": "Risk register",
    "choice_d": "Disaster recovery policy",
    "correct_answer": "B",
    "explanation": "A business continuity plan (BCP) documents strategies and procedures to maintain or quickly resume critical business operations during and after disruptions. Any critical business operations requiring IT system support will also include disaster recovery plans for each such IT system.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      240,
      201,
      241,
      207,
      203
    ],
    "source": "373666_Ch05"
  },
  {
    "id": 126,
    "question": "Which activity is most critical for determining recovery priorities within a business continuity program?",
    "choice_a": "Threat intelligence analysis",
    "choice_b": "Vulnerability scanning",
    "choice_c": "Control self-assessment",
    "choice_d": "Business impact analysis (BIA)",
    "correct_answer": "D",
    "explanation": "A business impact analysis (BIA) identifies critical processes, acceptable downtime, dependencies, and the impact of disruptions, forming the basis for recovery priorities and resource allocation.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      241,
      240,
      202,
      207,
      206
    ],
    "source": "373666_Ch05"
  },
  {
    "id": 127,
    "question": "Which metric is used to define the maximum acceptable amount of data loss following a disruption?",
    "choice_a": "Recovery Point Objective (RPO)",
    "choice_b": "Recovery Time Objective (RTO)",
    "choice_c": "Mean Time to Recover (MTTR)",
    "choice_d": "Service Level Objective (SLO)",
    "correct_answer": "A",
    "explanation": "Recovery point objective (RPO) defines the point in time to which data must be restored, representing the maximum tolerable data loss measured in time.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      202,
      241,
      206,
      207,
      203
    ],
    "source": "373666_Ch05"
  },
  {
    "id": 128,
    "question": "Which scenario best demonstrates alignment between business continuity management and risk management?",
    "choice_a": "Conducting annual penetration tests",
    "choice_b": "Updating access control lists quarterly",
    "choice_c": "Designing recovery strategies based on risk scenarios and business impact",
    "choice_d": "Deploying endpoint detection and response tools",
    "correct_answer": "C",
    "explanation": "Business continuity management aligns with risk management when recovery strategies are selected based on evaluated risk scenarios and their potential business impacts.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      241,
      242,
      240,
      203,
      204
    ],
    "source": "373666_Ch05"
  },
  {
    "id": 129,
    "question": "An organization meets its technical recovery objectives during a disaster but still experiences significant financial and reputational damage. What is the most likely root cause?",
    "choice_a": "Inadequate disaster recovery testing",
    "choice_b": "Failure to align BCM objectives with business expectations",
    "choice_c": "Insufficient backup frequency",
    "choice_d": "Lack of incident response automation",
    "correct_answer": "A",
    "explanation": "Technical recovery success alone is insufficient if BCM objectives (such as RTOs and RPOs) are not aligned with actual business tolerance for disruption, leading to unacceptable outcomes despite system restoration.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      241,
      202,
      240,
      207,
      206
    ],
    "source": "373666_Ch05"
  },
  {
    "id": 130,
    "question": "Which factor is MOST important when assigning ownership for a risk treatment plan?",
    "choice_a": "The technical expertise of the control owner",
    "choice_b": "The organizational level of the individual",
    "choice_c": "Accountability for the business impact of the risk",
    "choice_d": "The budget authority of the IT department",
    "correct_answer": "C",
    "explanation": "Risk ownership must align with accountability for business impact, not technical implementation or budget control. Risk ownership aligns with business impact, while control ownership supports implementation.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      162,
      181,
      171,
      165,
      163
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 131,
    "question": "Which of the following BEST communicates management\u2019s willingness to accept risk?",
    "choice_a": "Risk register",
    "choice_b": "Risk appetite statement",
    "choice_c": "Risk treatment plan",
    "choice_d": "Audit report",
    "correct_answer": "B",
    "explanation": "The risk appetite statement defines the amount and type of risk an organization is willing to accept on a routine basis. A risk treatment plan discusses a single risk, but not the organization\u2019s overall risk. The risk register is a part of risk management business records and does not communicate risk appetite. Audit reports also do not communicate risk appetite, although they may indirectly reflect it.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      126,
      116,
      123,
      118,
      119
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 132,
    "question": "Which activity BEST ensures alignment between IT operations and business risk objectives?",
    "choice_a": "Patch management",
    "choice_b": "Incident response testing",
    "choice_c": "Change management governance",
    "choice_d": "Asset inventory maintenance",
    "correct_answer": "C",
    "explanation": "Change management governance ensures that IT changes align with risk tolerance and business priorities by establishing processes for introducing proposed system changes. Patch management, incident response testing, and asset inventory maintenance are vital activities, but are not related to business alignment.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      193,
      192,
      190,
      228,
      214
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 133,
    "question": "Which scenario BEST illustrates a control deficiency rather than a vulnerability?",
    "choice_a": "Unpatched operating systems",
    "choice_b": "Weak password policy",
    "choice_c": "Ineffective segregation of duties",
    "choice_d": "Publicly exposed API endpoint",
    "correct_answer": "C",
    "explanation": "A control deficiency reflects a failure in control design or operation, not an inherent system weakness. Unpatched systems, weak password policy, and publicly exposed APIs are considered vulnerabilities.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      134,
      132,
      135,
      152,
      143
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 134,
    "question": "Which risk response option transfers risk to a third party?",
    "choice_a": "Risk acceptance",
    "choice_b": "Risk avoidance",
    "choice_c": "Risk mitigation",
    "choice_d": "Risk sharing",
    "correct_answer": "D",
    "explanation": "Risk sharing (also known as risk transfer) shifts financial or operational risk to another party, often via insurance or contracts. Risk acceptance, risk avoidance, and risk mitigation do not involve risk transfer to another party.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      160,
      163,
      171,
      181,
      180
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 135,
    "question": "Which governance structure MOST directly supports independent risk oversight?",
    "choice_a": "IT steering committee",
    "choice_b": "Executive management team",
    "choice_c": "Board risk committee",
    "choice_d": "Project management office",
    "correct_answer": "C",
    "explanation": "A board risk committee provides independent oversight separate from operational management. The other choices lack independence.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      117,
      125,
      123,
      115,
      119
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 136,
    "question": "Which input is MOST critical when developing a risk scenario?",
    "choice_a": "Historical incident frequency",
    "choice_b": "Threat actor motivation",
    "choice_c": "Business process context",
    "choice_d": "Control maturity ratings",
    "correct_answer": "C",
    "explanation": "Risk scenarios must be grounded in a business context to assess and communicate meaningful impact. Incident frequency may be useful for better understanding risk levels. Threat actor motivation helps to better understand a risk scenario. Control maturity ratings may be useful when maturity is low.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      138,
      154,
      132,
      151,
      142
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 137,
    "question": "Which SDLC phase MOST benefits from early risk identification?",
    "choice_a": "Deployment",
    "choice_b": "Maintenance",
    "choice_c": "Design",
    "choice_d": "Retirement",
    "correct_answer": "C",
    "explanation": "Identifying risk during design enables preventive controls and cost-effective mitigation. Deployment, maintenance, and retirement occur after a system has been designed and are too late to influence design.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      213,
      217,
      215,
      211,
      214
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 138,
    "question": "Which situation MOST warrants escalation to senior management?",
    "choice_a": "Minor control failure with no impact",
    "choice_b": "Accepted risk within tolerance",
    "choice_c": "Risk exceeding approved appetite",
    "choice_d": "Delayed control testing schedule",
    "correct_answer": "C",
    "explanation": "A risk exceeding risk appetite triggers an escalation that requires executive decision-making and potential strategy adjustments. The other choices are not serious matters requiring escalation.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      160,
      161,
      180,
      181,
      171
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 139,
    "question": "Inherent risk is BEST described as risk that is:",
    "choice_a": "Accepted by management",
    "choice_b": "Remaining after controls",
    "choice_c": "Present before controls",
    "choice_d": "Transferred to third parties",
    "correct_answer": "C",
    "explanation": "Inherent risk exists prior to the application of any controls. Risk remaining after controls is known as residual risk. Accepted and transferred risks are not inherent risks.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      152,
      132,
      142,
      147,
      149
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 140,
    "question": "Which situation BEST demonstrates misalignment between risk appetite and risk tolerance?",
    "choice_a": "Different tolerance thresholds across business units",
    "choice_b": "Tolerance limits approved by executive leadership",
    "choice_c": "Operational losses within approved thresholds",
    "choice_d": "Risk acceptance documented and approved",
    "correct_answer": "A",
    "explanation": "Risk tolerance may vary, but must remain consistent with enterprise risk appetite. Established tolerance limits, losses within thresholds, and documented risk acceptance are issues that represent alignment.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      126,
      116,
      123,
      118,
      125
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 141,
    "question": "Which control MOST directly supports data lifecycle risk management?",
    "choice_a": "Role-based access control",
    "choice_b": "Data classification policy",
    "choice_c": "Network segmentation",
    "choice_d": "Vulnerability scanning",
    "correct_answer": "B",
    "explanation": "Data classification informs handling, retention, and protection across the data lifecycle. Role-based access control, network segmentation, and vulnerability scanning do not directly support data lifecycle risk management.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      244,
      208,
      210,
      209,
      245
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 142,
    "question": "Which metric BEST indicates control effectiveness over time?",
    "choice_a": "Key performance indicators",
    "choice_b": "Audit findings count",
    "choice_c": "Key control indicators",
    "choice_d": "Incident response duration",
    "correct_answer": "C",
    "explanation": "Key control indicators (KCIs) specifically measure whether controls are operating as intended. KCIs are most direct, but effectiveness is often triangulated across multiple metrics. Key performance indicators indicate system or process performance. Audit finding counts may correlate with control effectiveness, but they are not the best answer. Incident response duration could represent the effectiveness of a specific control on responsiveness, but not in general.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      186,
      179,
      184,
      185,
      177
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 143,
    "question": "Which factor MOST influences risk likelihood estimation?",
    "choice_a": "Asset replacement cost",
    "choice_b": "Threat capability and intent",
    "choice_c": "Control ownership assignment",
    "choice_d": "Regulatory penalties",
    "correct_answer": "B",
    "explanation": "Likelihood depends heavily on threat capability and motivation. The other factor is the presence and nature of any vulnerabilities. Asset replacement cost and regulatory penalties are impacts, not probabilities. Control ownership assignments are unrelated.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      142,
      132,
      133,
      134,
      148
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 144,
    "question": "Which role is responsible for setting enterprise risk appetite?",
    "choice_a": "Risk owners",
    "choice_b": "Control owners",
    "choice_c": "Board of directors",
    "choice_d": "Internal audit",
    "correct_answer": "C",
    "explanation": "The board of directors establishes enterprise-level risk appetite. Risk owners, control owners, and internal audit should not set risk appetite.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      116,
      117,
      123,
      126,
      125
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 145,
    "question": "Which emerging technology introduces the GREATEST uncertainty in risk assessment?",
    "choice_a": "Virtualization",
    "choice_b": "Microservices",
    "choice_c": "Artificial intelligence systems",
    "choice_d": "Relational databases",
    "correct_answer": "C",
    "explanation": "AI systems introduce opacity, adaptive behavior, privacy, and secondary-use risks. Virtualization, microservices, and relational databases are less uncertain, as they are well-established.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      219,
      218,
      247,
      214,
      225
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 146,
    "question": "What is the PRIMARY objective of exception management?",
    "choice_a": "Eliminate noncompliance",
    "choice_b": "Reduce audit workload",
    "choice_c": "Temporarily allow deviation from policy",
    "choice_d": "Permanently bypass controls",
    "correct_answer": "C",
    "explanation": "Exceptions allow controlled deviations under defined conditions and with a defined expiration. They do not eliminate noncompliance or reduce audit workload. Bypassing controls is not the primary purpose.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      166,
      167,
      171,
      181,
      180
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 147,
    "question": "Which condition MOST undermines the accuracy of a business impact analysis?",
    "choice_a": "Use of qualitative scales",
    "choice_b": "Incomplete dependency mapping",
    "choice_c": "Scenario-based assumptions",
    "choice_d": "Executive validation",
    "correct_answer": "B",
    "explanation": "Missing dependencies lead to understated or incorrect impact estimates. Qualitative scales do not undermine accuracy, if ratings are consistently discerned. Scenario-based assumptions and executive validation can help improve accuracy, not undermine it.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      151,
      138,
      142,
      154,
      148
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 148,
    "question": "Which plan focuses on restoring IT systems after a disruption?",
    "choice_a": "Business continuity plan",
    "choice_b": "Incident response plan",
    "choice_c": "Disaster recovery plan",
    "choice_d": "Risk treatment plan",
    "correct_answer": "C",
    "explanation": "Disaster recovery plans address the restoration of IT systems. Business continuity plans focus on the resilience of business processes. Incident response and risk treatment plans are not used to restore IT systems.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      207,
      201,
      202,
      203,
      204
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 149,
    "question": "Which activity confirms that risk responses were implemented as approved?",
    "choice_a": "Risk assessment",
    "choice_b": "Risk validation",
    "choice_c": "Risk identification",
    "choice_d": "Risk acceptance",
    "correct_answer": "B",
    "explanation": "Validation, also known as follow-up, ensures that approved responses were executed. A future risk assessment can help confirm implementation of a risk response, but this may occur months or years later. Risk identification and acceptance are not used to confirm risk response.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      179,
      178,
      181,
      166,
      167
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 150,
    "question": "Which factor MOST influences organizational risk culture?",
    "choice_a": "Number of policies",
    "choice_b": "Frequency of audits",
    "choice_c": "Leadership behavior",
    "choice_d": "Control automation level",
    "correct_answer": "C",
    "explanation": "Leadership behavior strongly shapes risk awareness and decision-making norms. The number of policies, audit frequency, and control automation may reflect risk culture, but they do not influence risk culture.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      118,
      116,
      126,
      115,
      117
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 151,
    "question": "Which artifact BEST supports prioritization of risk response efforts?",
    "choice_a": "Heat map",
    "choice_b": "Asset inventory",
    "choice_c": "Policy library",
    "choice_d": "Control catalog",
    "correct_answer": "A",
    "explanation": "Heat maps visualize relative likelihood and impact to support prioritization. The other choices are not related to risk response prioritization.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      149,
      142,
      147,
      146,
      152
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 152,
    "question": "Which control MOST directly reduces risk from unauthorized system changes?",
    "choice_a": "Backup procedures",
    "choice_b": "Change approval workflows",
    "choice_c": "Log retention policies",
    "choice_d": "Vulnerability assessments",
    "correct_answer": "B",
    "explanation": "Change approval workflows help prevent unauthorized or unreviewed system changes by requiring proposed changes to be formally requested, reviewed, and approved. Without change management, changes may cause unintended malfunctions and outages.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      193,
      192,
      214,
      230,
      228
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 153,
    "question": "Which strategic-level risk response decision is MOST likely to require board involvement?",
    "choice_a": "Control enhancement",
    "choice_b": "Risk mitigation",
    "choice_c": "Risk avoidance impacting strategy",
    "choice_d": "Control testing frequency change",
    "correct_answer": "C",
    "explanation": "Strategic changes due to risk avoidance require board-level oversight. The other choices are unlikely to require board involvement.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      160,
      171,
      162,
      166,
      180
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 154,
    "question": "Which term describes a potential cause of an unwanted incident?",
    "choice_a": "Risk",
    "choice_b": "Impact",
    "choice_c": "Threat",
    "choice_d": "Control",
    "correct_answer": "C",
    "explanation": "A threat is a potential cause of harm. Risk, impact, and control are not incident causes.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      132,
      133,
      142,
      148,
      152
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 155,
    "question": "Which document MOST directly links IT risk to business objectives?",
    "choice_a": "Risk profile",
    "choice_b": "IT asset register",
    "choice_c": "Disaster recovery plan",
    "choice_d": "Control testing report",
    "correct_answer": "A",
    "explanation": "The risk profile aggregates and contextualizes risk relative to business objectives. IT asset register, DRP, and control test reports are not directly linked to business objectives.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      127,
      116,
      120,
      123,
      124
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 156,
    "question": "Which activity BEST supports a risk-aware culture?",
    "choice_a": "Annual penetration testing",
    "choice_b": "Security awareness training",
    "choice_c": "Log monitoring",
    "choice_d": "Vulnerability scanning",
    "correct_answer": "B",
    "explanation": "Awareness training promotes informed risk behavior across the organization. The other activities don\u2019t support a risk-aware culture, as these activities are generally not known (in detail) to most of an organization\u2019s workforce.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      237,
      238,
      239,
      236,
      228
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 157,
    "question": "Which input is MOST critical when selecting a risk treatment option?",
    "choice_a": "Control cost",
    "choice_b": "Residual risk level",
    "choice_c": "Control maturity score",
    "choice_d": "Audit frequency",
    "correct_answer": "B",
    "explanation": "Treatment decisions depend on whether residual risk is acceptable. Cost may be the next most critical input, while control maturity and audit frequency have little or no input.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      161,
      171,
      181,
      160,
      162
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 158,
    "question": "Which analysis BEST identifies cascading risk effects?",
    "choice_a": "Asset valuation",
    "choice_b": "Root cause analysis",
    "choice_c": "Dependency analysis",
    "choice_d": "Control gap assessment",
    "correct_answer": "C",
    "explanation": "Dependency analysis reveals downstream and cascading impacts by identifying other critical systems that bring their own risks. All the other choices do not represent cascading risk because there is no recursion in them.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      148,
      142,
      154,
      138,
      149
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 159,
    "question": "Which concept ensures that risk decisions are made at appropriate organizational levels?",
    "choice_a": "Segregation of duties",
    "choice_b": "Risk ownership",
    "choice_c": "Defense in depth",
    "choice_d": "Least privilege",
    "correct_answer": "B",
    "explanation": "Risk ownership assigns accountability to the correct decision-makers. Least privilege and segregation of duties are access management concepts; defense in depth is a control design concept.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      117,
      123,
      125,
      127,
      120
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 160,
    "question": "Which condition MOST complicates data privacy risk management?",
    "choice_a": "Centralized data storage",
    "choice_b": "Static data classification",
    "choice_c": "Cross-border data processing",
    "choice_d": "On-premises infrastructure",
    "correct_answer": "C",
    "explanation": "Cross-border processing introduces legal and regulatory complexity far more than the other choices.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      247,
      248,
      208,
      227,
      246
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 161,
    "question": "Which report is MOST useful for operational managers?",
    "choice_a": "Board risk summary",
    "choice_b": "Strategic risk profile",
    "choice_c": "Enterprise risk appetite statement",
    "choice_d": "KRI dashboard",
    "correct_answer": "D",
    "explanation": "Key risk indicator (KRI) dashboards support day-to-day risk monitoring. Board risk summaries, strategic risk profile, and enterprise risk appetite statements are all executive leadership and board reports.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      179,
      185,
      183,
      180,
      184
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 162,
    "question": "Which factor MOST affects residual risk calculation?",
    "choice_a": "Asset value",
    "choice_b": "Threat frequency",
    "choice_c": "Control effectiveness",
    "choice_d": "Regulatory penalties",
    "correct_answer": "C",
    "explanation": "Residual risk depends on how effectively controls reduce inherent risk. Control effectiveness is the most direct factor, but others contribute contextually.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      152,
      134,
      135,
      142,
      146
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 163,
    "question": "Which situation MOST threatens governance effectiveness?",
    "choice_a": "Formal risk policies",
    "choice_b": "Clear role definitions",
    "choice_c": "Overlapping accountability",
    "choice_d": "Regular reporting",
    "correct_answer": "C",
    "explanation": "Overlapping accountability creates ambiguity and weakens oversight. The other choices support governance effectiveness.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      117,
      125,
      119,
      115,
      123
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 164,
    "question": "Which concept limits system access to necessary permissions only?",
    "choice_a": "Defense in depth",
    "choice_b": "Least privilege",
    "choice_c": "Separation of duties",
    "choice_d": "Risk tolerance",
    "correct_answer": "B",
    "explanation": "Least privilege restricts access to what is strictly required. Defense in depth is a control design concept; risk tolerance relates to risk treatment decisions; and separation of duties is used to divide critical tasks among two or more persons.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      231,
      232,
      234,
      213,
      230
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 165,
    "question": "Which activity BEST supports continuous risk monitoring?",
    "choice_a": "Annual audits",
    "choice_b": "Control design reviews",
    "choice_c": "Automated metrics collection",
    "choice_d": "Policy approval cycles",
    "correct_answer": "C",
    "explanation": "Automation enables the timely detection of changes in risk. Annual audits, policy approval cycles, and control design reviews do not represent continuous monitoring.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      179,
      180,
      185,
      164,
      166
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 166,
    "question": "Which term describes the outcome of a risk event?",
    "choice_a": "Impact",
    "choice_b": "Threat",
    "choice_c": "Vulnerability",
    "choice_d": "Control",
    "correct_answer": "A",
    "explanation": "Impact is the result or consequence of a risk event. A threat is an event that can cause harm. A vulnerability is a weakness that may permit a threat to occur. A control is a safeguard that enforces a condition or prevents an unwanted event.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      132,
      142,
      152,
      148,
      139
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 167,
    "question": "Which mechanism MOST effectively enforces ethical risk management practices?",
    "choice_a": "Informal norms",
    "choice_b": "Professional codes of conduct",
    "choice_c": "Technical controls",
    "choice_d": "Incident response playbooks",
    "correct_answer": "B",
    "explanation": "Codes of conduct establish ethical expectations and accountability. Technical controls and IR playbooks are largely unrelated to ethics. Informal norms don\u2019t enforce anything.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      118,
      129,
      119,
      115,
      126
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 168,
    "question": "Which IT process MOST directly supports incident containment?",
    "choice_a": "Change management",
    "choice_b": "Configuration management",
    "choice_c": "Incident response",
    "choice_d": "Capacity planning",
    "correct_answer": "C",
    "explanation": "Incident response focuses on containment and remediation. Change management, configuration management, and capacity planning have little, if anything, to do with incident containment.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      233,
      193,
      194,
      240,
      204
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 169,
    "question": "Which failure MOST undermines risk reporting credibility?",
    "choice_a": "Qualitative scoring",
    "choice_b": "Infrequent updates",
    "choice_c": "Unvalidated data sources",
    "choice_d": "Aggregated metrics",
    "correct_answer": "C",
    "explanation": "Unvalidated data erodes trust in reported risk information. Qualitative scoring can undermine credibility if ratings are not applied consistently. Infrequent updates and aggregated metrics also undermine risk reporting credibility, but not as much as unvalidated data.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      182,
      180,
      183,
      185,
      179
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 170,
    "question": "Which approach BEST improves risk assessment consistency?",
    "choice_a": "Individual judgment",
    "choice_b": "Standardized methodology",
    "choice_c": "Ad hoc workshops",
    "choice_d": "Executive interviews",
    "correct_answer": "B",
    "explanation": "Standardized methods improve comparability and repeatability. Executive interviews improve risk assessment consistency, but not as much as a standard methodology. Individual judgment and ad hoc workshops degrade consistency.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      144,
      145,
      142,
      143,
      153
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 171,
    "question": "Which element defines acceptable variation around risk appetite?",
    "choice_a": "Risk tolerance",
    "choice_b": "Risk profile",
    "choice_c": "Risk scenario",
    "choice_d": "Risk capacity",
    "correct_answer": "A",
    "explanation": "Risk tolerance specifies acceptable deviation limits. A risk profile is a collection of details on identified risks; a risk scenario is a description of an individual risk; and risk capacity is the amount of loss an organization can incur without seriously affecting its ability to continue as an organization.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      126,
      116,
      123,
      124,
      125
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 172,
    "question": "Which practice MOST supports secure system development?",
    "choice_a": "Post-deployment testing",
    "choice_b": "Secure coding standards",
    "choice_c": "Log review",
    "choice_d": "Patch management",
    "correct_answer": "B",
    "explanation": "Secure coding standards reduce vulnerabilities early, and in many cases, prevent them. Post-deployment testing, log review, and patch management are important, but do not contribute to secure development.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      215,
      217,
      212,
      214,
      230
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 173,
    "question": "Which stakeholder should approve risk acceptance decisions?",
    "choice_a": "Risk owner",
    "choice_b": "System administrator",
    "choice_c": "Control owner",
    "choice_d": "Internal auditor",
    "correct_answer": "A",
    "explanation": "Risk owners are accountable for acceptance decisions. In some governance models, acceptance may require higher-level endorsement. System administrators, control owners, and internal auditors should not be risk acceptance approvers.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      162,
      161,
      167,
      181,
      180
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 174,
    "question": "Which scenario BEST represents secondary risk?",
    "choice_a": "Malware infection",
    "choice_b": "Data breach fines",
    "choice_c": "Reputational damage following disclosure",
    "choice_d": "System downtime",
    "correct_answer": "C",
    "explanation": "Secondary risk arises as a consequence of the primary event. Malware infections, fines, and downtime are primary risks.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      138,
      139,
      148,
      152,
      142
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 175,
    "question": "Which artifact MOST supports alignment between ERM and IT risk management?",
    "choice_a": "IT policy manual",
    "choice_b": "Enterprise risk taxonomy",
    "choice_c": "Incident log",
    "choice_d": "Asset register",
    "correct_answer": "B",
    "explanation": "A common taxonomy enables integration across risk disciplines. IT policy manuals, incident logs, and asset registers are unrelated to ERM\u2013IT risk management alignment.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      124,
      123,
      120,
      119,
      115
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 176,
    "question": "Which activity verifies that backups can be restored successfully?",
    "choice_a": "Backup scheduling",
    "choice_b": "Data classification",
    "choice_c": "Restoration testing",
    "choice_d": "Access review",
    "correct_answer": "C",
    "explanation": "Restoration testing confirms backup effectiveness. In the absence of restoration testing, the effectiveness of backups is unknown. Backup scheduling, data classification, and access reviews are not related to the integrity of backups.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      194,
      205,
      206,
      203,
      207
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 177,
    "question": "Which metric BEST signals increasing risk exposure?",
    "choice_a": "KPI trend improvement",
    "choice_b": "Stable control maturity",
    "choice_c": "Rising KRI thresholds",
    "choice_d": "Reduced audit findings",
    "correct_answer": "C",
    "explanation": "Rising key risk indicators (KRIs) indicate increasing exposure. Key performance indicator (KPI) trend improvements and reduced audit findings should be neutral or indicate a decrease in risk exposure. Stable control maturity should be neutral in terms of its influence on risk exposure.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      185,
      179,
      184,
      187,
      183
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 178,
    "question": "Which risk register attribute MOST supports executive decision-making?",
    "choice_a": "Technical vulnerability details",
    "choice_b": "Risk owner name",
    "choice_c": "Aggregated impact rating",
    "choice_d": "Control test scripts",
    "correct_answer": "C",
    "explanation": "Aggregated impact ratings support prioritization at the executive level. Technical vulnerability details and control test scripts should not support executive decision-making, nor should the name of the risk owner.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      149,
      142,
      147,
      138,
      157
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 179,
    "question": "Which governance failure MOST likely leads to unmanaged IT risk?",
    "choice_a": "Lack of documentation",
    "choice_b": "Excessive controls",
    "choice_c": "Overreporting metrics",
    "choice_d": "Undefined decision authority",
    "correct_answer": "D",
    "explanation": "Undefined authority prevents timely and accountable risk decisions. The other choices will contribute to poorly managed operations and reporting.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      117,
      115,
      123,
      119,
      125
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 180,
    "question": "Which element MOST improves the accuracy of risk scenario analysis?",
    "choice_a": "Historical loss data adjusted for context",
    "choice_b": "Asset replacement cost",
    "choice_c": "Control testing frequency",
    "choice_d": "Number of vulnerabilities identified",
    "correct_answer": "A",
    "explanation": "Threat probability is usually the most difficult part of risk to quantify. Historical loss data, when contextualized, provides realistic insight into likelihood and impact. The other choices are far easier to quantify.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      142,
      146,
      147,
      148,
      138
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 181,
    "question": "Which role is accountable for ensuring controls are operating as intended?",
    "choice_a": "Risk owner",
    "choice_b": "Control owner",
    "choice_c": "Internal auditor",
    "choice_d": "Compliance officer",
    "correct_answer": "B",
    "explanation": "Control owners are responsible for the implementation and operation of controls. While control owners ensure operation, assurance functions (usually Internal Audit) verify performance. Risk owners and compliance officers are usually \u201cabove\u201d control owners in an organizational chart and often do not have operational responsibility.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      162,
      179,
      177,
      181,
      173
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 182,
    "question": "Which factor MOST directly influences the effectiveness of the three lines of defense model?",
    "choice_a": "Number of documented policies",
    "choice_b": "Automation of controls",
    "choice_c": "Volume of risk reporting",
    "choice_d": "Independence between assurance functions",
    "correct_answer": "D",
    "explanation": "Independence between the three lines ensures objective oversight and challenge across defense layers. The other choices may contribute in small ways (if at all).",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      125,
      117,
      123,
      129,
      118
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 183,
    "question": "Which IT process MOST reduces operational risk from unauthorized software changes?",
    "choice_a": "Configuration baselining",
    "choice_b": "Capacity management",
    "choice_c": "Change management",
    "choice_d": "Incident escalation",
    "correct_answer": "C",
    "explanation": "Change management ensures authorization, testing, and approval of changes. Capacity management, configuration baselining, and incident escalation are unrelated to software change authorization.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      193,
      192,
      214,
      228,
      213
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 184,
    "question": "Which situation MOST indicates ineffective risk treatment?",
    "choice_a": "Residual risk reduced below tolerance",
    "choice_b": "Controls implemented, but KRIs continue to rise",
    "choice_c": "Risk acceptance formally documented",
    "choice_d": "Risk transferred through insurance",
    "correct_answer": "B",
    "explanation": "Rising key risk indicators (KRIs) suggest that controls are not achieving the intended risk reduction. Residual risk below tolerance is not an indicator of risk treatment effectiveness. Formally documented risk acceptance and risk transfer are considered effective risk treatment.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      179,
      185,
      181,
      177,
      171
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 185,
    "question": "Which term describes a weakness that could be exploited by a threat?",
    "choice_a": "Risk event",
    "choice_b": "Impact",
    "choice_c": "Vulnerability",
    "choice_d": "Loss",
    "correct_answer": "C",
    "explanation": "A vulnerability is a weakness that may be exploited. A risk event is not a weakness, but a specific risk scenario. Impact and loss are the effects of a threat.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      132,
      134,
      152,
      142,
      139
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 186,
    "question": "Which condition MOST undermines enterprise risk management integration?",
    "choice_a": "Separate risk registers with no common taxonomy",
    "choice_b": "Periodic board reporting",
    "choice_c": "Defined risk appetite",
    "choice_d": "Formal governance committees",
    "correct_answer": "A",
    "explanation": "The lack of a shared taxonomy prevents the aggregation and comparison of risks. Periodic board reporting, a defined risk appetite, and formal governance committees support ERM but are neutral on ERM integration.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      124,
      123,
      120,
      119,
      125
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 187,
    "question": "Which activity ensures that systems can support business operations during disruptions?",
    "choice_a": "Vulnerability management",
    "choice_b": "Business continuity planning",
    "choice_c": "Penetration testing",
    "choice_d": "Log correlation",
    "correct_answer": "B",
    "explanation": "Business continuity planning (BCP) maintains critical operations during disruptions. Vulnerability management improves resilience through better defenses. Penetration testing can also improve resilience, provided the organization mitigates important findings. Log correlation aids in event detection, not continuity during disruptions.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      240,
      241,
      207,
      202,
      205
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 188,
    "question": "Which input is MOST important when determining risk reporting frequency?",
    "choice_a": "Control testing schedule",
    "choice_b": "Regulatory inspection cycles",
    "choice_c": "Volatility of the risk",
    "choice_d": "Number of stakeholders",
    "correct_answer": "C",
    "explanation": "More volatile risks require more frequent reporting. Control testing and the number of stakeholders are not related to risk reporting schedules. Regulatory inspection cycles could also be related to risk reporting frequency, but they are less important than risk volatility.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      180,
      185,
      183,
      179,
      188
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 189,
    "question": "Which approach BEST supports comparison of risks across domains?",
    "choice_a": "Normalized risk scoring",
    "choice_b": "Scenario workshops",
    "choice_c": "Qualitative narratives",
    "choice_d": "Independent assessments",
    "correct_answer": "A",
    "explanation": "Normalized scoring enables consistent comparison. Scenario workshops, qualitative narratives, and independent assessments do little, if anything, to support risk comparisons.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      147,
      146,
      142,
      149,
      144
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 190,
    "question": "Which document defines acceptable behavior regarding risk-related decisions?",
    "choice_a": "Risk register",
    "choice_b": "Code of ethics",
    "choice_c": "Audit charter",
    "choice_d": "Business case",
    "correct_answer": "B",
    "explanation": "Codes of ethics establish behavioral expectations. Risk registers, audit charters, and business cases do not define acceptable behavior, but serve unrelated functions.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      129,
      118,
      119,
      123,
      126
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 191,
    "question": "Which condition MOST complicates disaster recovery planning?",
    "choice_a": "Single data center architecture",
    "choice_b": "Cloud-based workloads",
    "choice_c": "Interdependent legacy systems",
    "choice_d": "Virtualized infrastructure",
    "correct_answer": "C",
    "explanation": "Interdependencies increase recovery complexity and sequencing risk, particularly with legacy systems that may have fewer integration capabilities. Single data center architecture can simplify DR planning, although a single data center also represents a single point of failure. Cloud-based workloads and virtualization can either simplify or complicate DR planning, depending upon the degree of consistency and automation.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      203,
      202,
      207,
      241,
      191
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 192,
    "question": "Which activity MOST improves coordination between risk and control owners?",
    "choice_a": "Independent audits",
    "choice_b": "Joint risk workshops",
    "choice_c": "Automated testing",
    "choice_d": "Policy enforcement",
    "correct_answer": "B",
    "explanation": "Workshops promote shared understanding and alignment. Independent audits provide an opportunity for coordination, but less so than joint risk workshops. Automated testing and policy enforcement may or may not influence coordination between risk and control owners.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      162,
      181,
      167,
      177,
      179
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 193,
    "question": "Which factor MOST reduces confidence in likelihood estimates?",
    "choice_a": "Lack of historical data",
    "choice_b": "Qualitative assessment methods",
    "choice_c": "Executive involvement",
    "choice_d": "Scenario documentation",
    "correct_answer": "A",
    "explanation": "Without historical data, likelihood estimates rely heavily on judgment, particularly for low-probability, high-impact event scenarios. Executive involvement and scenario documentation can improve confidence through clarity and participation. Qualitative methods should be neutral when applied consistently.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      142,
      147,
      146,
      138,
      157
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 194,
    "question": "Which governance artifact MOST directly supports escalation paths?",
    "choice_a": "Risk taxonomy",
    "choice_b": "Organizational chart",
    "choice_c": "Risk policy",
    "choice_d": "Risk appetite statement",
    "correct_answer": "C",
    "explanation": "Risk policies define escalation criteria, procedures, and responsibilities. Risk taxonomy and appetite are not related to escalation. An organizational chart is the next best answer, as it can be used to identify escalation paths not defined elsewhere.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      119,
      117,
      123,
      125,
      115
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 195,
    "question": "Which practice BEST reduces risk introduced by emerging technologies?",
    "choice_a": "Pilot testing",
    "choice_b": "Accelerated deployment",
    "choice_c": "Vendor marketing review",
    "choice_d": "Post-incident analysis",
    "correct_answer": "A",
    "explanation": "Pilots allow controlled evaluation before full adoption. Accelerated deployment of emerging technology increases risk. Vendor marketing information should have little, if anything, to do with risk reduction. Post-incident analysis is not related to risk management, but is related to incident management.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      225,
      228,
      218,
      219,
      237
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 196,
    "question": "Which response option removes exposure by discontinuing the activity?",
    "choice_a": "Risk mitigation",
    "choice_b": "Risk acceptance",
    "choice_c": "Risk avoidance",
    "choice_d": "Risk transfer",
    "correct_answer": "C",
    "explanation": "Avoidance eliminates the source of risk. The activity is not discontinued with the other three choices.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      160,
      171,
      181,
      166,
      162
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 197,
    "question": "Which attribute of a risk register MOST supports trend analysis?",
    "choice_a": "Risk owner",
    "choice_b": "Risk category",
    "choice_c": "Time-stamped ratings",
    "choice_d": "Control descriptions",
    "correct_answer": "C",
    "explanation": "Time-stamped risk ratings enable trend identification. Risk owners, risk categories, and control descriptions are not related to trend analysis.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      149,
      150,
      157,
      142,
      147
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 198,
    "question": "Which scenario BEST demonstrates ineffective governance oversight?",
    "choice_a": "Board receives summarized risk reports",
    "choice_b": "Risk decisions made without documented authority",
    "choice_c": "Management accepts risk within tolerance",
    "choice_d": "Regular risk committee meetings",
    "correct_answer": "B",
    "explanation": "Undocumented authority weakens accountability. The other choices demonstrate effective governance oversight.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      115,
      117,
      119,
      120,
      125
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 199,
    "question": "Which SDLC activity MOST directly mitigates design-level risk?",
    "choice_a": "User acceptance testing",
    "choice_b": "Secure architecture review",
    "choice_c": "Patch deployment",
    "choice_d": "Log monitoring",
    "correct_answer": "B",
    "explanation": "Architecture reviews address systemic design weaknesses. The other choices take place well after design and even development, and thus have little influence on design-level risk.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      217,
      215,
      213,
      211,
      214
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 200,
    "question": "Which metric MOST effectively signals control degradation?",
    "choice_a": "Increasing control failures",
    "choice_b": "Static KCI values",
    "choice_c": "KPI improvement",
    "choice_d": "Reduced audit scope",
    "correct_answer": "A",
    "explanation": "Rising failures indicate declining control performance. Static KCI values signal control stability. KPI improvements may or may not be related to control degradation. Reduced audit scope is unrelated.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      179,
      186,
      185,
      177,
      187
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 201,
    "question": "Which concept represents the probability of a risk event occurring?",
    "choice_a": "Impact",
    "choice_b": "Exposure",
    "choice_c": "Likelihood",
    "choice_d": "Severity",
    "correct_answer": "C",
    "explanation": "Likelihood reflects probability. Impact is the effect of a risk event. Exposure is the potential monetary loss from a risk event. Severity represents an incident rating rubric.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      142,
      132,
      147,
      146,
      152
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 202,
    "question": "Which practice MOST supports consistent risk decision-making?",
    "choice_a": "Ad hoc approvals",
    "choice_b": "Documented risk criteria",
    "choice_c": "Individual discretion",
    "choice_d": "Informal discussions",
    "correct_answer": "B",
    "explanation": "Documented and repeatable decision criteria ensure consistency. Ad hoc approvals, individual discretion, and informal discussions support inconsistent decision-making.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      119,
      124,
      126,
      120,
      125
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 203,
    "question": "Which factor MOST increases data protection risk in outsourced environments?",
    "choice_a": "Encryption at rest",
    "choice_b": "Shared responsibility ambiguity",
    "choice_c": "Centralized monitoring",
    "choice_d": "Contractual SLAs",
    "correct_answer": "B",
    "explanation": "Ambiguous responsibilities lead to protection gaps. Encryption at rest and centralized monitoring decrease data protection risk. Contractual SLAs are unrelated to data protection risk.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      246,
      208,
      195,
      232,
      247
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 204,
    "question": "Which output MOST supports executive prioritization of risk responses?",
    "choice_a": "Detailed control test results",
    "choice_b": "Aggregated risk dashboard",
    "choice_c": "Incident root cause analysis",
    "choice_d": "Asset inventories",
    "correct_answer": "B",
    "explanation": "Aggregated dashboards support the prioritization of high-level decisions. Detailed control rest results are unrelated, as they are management-oriented rather than executive-oriented. Root cause analysis and asset inventories are not related to risk response prioritization.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      183,
      180,
      185,
      181,
      179
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 205,
    "question": "Which analysis BEST supports identification of control gaps?",
    "choice_a": "Threat modeling",
    "choice_b": "Control mapping",
    "choice_c": "Loss quantification",
    "choice_d": "Scenario ranking",
    "correct_answer": "B",
    "explanation": "Control mapping highlights missing or weak controls, particularly when an organization compares its controls with an industry standard such as ISO/IEC 27002 or CIS CSC. Threat modeling identifies potential vulnerabilities. Scenario ranking and loss quantification do little to identify control gaps.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      134,
      135,
      143,
      144,
      145
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 206,
    "question": "Which role provides independent assurance on risk management effectiveness?",
    "choice_a": "Risk owner",
    "choice_b": "Control owner",
    "choice_c": "Internal audit",
    "choice_d": "Business manager",
    "correct_answer": "C",
    "explanation": "Internal audit provides independent assurance within the three lines of defense model. Risk owners, control owners, and business managers lack independence as they are involved in operational processes.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      125,
      117,
      123,
      124,
      126
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 207,
    "question": "Which practice MOST reduces operational risk from asset sprawl?",
    "choice_a": "Asset inventory management",
    "choice_b": "Network segmentation",
    "choice_c": "Incident escalation",
    "choice_d": "Backup rotation",
    "correct_answer": "A",
    "explanation": "Asset inventory management enables visibility and control, and reveals signs of asset sprawl. Network segmentation MAY reduce the risk of asset sprawl in some situations. Incident escalation and backup rotation are unrelated to asset sprawl and asset management.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      197,
      195,
      228,
      226,
      193
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 208,
    "question": "Which condition MOST indicates ineffective exception management?",
    "choice_a": "Time-bound approvals",
    "choice_b": "Defined compensating controls",
    "choice_c": "Repeated extensions without review",
    "choice_d": "Documented rationale",
    "correct_answer": "C",
    "explanation": "Repeated extensions without reviews suggest unmanaged risk. Time-bound approvals, defined compensating controls, and documented rationale are activities you would expect to find in effective exception management operations.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      166,
      167,
      173,
      181,
      179
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 209,
    "question": "Which issue MOST limits the comparability of qualitative risk assessments?",
    "choice_a": "Lack of numerical precision",
    "choice_b": "Inconsistent rating definitions",
    "choice_c": "Scenario complexity",
    "choice_d": "Use of workshops",
    "correct_answer": "B",
    "explanation": "Inconsistent definitions reduce comparability, as such a comparison would not be an \u201capples to apples\u201d comparison. A lack of numerical precision would not hamper comparability. Scenario complexity may limit comparability, but not as much as inconsistent ratings. The use of workshops should not be a factor here.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      147,
      142,
      143,
      144,
      145
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 210,
    "question": "Which factor MOST influences risk governance maturity?",
    "choice_a": "Number of metrics",
    "choice_b": "Executive engagement",
    "choice_c": "Control automation",
    "choice_d": "Audit frequency",
    "correct_answer": "B",
    "explanation": "Active executive engagement drives the maturity of risk governance. The other choices are not a factor, as maturity does not depend only on metrics, control automation, or audit frequency.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      115,
      116,
      117,
      118,
      123
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 211,
    "question": "Which concept ensures that critical systems can be accessed on demand?",
    "choice_a": "Confidentiality",
    "choice_b": "Integrity",
    "choice_c": "Availability",
    "choice_d": "Authenticity",
    "correct_answer": "C",
    "explanation": "Availability focuses on system uptime and access. Confidentiality focuses on preventing unauthorized access, while integrity focuses on preventing unauthorized modification. Authenticity is not one of the basic \u201cCIA\u201d concepts.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      223,
      240,
      241,
      207,
      206
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 212,
    "question": "Which activity MOST improves risk response accountability?",
    "choice_a": "Risk acceptance memos",
    "choice_b": "Assigned ownership with timelines",
    "choice_c": "Periodic audits",
    "choice_d": "Control testing",
    "correct_answer": "B",
    "explanation": "Ownership and timelines ensure follow-through. Risk acceptance memos can serve the same purpose, but only for accepted risks. Periodic audits and control testing can help by verifying remediation (if that is the chosen response), but are not the best answer.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      162,
      181,
      167,
      161,
      180
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 213,
    "question": "Which factor MOST affects impact assessment?",
    "choice_a": "Threat motivation",
    "choice_b": "Asset criticality",
    "choice_c": "Control maturity",
    "choice_d": "Likelihood rating",
    "correct_answer": "B",
    "explanation": "Business impact is driven primarily by asset importance. Threat motivation and control maturity have little or no impact. Likelihood differs from impact, as it expresses the probability of an event, not its impact.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      151,
      154,
      142,
      146,
      152
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 214,
    "question": "Which governance failure MOST likely results in unmanaged residual risk?",
    "choice_a": "Infrequent audits",
    "choice_b": "Undefined risk acceptance authority",
    "choice_c": "Excessive documentation",
    "choice_d": "Formal reporting",
    "correct_answer": "B",
    "explanation": "Without a defined acceptance authority, residual risk decisions are unclear. Excessive documentation, infrequent audits, and formal reporting are not related.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      117,
      123,
      127,
      126,
      125
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 215,
    "question": "Which practice BEST supports secure disposal of data?",
    "choice_a": "Media sanitization",
    "choice_b": "Data masking",
    "choice_c": "Encryption",
    "choice_d": "Access review",
    "correct_answer": "A",
    "explanation": "Sanitization, such as overwriting, ensures that data cannot be recovered. Data masking and encryption are less effective because the data may still be recoverable. Access reviews are not related to secure data disposal.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      210,
      208,
      245,
      244,
      232
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 216,
    "question": "Which response option reduces risk through additional controls?",
    "choice_a": "Risk avoidance",
    "choice_b": "Risk transfer",
    "choice_c": "Risk mitigation",
    "choice_d": "Risk acceptance",
    "correct_answer": "C",
    "explanation": "Mitigation lowers likelihood or impact. Avoidance involves discontinuing the activity that introduces a risk. Transfer involves a third-party assuming part or all of a risk. Acceptance involves management\u2019s approval for no action to be taken.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      160,
      171,
      172,
      173,
      176
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 217,
    "question": "Which risk analysis output BEST supports cost-benefit evaluation?",
    "choice_a": "Risk ranking",
    "choice_b": "Loss expectancy",
    "choice_c": "Control mapping",
    "choice_d": "Threat inventory",
    "correct_answer": "B",
    "explanation": "Loss expectancy supports the development of economic analysis in support of cost-benefit evaluation. Risk ranking is a sequence of risks but lacks their likelihood and impact parameters. Control mapping and threat inventory provide less support for cost-benefit evaluation than does less expectancy.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      146,
      147,
      151,
      142,
      138
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 218,
    "question": "Which practice MOST improves transparency of risk decisions?",
    "choice_a": "Informal discussions",
    "choice_b": "Documented rationale",
    "choice_c": "Verbal approvals",
    "choice_d": "Ad hoc reporting",
    "correct_answer": "B",
    "explanation": "Documentation provides traceability and transparency. Informal discussions, verbal approvals, and ad hoc reporting are, by their nature, undocumented and therefore opaque.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      119,
      115,
      120,
      123,
      125
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 219,
    "question": "Which issue MOST increases identity and access management complexity in hybrid environments?",
    "choice_a": "Password complexity",
    "choice_b": "Federated identity integration",
    "choice_c": "Role definitions",
    "choice_d": "Logging",
    "correct_answer": "B",
    "explanation": "Federation across environments increases the complexity of identity and access management systems. Password complexity and logging have little impact on IAM complexity. Role definitions may be a factor, but less so than the integration of federated identities.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      220,
      231,
      232,
      228,
      226
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 220,
    "question": "Which metric MOST effectively demonstrates risk response success?",
    "choice_a": "Number of controls",
    "choice_b": "Policy updates",
    "choice_c": "Audit frequency",
    "choice_d": "Reduction in residual risk",
    "correct_answer": "D",
    "explanation": "Successful risk responses reduce residual risk. The number of controls, policy updates, and audit frequency have little, if anything, to do with the success of risk response.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      181,
      179,
      185,
      160,
      171
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 221,
    "question": "Which concept represents remaining risk after controls are implemented?",
    "choice_a": "Residual risk",
    "choice_b": "Inherent risk",
    "choice_c": "Accepted risk",
    "choice_d": "Secondary risk",
    "correct_answer": "A",
    "explanation": "Residual risk remains after controls. Inherent risk exists before any controls are applied. Accepted risk represents a decision made about a risk. The term \u201csecondary risk\u201d is not common in risk management.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      152,
      132,
      142,
      135,
      149
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 222,
    "question": "Which element MOST supports alignment between IT and enterprise risk reporting?",
    "choice_a": "Common scoring scales",
    "choice_b": "Separate dashboards",
    "choice_c": "Technical metrics",
    "choice_d": "Incident logs",
    "correct_answer": "A",
    "explanation": "Common scales enable aggregation and comparison. Separate dashboards obscure alignment, while technical metrics and incident logs are less relevant.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      120,
      116,
      123,
      124,
      125
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 223,
    "question": "Which activity MOST supports detection of anomalous behavior?",
    "choice_a": "Configuration reviews",
    "choice_b": "Log monitoring",
    "choice_c": "Patch testing",
    "choice_d": "Capacity planning",
    "correct_answer": "B",
    "explanation": "Log monitoring enables anomaly detection. Configuration reviews help confirm configuration settings and do not focus on events. Patch testing supports vulnerability management, which is about prevention, not detection. Capacity planning is unrelated.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      194,
      225,
      234,
      230,
      227
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 224,
    "question": "Which failure MOST undermines confidence in KRI thresholds?",
    "choice_a": "Conservative limits",
    "choice_b": "Static thresholds despite environmental change",
    "choice_c": "Frequent reporting",
    "choice_d": "Automation",
    "correct_answer": "B",
    "explanation": "Static thresholds may no longer reflect risk reality: as environments change, thresholds need to be changed with them. Conservative limits may conceal increasing risks that warrant attention. Frequent reporting and automation are less relevant.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      185,
      179,
      180,
      182,
      186
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 225,
    "question": "Which step MOST improves risk scenario completeness?",
    "choice_a": "Asset valuation",
    "choice_b": "Stakeholder validation",
    "choice_c": "Control testing",
    "choice_d": "Quantification",
    "correct_answer": "B",
    "explanation": "Validation ensures that scenarios reflect operational reality. In the absence of stakeholders validating a risk scenario for completeness and relevance, all other steps are inconsequential.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      138,
      140,
      143,
      144,
      136
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 226,
    "question": "Which body is responsible for oversight of risk management effectiveness?",
    "choice_a": "Project teams",
    "choice_b": "IT operations",
    "choice_c": "Board of directors",
    "choice_d": "System owners",
    "correct_answer": "C",
    "explanation": "The board provides oversight of risk management programs. Project teams, IT operations, and system owners are not in positions of corporate risk governance.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      117,
      123,
      125,
      115,
      119
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 227,
    "question": "Which practice MOST reduces risk from third-party system access?",
    "choice_a": "Network hardening",
    "choice_b": "Access provisioning reviews",
    "choice_c": "Data encryption",
    "choice_d": "Backup testing",
    "correct_answer": "B",
    "explanation": "Reviews of third-party access to systems ensure that access remains appropriate. Network hardening may also help by making network devices more resilient to attack. Data encryption may also help by preventing third parties from accessing data they should not. Backup testing is unrelated.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      232,
      231,
      246,
      234,
      244
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 228,
    "question": "Which artifact MOST supports validation of control performance?",
    "choice_a": "Policy statements",
    "choice_b": "Control test results",
    "choice_c": "Risk appetite statement",
    "choice_d": "Asset inventory",
    "correct_answer": "B",
    "explanation": "Test results demonstrate actual performance. Policy statements, risk appetite statements, and asset inventory are unrelated and do not support validation of control performance.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      179,
      177,
      186,
      184,
      178
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 229,
    "question": "Which issue MOST limits the accuracy of aggregated risk reporting?",
    "choice_a": "Use of dashboards",
    "choice_b": "Differing risk definitions",
    "choice_c": "Executive summaries",
    "choice_d": "Quantitative models",
    "correct_answer": "B",
    "explanation": "Inconsistent definitions distort aggregation. Dashboards and executive summaries are unrelated to the accuracy of risk reporting. Quantitative models can support aggregated risk reporting, provided that all risks are scored and weighted consistently.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      132,
      142,
      147,
      149,
      157
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 230,
    "question": "Which factor MOST influences prioritization of multiple risk treatment plans?",
    "choice_a": "Control maturity",
    "choice_b": "Number of affected assets",
    "choice_c": "Audit frequency",
    "choice_d": "Residual risk magnitude",
    "correct_answer": "D",
    "explanation": "The level of residual risk relative to tolerance drives treatment prioritization. The maturity of controls, the number of affected assets, and the audit frequency are likely to have little or no impact on risk treatment priorities.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      181,
      171,
      161,
      180,
      185
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 231,
    "question": "Which document formally assigns accountability for managing specific risks?",
    "choice_a": "Risk register",
    "choice_b": "Risk policy",
    "choice_c": "Audit plan",
    "choice_d": "Business impact analysis",
    "correct_answer": "A",
    "explanation": "The risk register records ownership and accountability for identified risks. Risk policy assigns accountability overall, but not for specific risks. Audit plans and BIAs do not assign risk accountability.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      127,
      120,
      125,
      124,
      119
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 232,
    "question": "Which IT operations activity MOST directly reduces configuration drift?",
    "choice_a": "Incident escalation",
    "choice_b": "Configuration management",
    "choice_c": "Capacity monitoring",
    "choice_d": "Backup validation",
    "correct_answer": "B",
    "explanation": "Configuration management maintains approved system states and detects drift. Incident escalation, capacity monitoring, and backup validation are not related to configuration management, but other functions.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      214,
      193,
      216,
      200,
      228
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 233,
    "question": "Which factor MOST affects consistency of risk scoring across assessments?",
    "choice_a": "Assessor experience",
    "choice_b": "Number of scenarios",
    "choice_c": "Defined scoring criteria",
    "choice_d": "Use of workshops",
    "correct_answer": "C",
    "explanation": "Clearly defined criteria ensure consistent scoring. Assessor experience is helpful, as are workshops and a variety of scenarios, but these all pale in comparison to defined scoring criteria.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      142,
      143,
      144,
      147,
      149
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 234,
    "question": "Which reporting weakness MOST reduces the usefulness of risk information for executive decision\u2011making?",
    "choice_a": "Excessive reliance on heat maps",
    "choice_b": "Presentation of metrics without business context",
    "choice_c": "Use of standardized reporting templates",
    "choice_d": "Inclusion of residual risk ratings",
    "correct_answer": "B",
    "explanation": "Executives require risk information framed in business terms. Metrics presented without context fail to convey operational relevance, making it difficult to assess urgency, prioritize actions, or align decisions with strategic objectives.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      180,
      183,
      182,
      185,
      184
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 235,
    "question": "Which governance mechanism MOST supports alignment between strategy and risk decisions?",
    "choice_a": "Project steering committees",
    "choice_b": "Risk appetite framework",
    "choice_c": "Control catalogs",
    "choice_d": "Incident management procedures",
    "correct_answer": "B",
    "explanation": "Risk appetite links strategic objectives to risk-taking boundaries. Project steering committees, control catalogs, and incident management procedures are not governance mechanisms.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      116,
      126,
      123,
      115,
      117
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 236,
    "question": "Which principle ensures that information is accurate and complete?",
    "choice_a": "Availability",
    "choice_b": "Confidentiality",
    "choice_c": "Integrity",
    "choice_d": "Accountability",
    "correct_answer": "C",
    "explanation": "Integrity addresses the accuracy and completeness of information. Confidentiality is concerned with authorized access to information. Availability concerns users\u2019 ability to access information on demand, while accountability is a cultural characteristic.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      223,
      231,
      230,
      208,
      227
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 237,
    "question": "Which issue MOST undermines the reliability of quantitative risk analysis?",
    "choice_a": "Scenario variability",
    "choice_b": "Poor data quality",
    "choice_c": "Model documentation",
    "choice_d": "Executive review",
    "correct_answer": "B",
    "explanation": "Quantitative outputs are only as reliable as the underlying data. Scenario variability does not affect the reliability of risk analysis, nor does model documentation or executive review.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      146,
      147,
      159,
      157,
      142
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 238,
    "question": "Which input is MOST important when determining compensating controls?",
    "choice_a": "Control cost",
    "choice_b": "Threat sophistication",
    "choice_c": "Residual risk exposure",
    "choice_d": "Audit scope",
    "correct_answer": "C",
    "explanation": "Compensating controls are selected to reduce unacceptable residual risk. While residual risk is primary, other factors may shape feasibility.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      173,
      181,
      161,
      176,
      171
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 239,
    "question": "Which condition MOST weakens accountability for IT risk decisions?",
    "choice_a": "Distributed risk ownership",
    "choice_b": "Documented escalation paths",
    "choice_c": "Undefined approval authority",
    "choice_d": "Periodic reporting",
    "correct_answer": "C",
    "explanation": "Without clear authority, accountability for decisions is weakened. Distributed risk ownership may also undermine accountability, as individuals may try to shift it to others. Escalation paths and reporting are not related to risk decision accountability.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      117,
      123,
      125,
      120,
      119
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 240,
    "question": "Which practice MOST improves resilience of critical IT services?",
    "choice_a": "Vulnerability scanning",
    "choice_b": "Redundancy design",
    "choice_c": "Log correlation",
    "choice_d": "Asset tagging",
    "correct_answer": "B",
    "explanation": "Redundancy reduces single points of failure. Vulnerability scanning may contribute to resilience if the organization remediates vulnerabilities, but is not the best answer. Log correlation may help an organization respond more quickly to events, but it is also not the best answer. Asset tagging has little or no impact on resilience.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      242,
      240,
      203,
      207,
      194
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 241,
    "question": "Which element represents the business consequence of a risk event?",
    "choice_a": "Impact",
    "choice_b": "Vulnerability",
    "choice_c": "Threat",
    "choice_d": "Likelihood",
    "correct_answer": "A",
    "explanation": "Impact describes the consequence to the business. Vulnerability, threat, and likelihood may contribute to the magnitude of a risk event, but none of them describes its consequences.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      132,
      142,
      138,
      148,
      151
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 242,
    "question": "Which artifact MOST supports monitoring progress of risk treatments?",
    "choice_a": "Risk profile",
    "choice_b": "Risk treatment plan",
    "choice_c": "Audit charter",
    "choice_d": "Asset inventory",
    "correct_answer": "B",
    "explanation": "Treatment plans track actions, timelines, and responsibilities. A risk profile over time does not indicate any progress in risk treatment. Audit charters define audit programs, which are unrelated to risk treatment. Asset inventories, while important, also do not support risk treatment monitoring.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      181,
      180,
      179,
      167,
      162
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 243,
    "question": "Which practice MOST strengthens risk-aware decision-making?",
    "choice_a": "Detailed technical metrics",
    "choice_b": "Automated controls",
    "choice_c": "Increased audit frequency",
    "choice_d": "Regular executive risk discussions",
    "correct_answer": "D",
    "explanation": "Executive engagement reinforces risk-informed behavior. Technical metrics and automated controls have little to do with risk-aware decisions. Increased audit frequency is likewise unrelated.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      118,
      116,
      115,
      117,
      126
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 244,
    "question": "Which factor MOST complicates secure SDLC governance?",
    "choice_a": "Open-source IDEs",
    "choice_b": "Agile development velocity",
    "choice_c": "Formal documentation",
    "choice_d": "Centralized repositories",
    "correct_answer": "B",
    "explanation": "Rapid iterations in Agile can outpace control and review processes. IDEs are not related to SDLC governance processes. Formal documentation and centralized repositories can simplify SDLC governance.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      200,
      213,
      214,
      228,
      212
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 245,
    "question": "Which technique BEST supports the identification of emerging threats?",
    "choice_a": "Asset valuation",
    "choice_b": "Threat intelligence analysis",
    "choice_c": "Control self-assessments",
    "choice_d": "Impact scoring",
    "correct_answer": "B",
    "explanation": "Threat intelligence identifies new and evolving threats. Asset valuation is unrelated to emerging threats. Control self-assessments and impact scoring are not designed to identify emerging threats.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      150,
      156,
      133,
      132,
      143
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 246,
    "question": "Which response option acknowledges risk without further action?",
    "choice_a": "Risk mitigation",
    "choice_b": "Risk transfer",
    "choice_c": "Risk acceptance",
    "choice_d": "Risk avoidance",
    "correct_answer": "C",
    "explanation": "Acceptance formally acknowledges residual risk. All other choices involve some form of action.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      161,
      160,
      171,
      181,
      180
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 247,
    "question": "Which governance gap MOST increases the likelihood of unmanaged risk accumulation?",
    "choice_a": "Formal reporting cycles",
    "choice_b": "Undefined risk aggregation rules",
    "choice_c": "Risk appetite approval",
    "choice_d": "Independent assurance",
    "correct_answer": "B",
    "explanation": "Without aggregation rules, cumulative exposure may go unnoticed. Formal reporting cycles, risk appetite approvals, and independent assurance are unrelated to the accumulation of unmanaged risk.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      120,
      123,
      125,
      119,
      127
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 248,
    "question": "Which practice MOST reduces risk from obsolete systems?",
    "choice_a": "Patch management",
    "choice_b": "Technology lifecycle management",
    "choice_c": "Incident response",
    "choice_d": "Log analysis",
    "correct_answer": "B",
    "explanation": "Lifecycle management addresses obsolescence and end-of-support risk. Patch management may not reduce risk, as patches are often unavailable for obsolete systems. Incident response and log analysis do not change the risks associated with obsolete systems.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      197,
      191,
      216,
      193,
      225
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 249,
    "question": "Which factor MOST influences the development of realistic risk scenarios?",
    "choice_a": "Business process understanding",
    "choice_b": "Asset book value",
    "choice_c": "Control maturity scores",
    "choice_d": "Audit findings",
    "correct_answer": "A",
    "explanation": "Understanding business processes grounds scenarios in reality. Asset value should have little to do with scenario development. Control maturity scores and audit findings, while important in security governance, do little if anything to influence scenario development.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      138,
      133,
      154,
      151,
      142
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 250,
    "question": "Which condition MOST indicates ineffective KRI design?",
    "choice_a": "Thresholds aligned to appetite",
    "choice_b": "Manual data collection",
    "choice_c": "Metrics unrelated to risk drivers",
    "choice_d": "Periodic review",
    "correct_answer": "C",
    "explanation": "KRIs must reflect underlying risk drivers to be meaningful. Thresholds aligned to appetite should improve KRI design. Manual data collection is related to the efficiency (and perhaps accuracy) of KRI design. Periodic review (of what?) is unrelated, as this answer is unclear.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      185,
      179,
      184,
      182,
      186
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 251,
    "question": "Which function provides an independent evaluation of governance effectiveness?",
    "choice_a": "Risk management",
    "choice_b": "Compliance",
    "choice_c": "Internal audit",
    "choice_d": "IT operations",
    "correct_answer": "C",
    "explanation": "Internal audit independently evaluates governance and controls. Risk management, compliance, and IT operations are not independent of governance.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      125,
      123,
      117,
      115,
      119
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 252,
    "question": "Which activity MOST supports early detection of security incidents?",
    "choice_a": "Backup testing",
    "choice_b": "Continuous monitoring",
    "choice_c": "Change approvals",
    "choice_d": "Capacity planning",
    "correct_answer": "B",
    "explanation": "Continuous monitoring enables timely detection. Backup testing confirms that data can be restored. Change approvals are authorizations for system or network changes. Capacity planning ensures sufficient computing resources.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      194,
      234,
      225,
      193,
      204
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 253,
    "question": "Which issue MOST limits the effectiveness of scenario-based risk assessments?",
    "choice_a": "Limited stakeholder participation",
    "choice_b": "Overly detailed narratives",
    "choice_c": "Use of impact scales",
    "choice_d": "Scenario prioritization",
    "correct_answer": "A",
    "explanation": "Without stakeholder input, scenarios may miss key assumptions. Impact scales and scenario prioritization improve their effectiveness. Overly detailed narratives also limit effectiveness, but less so than the lack of stakeholder involvement.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      138,
      143,
      144,
      140,
      159
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 254,
    "question": "Which practice MOST improves transparency of risk response decisions?",
    "choice_a": "Informal agreements",
    "choice_b": "Documented approvals",
    "choice_c": "Verbal briefings",
    "choice_d": "Control automation",
    "correct_answer": "B",
    "explanation": "Documentation provides traceability and accountability. Informal agreements and verbal-only briefings inhibit transparency. Control automation is not relevant.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      161,
      162,
      181,
      180,
      167
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 255,
    "question": "Which mechanism MOST supports consistent escalation of IT risks?",
    "choice_a": "Ad hoc reporting",
    "choice_b": "Asset inventories",
    "choice_c": "Defined risk thresholds",
    "choice_d": "Incident logs",
    "correct_answer": "C",
    "explanation": "Thresholds trigger escalation consistently. Ad hoc reporting and incident logs do not support consistent escalation. Asset inventories that include asset-criticality scoring can help, but they are not the best answer.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      120,
      119,
      127,
      124,
      125
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 256,
    "question": "Which principle focuses on protecting information from unauthorized disclosure?",
    "choice_a": "Integrity",
    "choice_b": "Availability",
    "choice_c": "Confidentiality",
    "choice_d": "Resilience",
    "correct_answer": "C",
    "explanation": "Confidentiality prevents unauthorized access. The principle of integrity emphasizes protection from unauthorized modification. The principle of availability emphasizes the ability to access data and systems on demand, while resilience emphasizes systems continuing to operate properly despite disruptive events.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      223,
      244,
      231,
      209,
      230
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 257,
    "question": "Which output BEST supports executive comparison of disparate risks?",
    "choice_a": "Technical vulnerability lists",
    "choice_b": "Incident timelines",
    "choice_c": "Control descriptions",
    "choice_d": "Aggregated risk ratings",
    "correct_answer": "D",
    "explanation": "Aggregated ratings enable comparison. Technical vulnerability lists, incident timelines, and control descriptions represent management-level information, not executive-level information, and do little if anything to support executive comparison of risks.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      138,
      149,
      147,
      142,
      151
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 258,
    "question": "Which activity MOST supports validation of risk acceptance decisions?",
    "choice_a": "Audit planning",
    "choice_b": "Residual risk review",
    "choice_c": "Policy approval",
    "choice_d": "Control implementation",
    "correct_answer": "B",
    "explanation": "Reviewing residual risk confirms acceptability and establishes an overall plan for all accepted risks to be periodically reviewed. Audit planning, policy approval, and control implementation do not support this.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      161,
      181,
      179,
      180,
      167
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 259,
    "question": "Which governance weakness MOST likely results in conflicting risk decisions?",
    "choice_a": "Centralized reporting",
    "choice_b": "Multiple uncoordinated decision authorities",
    "choice_c": "Board oversight",
    "choice_d": "Formal risk appetite",
    "correct_answer": "B",
    "explanation": "Uncoordinated authorities lead to inconsistency. Centralized reporting, board oversight, and formal risk appetite all help prevent conflicting risk decisions by improving transparency.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      117,
      115,
      123,
      125,
      119
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 260,
    "question": "Which practice MOST reduces risk from misconfigured cloud services?",
    "choice_a": "Secure baseline templates",
    "choice_b": "Manual reviews",
    "choice_c": "Incident drills",
    "choice_d": "Capacity testing",
    "correct_answer": "A",
    "explanation": "Baseline templates enforce secure configurations. Manual reviews can be helpful, but do not scale for large environments. Incident drills and capacity testing are unrelated topics.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      213,
      215,
      220,
      225,
      224
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 261,
    "question": "Which term describes the combination of likelihood and impact?",
    "choice_a": "Exposure",
    "choice_b": "Risk",
    "choice_c": "Threat",
    "choice_d": "Control",
    "correct_answer": "B",
    "explanation": "Risk reflects likelihood and impact combined. Exposure contributes to likelihood, but not to impact. Threat refers to an attack technique. A control is a safeguard to protect assets.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      132,
      142,
      146,
      147,
      152
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 262,
    "question": "Which failure MOST undermines confidence in risk treatment effectiveness?",
    "choice_a": "Delayed reporting",
    "choice_b": "Lack of success metrics",
    "choice_c": "Executive oversight",
    "choice_d": "Control redundancy",
    "correct_answer": "B",
    "explanation": "Without metrics and other feedback mechanisms, effectiveness cannot be demonstrated. Delayed reporting and poor oversight also contribute, but are not the best answers.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      179,
      184,
      186,
      180,
      181
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 263,
    "question": "Which practice MOST supports alignment of IT risk with ERM?",
    "choice_a": "Independent assessments",
    "choice_b": "Shared risk taxonomy",
    "choice_c": "Separate reporting lines",
    "choice_d": "Technical dashboards",
    "correct_answer": "B",
    "explanation": "Shared taxonomy enables integration among risk programs. Independent assessments and separate reporting lines do not support alignment. Technical dashboards operate below the ERM level and are not relevant.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      123,
      124,
      125,
      116,
      119
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 264,
    "question": "Which control MOST directly supports data minimization?",
    "choice_a": "Data retention schedules",
    "choice_b": "Encryption",
    "choice_c": "Access logging",
    "choice_d": "Network segmentation",
    "correct_answer": "A",
    "explanation": "Retention schedules limit unnecessary data storage. Encryption does not support data minimization as the data remains in an organization\u2019s custody. Access logging and network segmentation are not related to data minimization or retention.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      208,
      210,
      243,
      247,
      248
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 265,
    "question": "Which issue MOST complicates estimation of secondary risk impacts?",
    "choice_a": "Direct financial losses",
    "choice_b": "Reputational damage",
    "choice_c": "Asset valuation",
    "choice_d": "Control testing",
    "correct_answer": "B",
    "explanation": "Reputational impacts are difficult to predict and quantify. Control testing is an operational activity and is unrelated. Direct financial losses and asset valuations are easier to estimate than secondary effects.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      138,
      142,
      146,
      147,
      151
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 266,
    "question": "Which role is accountable for monitoring KRIs?",
    "choice_a": "Internal audit",
    "choice_b": "Control owner",
    "choice_c": "Risk owner",
    "choice_d": "Project manager",
    "correct_answer": "C",
    "explanation": "Risk owners monitor indicators related to their risks. Internal audit is an assurance function and does not monitor key indicators (except in the context of a specific audit). Control owners may have an interest in KRIs but are not accountable for monitoring them. Project managers are not accountable for monitoring key indicators and metrics, except for those related to the projects they manage.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      162,
      185,
      179,
      181,
      180
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 267,
    "question": "Which concept defines the maximum risk an organization can bear?",
    "choice_a": "Risk appetite",
    "choice_b": "Risk tolerance",
    "choice_c": "Risk capacity",
    "choice_d": "Risk profile",
    "correct_answer": "C",
    "explanation": "Risk capacity is the upper limit of risk absorption in an organization. Risk appetite represents the overall acceptable level of risk for a given business activity. Risk tolerance represents the acceptable variation from risk appetite. A risk profile represents data on identified risks.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      126,
      116,
      123,
      124,
      125
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 268,
    "question": "Which condition MOST increases the risk of data leakage?",
    "choice_a": "Centralized access logging",
    "choice_b": "Inconsistent data classification",
    "choice_c": "Encryption in transit",
    "choice_d": "Regular access reviews",
    "correct_answer": "B",
    "explanation": "Inconsistent classification leads to improper handling. Centralized access logging can aid in access investigations but does not influence data leakage risk. Encryption in transit and regular access reviews can reduce the risk of data leakage in some cases.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      209,
      208,
      245,
      244,
      230
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 269,
    "question": "Which factor MOST affects prioritization of identified vulnerabilities?",
    "choice_a": "Number of affected systems",
    "choice_b": "Asset age",
    "choice_c": "Patch availability",
    "choice_d": "Exploitability and impact",
    "correct_answer": "D",
    "explanation": "Prioritization depends on exploitability and business impact. The number of affected systems, their age, and the availability of patches should have little or no influence on vulnerability priorities.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      149,
      142,
      146,
      147,
      152
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 270,
    "question": "Which reporting characteristic MOST supports effective decision-making?",
    "choice_a": "Timeliness and relevance",
    "choice_b": "High granularity",
    "choice_c": "Technical completeness",
    "choice_d": "Historical detail",
    "correct_answer": "A",
    "explanation": "Decision-makers need timely, relevant information. Historical detail, high granularity, and technical completeness may help, but are not the most supportive factors.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      180,
      182,
      183,
      184,
      185
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 271,
    "question": "Which governance failure MOST reduces the effectiveness of the three lines of defense?",
    "choice_a": "Overlapping responsibilities",
    "choice_b": "Formal charters",
    "choice_c": "Independent assurance",
    "choice_d": "Clear reporting lines",
    "correct_answer": "A",
    "explanation": "Overlap blurs accountability and independence. Formal charters, independent assurance, and clear reporting lines all help improve the effectiveness of the three lines of defense.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      125,
      117,
      119,
      115,
      123
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 272,
    "question": "Which activity MOST supports recovery time objectives?",
    "choice_a": "Capacity planning",
    "choice_b": "Disaster recovery testing",
    "choice_c": "Vulnerability scanning",
    "choice_d": "Change approvals",
    "correct_answer": "B",
    "explanation": "Testing validates recovery capabilities within agreed-upon timelines. Capacity planning, vulnerability scanning, and change approvals are largely irrelevant to recovery time objectives (RTOs).",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      206,
      205,
      241,
      202,
      240
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 273,
    "question": "Which practice MOST improves completeness of risk identification?",
    "choice_a": "Technical scanning",
    "choice_b": "Asset tagging",
    "choice_c": "Control assessments",
    "choice_d": "Cross-functional workshops",
    "correct_answer": "D",
    "explanation": "Cross-functional input broadens risk identification by involving a diverse set of stakeholders. By themselves, technical scanning, asset tagging, and control assessments support risk identification, but are not the best answer.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      140,
      136,
      131,
      143,
      144
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 274,
    "question": "Which issue MOST undermines the effectiveness of risk dashboards?",
    "choice_a": "Too many metrics",
    "choice_b": "Visual summaries",
    "choice_c": "Alignment to appetite",
    "choice_d": "Trend indicators",
    "correct_answer": "A",
    "explanation": "Excess metrics obscure key signals. Visual summaries, alignment to appetite, and trend indicators can all support risk dashboards.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      183,
      185,
      182,
      179,
      180
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 275,
    "question": "Which artifact MOST supports governance consistency across business units?",
    "choice_a": "Local procedures",
    "choice_b": "Enterprise risk policy",
    "choice_c": "Incident reports",
    "choice_d": "Asset inventories",
    "correct_answer": "B",
    "explanation": "Enterprise policies establish consistent expectations. Local procedures inhibit consistency, while incident reports and asset inventories may provide some support for governance.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      119,
      115,
      123,
      116,
      125
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 276,
    "question": "Which practice ensures that systems can be restored to a known-good state?",
    "choice_a": "Patch testing",
    "choice_b": "Configuration backups",
    "choice_c": "Log monitoring",
    "choice_d": "Access reviews",
    "correct_answer": "B",
    "explanation": "Configuration backups enable restoration. Patch testing, log monitoring, and access reviews are not related to system restoration.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      194,
      205,
      206,
      207,
      240
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 277,
    "question": "Which analysis BEST supports the understanding of threat actor behavior?",
    "choice_a": "Business impact analysis",
    "choice_b": "Risk scoring",
    "choice_c": "Control testing",
    "choice_d": "Threat modeling",
    "correct_answer": "D",
    "explanation": "Threat modeling examines adversary behavior and paths. Business impact analysis is used to prioritize business processes. Risk scoring is used to distinguish between larger and smaller risks. Control testing is used to assess a control\u2019s effectiveness.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      133,
      132,
      142,
      143,
      148
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 278,
    "question": "Which activity MOST supports continuous improvement of event management?",
    "choice_a": "Annual assessments",
    "choice_b": "Post-incident reviews",
    "choice_c": "Policy publication",
    "choice_d": "Control automation",
    "correct_answer": "B",
    "explanation": "Post-incident reviews identify lessons learned and support continuous improvement when those reviews result in action items to improve systems and/or processes. Annual assessments would be a potential indicator of improvements. Policy publication is unrelated. Control automation may make controls more efficient or effective, or both, but it is only a segment of the full range of potential improvements.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      179,
      187,
      177,
      180,
      167
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 279,
    "question": "Which governance outcome MOST indicates mature risk management?",
    "choice_a": "Extensive documentation",
    "choice_b": "Frequent audits",
    "choice_c": "Risk-informed strategic decisions",
    "choice_d": "Detailed control testing",
    "correct_answer": "C",
    "explanation": "Maturity is reflected when risk meaningfully informs strategy. Documentation is an artifact of governance, not an outcome. Audits are an assurance activity, not a governance activity. Detailed control testing is an operational discipline, not a governance activity.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      116,
      123,
      126,
      115,
      120
    ],
    "source": "373666_PracticeExam1"
  },
  {
    "id": 280,
    "question": "Which element MOST clearly establishes who can formally accept risk on behalf of the organization?",
    "choice_a": "Risk taxonomy",
    "choice_b": "Risk register",
    "choice_c": "Risk acceptance authority",
    "choice_d": "Risk appetite statement",
    "correct_answer": "C",
    "explanation": "Risk acceptance authority defines who is empowered to approve acceptance decisions.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      117,
      119,
      123,
      125,
      126
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 281,
    "question": "Which factor MOST determines whether a risk response should be revised?",
    "choice_a": "Control ownership",
    "choice_b": "Residual risk trend",
    "choice_c": "Audit cycle timing",
    "choice_d": "Reporting frequency",
    "correct_answer": "B",
    "explanation": "Changes in residual risk indicate whether the response remains effective. This is why risks should not be accepted in perpetuity. Audit cycles and reporting frequency have less to do with risk response revisions. Control ownership is not relevant.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      161,
      181,
      179,
      180,
      166
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 282,
    "question": "Which activity MOST improves identification of non-obvious risk scenarios?",
    "choice_a": "Scenario brainstorming workshops",
    "choice_b": "Control testing",
    "choice_c": "Asset inventory review",
    "choice_d": "Vulnerability scanning",
    "correct_answer": "A",
    "explanation": "Workshops encourage exploration of indirect and compound scenarios. Reviews of asset inventory, control testing, and vulnerability scans are less likely to reveal new risk scenarios (although they can).",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      140,
      138,
      133,
      143,
      144
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 283,
    "question": "Which practice MOST reduces operational risk from undocumented system dependencies?",
    "choice_a": "Configuration management databases",
    "choice_b": "Incident simulations",
    "choice_c": "Penetration testing",
    "choice_d": "Change freeze windows",
    "correct_answer": "A",
    "explanation": "Configuration databases document dependencies and relationships by modeling configuration items (CIs) and explicitly defining how those items are connected within the environment. Penetration testing and change freeze windows are unrelated. Incident simulations may reveal undocumented dependencies but have no impact on risk.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      192,
      195,
      214,
      193,
      194
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 284,
    "question": "Which situation BEST indicates a disconnect between governance structure and risk outcomes?",
    "choice_a": "Formal risk committees exist",
    "choice_b": "Risk metrics are reported regularly",
    "choice_c": "Policies are not formally reviewed",
    "choice_d": "Repeated risk decisions are reversed",
    "correct_answer": "D",
    "explanation": "Repeated reversals suggest unclear authority or misaligned governance. Policies that are not formally reviewed may contribute to a disconnect. Formal risk committees and metrics reported regularly do not indicate a disconnect.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      115,
      117,
      119,
      120,
      125
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 285,
    "question": "Which response option reduces the likelihood of a risk event occurring?",
    "choice_a": "Mitigation",
    "choice_b": "Avoidance",
    "choice_c": "Acceptance",
    "choice_d": "Transfer",
    "correct_answer": "A",
    "explanation": "Mitigation reduces likelihood and/or impact through controls. Mitigation is one of four risk treatment options (accept, avoid, mitigate, transfer). Avoidance may also reduce the likelihood, though this requires discontinuing the related activity.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      160,
      171,
      173,
      176,
      181
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 286,
    "question": "Which weakness MOST undermines the credibility of likelihood scoring?",
    "choice_a": "Use of ordinal scales",
    "choice_b": "Infrequent executive review",
    "choice_c": "Inconsistent threat assumptions",
    "choice_d": "Scenario documentation",
    "correct_answer": "C",
    "explanation": "Inconsistent assumptions distort probability estimates. At best, probability estimates are educated guesses, not often backed by reliable data. Ordinal scales are appropriate for ranking but not for likelihood scoring; still, this is not the best answer. Infrequent executive reviews may or may not be okay, depending on the overall governance program. Scenario documentation aids in likelihood scoring credibility.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      147,
      142,
      157,
      159,
      138
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 287,
    "question": "Which concept ensures that systems are protected against unauthorized modification?",
    "choice_a": "Availability",
    "choice_b": "Integrity",
    "choice_c": "Confidentiality",
    "choice_d": "Resilience",
    "correct_answer": "B",
    "explanation": "Integrity protects against unauthorized changes. Integrity is part of the CIA triad\u2014confidentiality, integrity, and availability\u2014the pillars of information security.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      223,
      231,
      230,
      208,
      227
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 288,
    "question": "Which governance practice MOST supports escalation of cross-functional IT risks?",
    "choice_a": "Centralized risk aggregation",
    "choice_b": "Local risk registers",
    "choice_c": "Departmental dashboards",
    "choice_d": "Technical incident logs",
    "correct_answer": "A",
    "explanation": "Central aggregation enables enterprise-level escalation. Aggregation is the practice of combining risks associated with an asset, yielding the total risk across all identified forms. Local risk registers do not support risk escalation as much as a single, centralized risk register. Department dashboards reinforce silos, which don\u2019t help with escalations. Technical incident logs are not relevant.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      120,
      123,
      125,
      119,
      127
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 289,
    "question": "Which factor MOST influences the selection of KRIs?",
    "choice_a": "Data availability",
    "choice_b": "Risk driver relevance",
    "choice_c": "Reporting format",
    "choice_d": "Control ownership",
    "correct_answer": "B",
    "explanation": "Key risk indicators (KRIs) must directly reflect underlying risk drivers, the risks that executives care most about. Data availability may also influence KRI selection, but risk driver relevance is a better answer. Reporting format and control ownership are less relevant, if at all.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      185,
      179,
      184,
      176,
      182
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 290,
    "question": "Which element describes the cause of a potential loss?",
    "choice_a": "Impact",
    "choice_b": "Risk",
    "choice_c": "Exposure",
    "choice_d": "Threat",
    "correct_answer": "D",
    "explanation": "Threats are potential causes of harm. Impact is a description of the harm.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      132,
      133,
      142,
      148,
      152
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 291,
    "question": "Which condition MOST increases recovery risk despite documented disaster recovery plans?",
    "choice_a": "Regular testing",
    "choice_b": "Updated runbooks",
    "choice_c": "Manual recovery procedures",
    "choice_d": "Defined recovery objectives",
    "correct_answer": "C",
    "explanation": "Manual recovery procedures increase recovery risk because they rely on human execution under stress, increasing the likelihood of errors, delays, and inconsistent outcomes, even when plans are well documented. In contrast, regular testing validates recovery capabilities and reduces uncertainty, updated runbooks improve accuracy and consistency by reflecting current environments, and defined recovery objectives (RTOs and RPOs) provide clear targets that guide effective recovery planning. These factors strengthen recovery readiness rather than undermine it, making heavy dependence on manual steps the primary risk-increasing condition.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      204,
      206,
      205,
      240,
      242
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 292,
    "question": "Which artifact MOST directly links IT risk oversight to corporate governance?",
    "choice_a": "Board risk charter",
    "choice_b": "IT policies",
    "choice_c": "Control test reports",
    "choice_d": "Asset inventories",
    "correct_answer": "A",
    "explanation": "A board risk charter most directly links IT risk oversight to corporate governance by formally defining the board\u2019s authority, responsibilities, and expectations for risk oversight, including technology and information risk. IT policies operationalize management intent but do not establish governance accountability, control test reports provide assurance evidence rather than governance linkage, and asset inventories support risk identification but have no governance function.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      115,
      117,
      119,
      123,
      125
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 293,
    "question": "Which failure MOST undermines confidence in reported risk reduction?",
    "choice_a": "Unverified control effectiveness claims",
    "choice_b": "Qualitative scoring",
    "choice_c": "Conservative assumptions",
    "choice_d": "Automated dashboards",
    "correct_answer": "A",
    "explanation": "Unverified control effectiveness claims most undermine confidence in reported risk reduction because reductions must be supported by evidence that controls actually operate as intended and achieve their objectives. Qualitative scoring can be acceptable when applied consistently and transparently, conservative assumptions may overstate risk but do not invalidate reported reductions, and automated dashboards are presentation tools whose reliability depends on underlying data. Without validation through testing or assurance, claimed risk reduction lacks credibility regardless of how it is reported.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      177,
      179,
      178,
      176,
      182
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 294,
    "question": "Which factor MOST influences prioritization of identified risk scenarios?",
    "choice_a": "Number of vulnerabilities",
    "choice_b": "Control documentation quality",
    "choice_c": "Business impact severity",
    "choice_d": "Audit history",
    "correct_answer": "C",
    "explanation": "Business impact severity most strongly influences prioritization because risk scenarios that threaten critical operations, strategic objectives, or significant financial or reputational harm demand attention regardless of the number of underlying issues. While likelihood is also considered, impact severity typically drives which risk scenarios are addressed first. The number of vulnerabilities does not directly indicate risk magnitude; control documentation quality affects assurance, but not scenario criticality; and audit history reflects past findings rather than current business exposure.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      138,
      142,
      149,
      151,
      152
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 295,
    "question": "Which SDLC practice MOST reduces the introduction of architectural weaknesses?",
    "choice_a": "Code reviews",
    "choice_b": "Secure design principles",
    "choice_c": "Patch management",
    "choice_d": "Regression testing",
    "correct_answer": "B",
    "explanation": "Secure design addresses weaknesses before implementation. This is a part of \u201cshift left,\u201d in which information security is involved earlier in the SDLC process. By following secure design principles, a system is less likely to contain vulnerabilities. Code reviews and regression testing detect defects after design decisions are made, limiting their ability to address fundamental architectural issues, whereas patch management addresses weaknesses only after deployment.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      213,
      215,
      217,
      212,
      211
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 296,
    "question": "Which document defines acceptable boundaries for risk-taking?",
    "choice_a": "Risk tolerance matrix",
    "choice_b": "Risk profile",
    "choice_c": "Risk register",
    "choice_d": "Risk appetite statement",
    "correct_answer": "D",
    "explanation": "Risk appetite defines acceptable risk boundaries by guiding executives on which risks may be accepted and which may not.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      126,
      116,
      123,
      119,
      118
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 297,
    "question": "Which activity MOST supports accountability for overdue risk treatments?",
    "choice_a": "Risk dashboards with due dates",
    "choice_b": "Audit findings",
    "choice_c": "Policy reviews",
    "choice_d": "Control catalogs",
    "correct_answer": "A",
    "explanation": "Dashboards with timelines expose overdue actions. Follow-up keeps attention on risk treatment tasks. Audit findings identify issues but do not provide ongoing tracking of remediation commitments, policy reviews assess governance adequacy rather than execution, and control catalogs document controls without monitoring whether risk treatments are completed on time.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      183,
      179,
      181,
      162,
      167
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 298,
    "question": "Which issue MOST limits the usefulness of historical loss data?",
    "choice_a": "Incomplete incident logging",
    "choice_b": "Lack of normalization",
    "choice_c": "Data volume",
    "choice_d": "Qualitative impact ratings",
    "correct_answer": "A",
    "explanation": "Missing events skew historical analysis. If incidents are not consistently logged, the historical loss dataset is not representative, which can significantly distort frequency and impact estimates derived from history. Lack of normalization can be corrected analytically, data volume is manageable with appropriate techniques, and qualitative impact ratings may reduce precision but still provide directional insight.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      142,
      146,
      147,
      143,
      150
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 299,
    "question": "Which activity validates that systems can resume operation after failure?",
    "choice_a": "Recovery testing",
    "choice_b": "Backup scheduling",
    "choice_c": "Vulnerability scanning",
    "choice_d": "Log review",
    "correct_answer": "A",
    "explanation": "Recovery testing validates an organization\u2019s ability to recover a system from disruptive events.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      205,
      206,
      202,
      207,
      240
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 300,
    "question": "Which practice MOST reduces ambiguity in risk decision-making?",
    "choice_a": "Informal approvals",
    "choice_b": "Individual discretion",
    "choice_c": "Documented escalation criteria",
    "choice_d": "Technical reporting",
    "correct_answer": "C",
    "explanation": "Clear escalation criteria reduce ambiguity by informing decision makers of the boundaries of risk decisions. Informal approvals and individual discretion increase inconsistency and uncertainty in decision-making, while technical reporting provides information but does not clarify who decides or when escalation is required.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      119,
      117,
      123,
      126,
      125
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 301,
    "question": "Which output MOST supports comparison of alternative risk responses?",
    "choice_a": "Cost-benefit analysis",
    "choice_b": "Control inventories",
    "choice_c": "Audit reports",
    "choice_d": "Incident statistics",
    "correct_answer": "A",
    "explanation": "Cost-benefit analysis supports response selection by revealing the details for each response. Organizations generally gravitate toward risk treatment options that minimize risk at the least cost or effort. Control inventories list existing controls but do not assess response trade-offs, audit reports identify deficiencies rather than compare treatment choices, and incident statistics describe past events without informing the economic or strategic merits of different responses.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      171,
      160,
      181,
      183,
      177
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 302,
    "question": "Which term describes risk remaining after mitigation efforts?",
    "choice_a": "Inherent risk",
    "choice_b": "Accepted risk",
    "choice_c": "Secondary risk",
    "choice_d": "Residual risk",
    "correct_answer": "D",
    "explanation": "Residual risk remains after controls are applied, and it's verified when controls are examined for effectiveness.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      152,
      132,
      135,
      142,
      149
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 303,
    "question": "Which practice MOST reduces risk from unauthorized privileged access?",
    "choice_a": "Privileged access management",
    "choice_b": "Encryption",
    "choice_c": "Network monitoring",
    "choice_d": "Patch testing",
    "correct_answer": "A",
    "explanation": "Privileged access management (PAM) tools and procedures restrict and monitor elevated access. Encryption protects data confidentiality but does not prevent misuse of privileged accounts, network monitoring may detect suspicious activity after access occurs, and patch testing improves system stability rather than access control.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      232,
      231,
      194,
      237,
      234
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 304,
    "question": "Which governance weakness MOST likely leads to inconsistent risk acceptance decisions?",
    "choice_a": "Excessive documentation",
    "choice_b": "Regular reporting",
    "choice_c": "Decentralized risk ownership",
    "choice_d": "Defined risk appetite",
    "correct_answer": "C",
    "explanation": "Decentralization leads to inconsistency when each decision-maker operates in a silo. Excessive documentation may be inefficient, but does not drive inconsistency; regular reporting improves transparency and coordination; and defined risk appetite provides boundaries that promote consistent decisions.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      116,
      117,
      119,
      123,
      125
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 305,
    "question": "Which metric tracks whether controls are functioning as intended?",
    "choice_a": "KPI",
    "choice_b": "SLA",
    "choice_c": "KRI",
    "choice_d": "KCI",
    "correct_answer": "D",
    "explanation": "Key control indicators (KCIs) measure control performance. KRIs portray risk, regardless of controls, and KPIs measure process or system performance. Service level agreements (SLAs) are performance and/or quality commitments to internal or external customers.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      186,
      179,
      184,
      185,
      177
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 306,
    "question": "Which factor MOST affects the completeness of vulnerability analysis?",
    "choice_a": "Asset ownership clarity",
    "choice_b": "Impact scoring",
    "choice_c": "Control documentation",
    "choice_d": "Coverage of scanning tools",
    "correct_answer": "D",
    "explanation": "Limited coverage leaves vulnerabilities unidentified. Scanning coverage depends on knowing which assets exist. Even well-managed assets remain blind spots if vulnerability scanning does not fully cover the environment. Asset ownership clarity supports accountability but does not ensure technical coverage, impact scoring prioritizes findings rather than discovering them, and control documentation describes defenses without revealing unknown weaknesses.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      134,
      143,
      154,
      156,
      157
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 307,
    "question": "Which condition MOST complicates secure data disposal in distributed environments?",
    "choice_a": "Multiple storage locations",
    "choice_b": "Encryption",
    "choice_c": "Centralized policies",
    "choice_d": "Access reviews",
    "correct_answer": "A",
    "explanation": "Distributed storage complicates complete disposal as tasks must be carried out in all locations. The more distributed the data, the harder it is to ensure complete and provable disposal. Encryption can simplify disposal through key destruction; centralized policies improve consistency of disposal requirements; and access reviews control who can reach data, but do not affect how many copies exist.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      210,
      222,
      208,
      245,
      247
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 308,
    "question": "Which governance mechanism MOST supports alignment between IT investment and risk posture?",
    "choice_a": "Capital budgeting committees",
    "choice_b": "Incident escalation",
    "choice_c": "Change management boards",
    "choice_d": "Risk-informed portfolio management",
    "correct_answer": "D",
    "explanation": "Risk-informed portfolios align investment with risk tolerance by incorporating risk exposure, tolerance, and trade-offs into funding and prioritization decisions. Capital budgeting committees may approve spending without an explicit risk context, change management boards focus on operational changes rather than strategic investment alignment, and incident escalation addresses realized events instead of guiding proactive investment choices.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      116,
      126,
      123,
      120,
      124
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 309,
    "question": "Which activity MOST improves the effectiveness of third-party risk responses?",
    "choice_a": "Contract standardization",
    "choice_b": "Insurance coverage",
    "choice_c": "One-time due diligence",
    "choice_d": "Ongoing vendor monitoring",
    "correct_answer": "D",
    "explanation": "Continuous monitoring ensures sustained risk control. Contract standardization makes contract language more consistent across the supplier portfolio. One-time due diligence is appropriate only for very low-risk vendors. Insurance coverage transfers some financial impact without reducing the underlying risk.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      164,
      163,
      179,
      181,
      171
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 310,
    "question": "Which factor MOST limits the accuracy of aggregated enterprise risk views?",
    "choice_a": "Variability in risk scoring scales",
    "choice_b": "Inconsistent scenario definitions and assumptions",
    "choice_c": "Decentralized scenario development across business units",
    "choice_d": "Summarized executive reporting",
    "correct_answer": "B",
    "explanation": "Inconsistent scenario definitions most limit the accuracy of aggregated enterprise risk views because aggregation depends on common assumptions, terminology, and scope. When scenarios are defined differently across units, combined risk measures become misleading. Variability in scoring scales and decentralized scenario development can be managed through standardization and governance, and executive-level reporting summarizes risk rather than distorting it.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      138,
      132,
      142,
      144,
      147
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 311,
    "question": "Which principle focuses on ensuring that authorized users can access systems when needed?",
    "choice_a": "Integrity",
    "choice_b": "Confidentiality",
    "choice_c": "Availability",
    "choice_d": "Authenticity",
    "correct_answer": "C",
    "explanation": "Availability ensures timely access. Availability is part of the CIA triad\u2014confidentiality, integrity, and availability\u2014the pillars of information security.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      223,
      231,
      232,
      230,
      194
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 312,
    "question": "Which role MOST appropriately challenges management risk decisions?",
    "choice_a": "Internal audit",
    "choice_b": "Control owner",
    "choice_c": "System administrator",
    "choice_d": "Project manager",
    "correct_answer": "A",
    "explanation": "In its role as the third line of defense, internal audit provides independent examinations of and challenges to management\u2019s risk decisions. Control owners, system administrators, and project managers are part of management and are responsible for implementing decisions rather than independently evaluating or challenging them.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      125,
      117,
      123,
      116,
      129
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 313,
    "question": "Which failure MOST undermines risk response accountability?",
    "choice_a": "Lack of automation",
    "choice_b": "Unassigned response ownership",
    "choice_c": "Conservative risk appetite",
    "choice_d": "Infrequent reporting",
    "correct_answer": "B",
    "explanation": "Without ownership, responses lack accountability. Clear assignment of ownership is foundational to accountable risk response execution. Lack of automation may reduce efficiency, but does not eliminate responsibility; conservative risk appetite constrains decisions rather than accountability; and infrequent reporting limits visibility but does not remove ownership.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      162,
      181,
      167,
      160,
      180
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 314,
    "question": "Which approach BEST supports identification of cascading risk impacts?",
    "choice_a": "Threat enumeration",
    "choice_b": "Dependency mapping",
    "choice_c": "Control testing",
    "choice_d": "Loss quantification",
    "correct_answer": "B",
    "explanation": "Dependency mapping reveals cascading effects by identifying dependencies on other systems and on access, each with its own risks. Threat enumeration identifies possible causes but not downstream effects, control testing evaluates control performance rather than impact propagation, and loss quantification measures impact magnitude without explaining how impacts cascade.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      148,
      138,
      142,
      144,
      149
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 315,
    "question": "Which practice MOST reduces operational risk from undocumented changes?",
    "choice_a": "Incident reporting",
    "choice_b": "Formal change approval",
    "choice_c": "Log analysis",
    "choice_d": "Asset tagging",
    "correct_answer": "B",
    "explanation": "Change approval prevents undocumented modifications. While change management is primarily an administrative control, systems can sometimes be equipped with tooling to detect configuration changes and compare them to approved changes, with any differences indicating unapproved changes. Incident reporting reacts to problems after they occur, log analysis may detect changes but does not prevent them, and asset tagging identifies assets without governing how they are modified.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      193,
      214,
      192,
      216,
      225
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 316,
    "question": "Which body has ultimate accountability for enterprise risk oversight?",
    "choice_a": "Executive management",
    "choice_b": "Risk committee",
    "choice_c": "Internal audit",
    "choice_d": "Board of directors",
    "correct_answer": "D",
    "explanation": "The board holds ultimate oversight responsibility.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      117,
      115,
      123,
      125,
      116
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 317,
    "question": "Which reporting attribute MOST improves executive comprehension?",
    "choice_a": "Technical precision",
    "choice_b": "Visual aggregation",
    "choice_c": "Raw data access",
    "choice_d": "Control-level detail",
    "correct_answer": "B",
    "explanation": "Aggregated visuals support executive understanding, provided they accurately depict relevant data in a business context. Technical precision, raw data access, and control-level detail are valuable to practitioners but can overwhelm executives and obscure key messages.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      183,
      180,
      184,
      185,
      182
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 318,
    "question": "Which term represents the combination of probability and consequence?",
    "choice_a": "Exposure",
    "choice_b": "Risk",
    "choice_c": "Vulnerability",
    "choice_d": "Threat",
    "correct_answer": "B",
    "explanation": "Risk combines likelihood and impact.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      132,
      142,
      146,
      147,
      152
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 319,
    "question": "Which factor MOST increases the likelihood of misconfigured security controls?",
    "choice_a": "Manual configuration processes",
    "choice_b": "Standardized baselines",
    "choice_c": "Automated validation",
    "choice_d": "Central governance",
    "correct_answer": "A",
    "explanation": "Manual processes are more error-prone than automated processes. Lacking automation, operators can make keying mistakes and also forget to include one or more systems. Standardized baselines promote consistency, automated validation detects and prevents misconfigurations, and central governance enforces uniform requirements and oversight.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      230,
      214,
      213,
      195,
      237
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 320,
    "question": "Which artifact MOST supports transparency of risk trade-off decisions?",
    "choice_a": "Control test plans",
    "choice_b": "Incident reports",
    "choice_c": "Documented risk acceptance rationales",
    "choice_d": "Asset inventories",
    "correct_answer": "C",
    "explanation": "Documented rationales for each risk decision provide traceability and consistency, as risk decisions tend to become precedents. Control test plans focus on assurance activities, incident reports describe realized events rather than decisions, and asset inventories support identification but not decision transparency.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      119,
      123,
      124,
      127,
      120
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 321,
    "question": "Which response option shifts risk consequences to another party?",
    "choice_a": "Mitigation",
    "choice_b": "Acceptance",
    "choice_c": "Avoidance",
    "choice_d": "Sharing",
    "correct_answer": "D",
    "explanation": "Sharing (also known as transfer) shifts consequences contractually to another party, such as a service provider or insurance company.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      160,
      163,
      165,
      171,
      181
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 322,
    "question": "Which factor MOST improves the reliability of impact estimation?",
    "choice_a": "Qualitative descriptors",
    "choice_b": "Likelihood scoring",
    "choice_c": "Control maturity ratings",
    "choice_d": "Business owner input",
    "correct_answer": "D",
    "explanation": "Business owners best understand operational impact because they understand operational dependencies, revenue effects, customer impact, and recovery implications. Qualitative descriptors provide structure but lack specificity; control maturity ratings assess safeguards rather than consequences; and likelihood scoring addresses probability, not impact magnitude.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      151,
      138,
      136,
      142,
      154
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 323,
    "question": "Which activity MOST supports early identification of control failures?",
    "choice_a": "Periodic audits",
    "choice_b": "Incident reviews",
    "choice_c": "Continuous monitoring",
    "choice_d": "Asset discovery",
    "correct_answer": "C",
    "explanation": "Continuous monitoring detects failures sooner than periodic audits and reviews by detecting deviations or breakdowns in near real time. Periodic audits and incident reviews identify issues after a delay, and asset discovery focuses on inventory rather than control performance.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      194,
      228,
      226,
      225,
      206
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 324,
    "question": "Which governance failure MOST likely results in unmanaged risk accumulation?",
    "choice_a": "Regular reporting",
    "choice_b": "Approved policies",
    "choice_c": "Formal oversight committees",
    "choice_d": "Undefined aggregation thresholds",
    "correct_answer": "D",
    "explanation": "Without aggregation thresholds, cumulative exposure is missed or inaccurate because individual risks may appear acceptable in isolation, while their combined exposure exceeds tolerance without triggering escalation. Regular reporting, formal oversight committees, and approved policies all support visibility and control rather than undermining it.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      120,
      123,
      126,
      125,
      119
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 325,
    "question": "Which element MOST supports validation of third-party risk responses?",
    "choice_a": "Contract language",
    "choice_b": "Independent assurance reports",
    "choice_c": "Initial due diligence",
    "choice_d": "Risk acceptance memos",
    "correct_answer": "B",
    "explanation": "Independent assurance validates control effectiveness and is more trusted than vendor assertions. Contract language defines expectations, but does not verify performance; initial due diligence offers only a point-in-time assessment, and risk acceptance memos document decisions rather than validate outcomes.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      164,
      163,
      179,
      177,
      178
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 326,
    "question": "Which analysis MOST supports prioritization of remediation actions?",
    "choice_a": "Vulnerability enumeration",
    "choice_b": "Control mapping",
    "choice_c": "Risk ranking",
    "choice_d": "Asset valuation",
    "correct_answer": "C",
    "explanation": "While practical constraints may affect sequencing, risk ranking provides the primary basis for remediation priority. Vulnerability enumeration lists weaknesses without indicating urgency, control mapping shows coverage relationships but not priority, and asset valuation informs impact assessment without integrating likelihood or overall risk.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      149,
      142,
      147,
      146,
      152
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 327,
    "question": "Which practice ensures that users are aware of security expectations?",
    "choice_a": "Penetration testing",
    "choice_b": "Access reviews",
    "choice_c": "Log monitoring",
    "choice_d": "Security awareness training",
    "correct_answer": "D",
    "explanation": "Training on essential security concepts promotes awareness, particularly because many of these concepts are not intuitive or self-evident.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      238,
      239,
      237,
      229,
      235
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 328,
    "question": "Which mechanism MOST supports consistency of risk decisions across business units?",
    "choice_a": "Enterprise risk criteria",
    "choice_b": "Local discretion",
    "choice_c": "Independent assessments",
    "choice_d": "Technical metrics",
    "correct_answer": "A",
    "explanation": "Common criteria applied across an entire organization help to ensure risk decision consistency. Local discretion increases variability, independent assessments may identify issues but do not enforce uniform decision standards, and technical metrics lack the business context needed for consistent risk decisions.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      119,
      123,
      126,
      115,
      124
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 329,
    "question": "Which condition MOST indicates ineffective monitoring of accepted risks?",
    "choice_a": "Periodic review schedules",
    "choice_b": "Assigned ownership",
    "choice_c": "Documented acceptance",
    "choice_d": "Static risk ratings despite environmental change",
    "correct_answer": "D",
    "explanation": "Accepted risks must be reevaluated as conditions change. Static risk ratings produce blind spots. Periodic review schedules, documented acceptance, and assigned ownership all support ongoing oversight rather than signal failure.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      161,
      162,
      179,
      180,
      188
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 330,
    "question": "Which practice MOST reduces risk associated with unsupported operating systems?",
    "choice_a": "Technology lifecycle governance",
    "choice_b": "Patch management",
    "choice_c": "Vulnerability scanning",
    "choice_d": "Network segmentation",
    "correct_answer": "A",
    "explanation": "Lifecycle governance ensures the timely upgrade or retirement of unsupported systems and applies compensating controls for unsupported systems that cannot be retired. Patch management is ineffective once vendor support ceases, vulnerability scanning identifies issues without the ability to resolve them, and network segmentation can limit exposure but does not address long-term sustainability. For frameworks such as PCI DSS, unsupported components represent a control failure by definition.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      216,
      228,
      234,
      230,
      196
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 331,
    "question": "Which governance practice MOST improves consistency of risk reporting to senior leadership?",
    "choice_a": "Decentralized reporting formats",
    "choice_b": "Common risk rating scales",
    "choice_c": "Technical incident summaries",
    "choice_d": "Control maturity scoring",
    "correct_answer": "B",
    "explanation": "Common scales enable consistent aggregation and comparison of risks across functions and business units. Decentralized reporting formats introduce variability, technical incident summaries focus on operational detail rather than comparable risk levels, and control maturity scoring evaluates controls rather than overall risk.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      120,
      123,
      119,
      125,
      124
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 332,
    "question": "Which document defines actions, owners, and timelines for addressing risk?",
    "choice_a": "Risk analysis",
    "choice_b": "Risk treatment plan",
    "choice_c": "Audit report",
    "choice_d": "Risk appetite statement",
    "correct_answer": "B",
    "explanation": "Risk treatment plans specify how risks will be addressed, by whom, and when. Risk analysis identifies and evaluates risks without prescribing execution details; audit reports document findings and recommendations, but do not manage remediation. Risk appetite statements set boundaries for acceptable risk rather than operational steps.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      181,
      162,
      180,
      166,
      167
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 333,
    "question": "Which factor MOST influences the credibility of vulnerability assessments?",
    "choice_a": "Accuracy of asset inventory",
    "choice_b": "Frequency of scanning",
    "choice_c": "Number of tools used",
    "choice_d": "Reporting format",
    "correct_answer": "A",
    "explanation": "Incomplete asset inventories result in vulnerability blind spots. The number of tools used and frequency of scanning improve coverage only if all assets are known, and reporting format affects presentation rather than assessment validity.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      134,
      143,
      154,
      156,
      157
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 334,
    "question": "Which condition MOST increases the complexity of identity management?",
    "choice_a": "Single sign-on",
    "choice_b": "Role-based access control",
    "choice_c": "Multiple identity stores",
    "choice_d": "Automated provisioning",
    "correct_answer": "C",
    "explanation": "Multiple identity stores complicate data synchronization and governance by requiring the synchronization of identities, credentials, and access rights across systems, increasing inconsistency and administrative overhead. Single sign-on, role-based access control, and automated provisioning simplify identity management by centralizing authentication, standardizing access, and reducing manual effort.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      232,
      231,
      208,
      228,
      191
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 335,
    "question": "Which statement BEST describes risk tolerance?",
    "choice_a": "Acceptable variation around risk appetite",
    "choice_b": "The amount of risk an organization is willing to accept overall",
    "choice_c": "The maximum risk an organization can absorb",
    "choice_d": "The list of prioritized risks",
    "correct_answer": "A",
    "explanation": "Risk tolerance defines the acceptable level of deviation from the stated risk appetite before escalation or corrective action is required.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      126,
      116,
      123,
      125,
      120
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 336,
    "question": "Which activity MOST supports effective escalation of overdue risk actions?",
    "choice_a": "Annual audits",
    "choice_b": "Exception documentation",
    "choice_c": "Policy updates",
    "choice_d": "Risk dashboards with status indicators",
    "correct_answer": "D",
    "explanation": "Dashboards highlight overdue actions for escalation, so management can easily see them and who is responsible, enabling timely management attention and escalation. Annual audits and policy updates occur too infrequently to drive prompt action, and exception documentation records deviations without actively signaling delays.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      183,
      180,
      179,
      185,
      167
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 337,
    "question": "Which term describes a weakness in a system or process?",
    "choice_a": "Threat",
    "choice_b": "Exposure",
    "choice_c": "Impact",
    "choice_d": "Vulnerability",
    "correct_answer": "D",
    "explanation": "Vulnerabilities are weaknesses that can be exploited.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      132,
      134,
      152,
      142,
      143
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 338,
    "question": "Which practice MOST reduces risk from shadow IT?",
    "choice_a": "Network monitoring",
    "choice_b": "Backup testing",
    "choice_c": "Incident drills",
    "choice_d": "Asset discovery and inventory",
    "correct_answer": "D",
    "explanation": "Asset discovery identifies unauthorized systems. Visibility into all assets is a prerequisite for managing and reducing shadow IT risk. Zero-trust goes a step further by requiring all devices to identify themselves to join the network. Network monitoring may detect activity but not establish ownership or control, incident drills test response rather than prevention, and backup testing addresses recoverability, not unauthorized technology use.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      226,
      221,
      234,
      208,
      195
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 339,
    "question": "Which governance factor MOST limits the effectiveness of risk committees?",
    "choice_a": "Ambiguity in decision authority and escalation rights",
    "choice_b": "Routine meeting cadence",
    "choice_c": "Formal committee charters",
    "choice_d": "Structured management reporting",
    "correct_answer": "A",
    "explanation": "Ambiguity in decision authority most limits the effectiveness of risk committees because members may discuss issues without clarity on who can approve actions or enforce outcomes. Routine meeting cadence supports consistency, documented charters define scope and responsibilities, and structured management reporting enables informed discussion.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      117,
      123,
      125,
      119,
      120
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 340,
    "question": "Which metric MOST directly reflects the success of risk mitigation?",
    "choice_a": "Number of controls",
    "choice_b": "Decrease in residual risk",
    "choice_c": "Policy compliance rate",
    "choice_d": "Frequency of audits",
    "correct_answer": "B",
    "explanation": "Effective mitigation reduces residual risk by demonstrating that implemented responses have reduced the level of risk remaining after controls are applied. The number of controls and frequency of audits measure activity, not effectiveness, and policy compliance rate indicates adherence rather than impact on risk exposure.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      181,
      179,
      186,
      185,
      177
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 341,
    "question": "Which activity MOST improves completeness of risk identification across processes?",
    "choice_a": "Cross-functional risk workshops",
    "choice_b": "Technical vulnerability scans",
    "choice_c": "Audit issue reviews",
    "choice_d": "Control testing",
    "correct_answer": "A",
    "explanation": "Workshops capture risks beyond technical scope. Some risks are associated with business processes, documentation, and staff competency. Technical vulnerability scans focus narrowly on systems, audit issue reviews reflect past findings rather than emerging risks, and control testing evaluates existing controls instead of uncovering new risk scenarios.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      140,
      131,
      143,
      138,
      133
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 342,
    "question": "Which principle focuses on preventing unauthorized disclosure of information?",
    "choice_a": "Integrity",
    "choice_b": "Confidentiality",
    "choice_c": "Availability",
    "choice_d": "Accountability",
    "correct_answer": "B",
    "explanation": "Confidentiality protects against unauthorized disclosure. Confidentiality is a part of CIA\u2014confidentiality, integrity, and availability\u2014the three pillars of information security.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      223,
      231,
      245,
      208,
      229
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 343,
    "question": "Which artifact MOST supports traceability of risk decisions?",
    "choice_a": "Audit schedules",
    "choice_b": "Incident response plans",
    "choice_c": "Asset inventories",
    "choice_d": "Risk acceptance records",
    "correct_answer": "D",
    "explanation": "Acceptance records document decisions and rationale. More broadly, records should be required for all risk treatment options (accept, mitigate, transfer, avoid). Incident response plans define actions for events, asset inventories support identification, and audit schedules plan assurance activities, but do not capture decisions.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      124,
      127,
      120,
      119,
      125
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 344,
    "question": "Which issue MOST undermines the effectiveness of third-party risk mitigation?",
    "choice_a": "Standardized contracts",
    "choice_b": "Risk acceptance documentation",
    "choice_c": "Lack of ongoing assurance",
    "choice_d": "Defined SLAs",
    "correct_answer": "C",
    "explanation": "Without ongoing assurance through questionnaires and monitoring, control degradation may go unnoticed. Standardized contracts and defined SLAs set expectations, but do not verify continued performance. Risk acceptance documentation records decisions rather than ensuring mitigation remains effective.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      179,
      163,
      164,
      181,
      177
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 345,
    "question": "Which condition MOST reduces the reliability of qualitative risk scoring?",
    "choice_a": "Narrative descriptions",
    "choice_b": "Subjective interpretation of scales",
    "choice_c": "Workshop facilitation",
    "choice_d": "Risk categorization",
    "correct_answer": "B",
    "explanation": "Subjective scale interpretation causes inconsistency. Scales should be defined and used consistently for reliable risk scoring. Narrative descriptions can add useful context, well-executed workshop facilitation can promote alignment, and risk categorization can support organization rather than distorting scores.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      147,
      142,
      149,
      144,
      145
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 346,
    "question": "Which control MOST directly supports detection of unauthorized access attempts?",
    "choice_a": "Log monitoring",
    "choice_b": "Encryption",
    "choice_c": "Data masking",
    "choice_d": "Backup validation",
    "correct_answer": "A",
    "explanation": "Log monitoring detects access anomalies. Organizations that do not monitor their event logs will be unaware of many forms of attack. Encryption protects data confidentiality, but does not reveal access attempts. Data masking limits data exposure without detecting misuse, and backup validation ensures recoverability rather than relying on access monitoring.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      194,
      230,
      231,
      232,
      225
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 347,
    "question": "Which role is accountable for enterprise risk oversight?",
    "choice_a": "Risk owners",
    "choice_b": "Control owners",
    "choice_c": "IT management",
    "choice_d": "Board of directors",
    "correct_answer": "D",
    "explanation": "The board oversees enterprise risk.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      117,
      123,
      125,
      115,
      116
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 348,
    "question": "Which input MOST influences prioritization of third-party remediation actions?",
    "choice_a": "Contract expiration date",
    "choice_b": "Vendor criticality",
    "choice_c": "Audit frequency",
    "choice_d": "Reporting format",
    "correct_answer": "B",
    "explanation": "Critical vendors pose greater risk. Business impact analysis (BIA) helps identify the most critical processes, some of which are supported or operated by third parties. Contract expiration dates affect timing but not risk magnitude; audit frequency reflects oversight cadence rather than remediation urgency; and reporting format has no bearing on priority.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      163,
      170,
      181,
      162,
      185
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 349,
    "question": "Which factor MOST improves realism of likelihood estimates?",
    "choice_a": "Threat actor capability analysis",
    "choice_b": "Asset valuation",
    "choice_c": "Control documentation",
    "choice_d": "Reporting cadence",
    "correct_answer": "A",
    "explanation": "Threat actor capability analysis informs probability by providing a better understanding of a threat actor\u2019s capabilities and motivations. Asset valuation informs impact rather than likelihood. Control documentation describes safeguards without assessing threat behavior. Reporting cadence affects timeliness, not probability accuracy.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      133,
      142,
      148,
      157,
      147
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 350,
    "question": "Which issue MOST complicates the enforcement of least privilege?",
    "choice_a": "Role-based access models",
    "choice_b": "Dynamic job functions",
    "choice_c": "Central IAM tools",
    "choice_d": "Access reviews",
    "correct_answer": "B",
    "explanation": "Changing roles, as in organizations with dynamic job functions (where personnel move from job to job), complicate access management, eroding the principle of least privilege. Role-based access models, access reviews, and central IAM tools are designed to support least privilege by structuring, reviewing, and managing access.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      232,
      231,
      236,
      237,
      228
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 351,
    "question": "Which practice MOST supports consistent risk acceptance decisions?",
    "choice_a": "Informal management judgment",
    "choice_b": "Defined acceptance criteria",
    "choice_c": "Independent audits",
    "choice_d": "Incident reporting",
    "correct_answer": "B",
    "explanation": "Criteria ensure consistency in risk decisions, even across differing contexts and among different decision makers, by establishing clear thresholds and conditions under which risks may be accepted across the organization. Informal management judgment varies by individual, independent audits assess decisions after the fact, and incident reporting addresses realized events rather than decision standards.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      119,
      126,
      123,
      124,
      120
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 352,
    "question": "Which report MOST supports senior management decision-making?",
    "choice_a": "Technical vulnerability report",
    "choice_b": "Incident logs",
    "choice_c": "Control test scripts",
    "choice_d": "Aggregated risk dashboard",
    "correct_answer": "D",
    "explanation": "Aggregated risk dashboards summarize key risks across an organization.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      183,
      180,
      185,
      179,
      184
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 353,
    "question": "Which activity MOST improves identification of control weaknesses?",
    "choice_a": "Threat intelligence",
    "choice_b": "Control effectiveness testing",
    "choice_c": "Asset discovery",
    "choice_d": "Loss modeling",
    "correct_answer": "B",
    "explanation": "Testing for control effectiveness assesses the effectiveness of tested controls by directly evaluating whether they are designed and operating as intended. Threat intelligence informs potential threats but does not assess internal controls. Asset discovery identifies what must be protected, and loss modeling estimates impact rather than revealing control failures.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      134,
      135,
      143,
      157,
      152
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 354,
    "question": "Which practice MOST supports secure cloud configuration management?",
    "choice_a": "Penetration testing",
    "choice_b": "Manual reviews",
    "choice_c": "Incident response drills",
    "choice_d": "Infrastructure-as-Code baselines",
    "correct_answer": "D",
    "explanation": "Infrastructure-as-Code (IaC) enforces secure, repeatable configurations in a cloud environment by embedding security into automated provisioning. Manual reviews are error-prone and do not scale; incident response drills test preparedness rather than configuration integrity; and penetration testing identifies weaknesses after deployment.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      200,
      215,
      214,
      213,
      228
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 355,
    "question": "Which governance gap MOST increases the risk of unmanaged risk aggregation?",
    "choice_a": "Periodic reporting",
    "choice_b": "Undefined aggregation thresholds",
    "choice_c": "Risk appetite approval",
    "choice_d": "Independent assurance",
    "correct_answer": "B",
    "explanation": "Without thresholds, cumulative (aggregated) risk may be missed because individually acceptable risks can accumulate without triggering escalation or management action. Periodic reporting, risk appetite approval, and independent assurance all support oversight and control rather than undermine it.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      120,
      126,
      123,
      119,
      125
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 356,
    "question": "Which factor MOST affects the effectiveness of risk communication?",
    "choice_a": "Report length",
    "choice_b": "Audience relevance",
    "choice_c": "Technical depth",
    "choice_d": "Reporting tools",
    "correct_answer": "B",
    "explanation": "The content of communication must match an audience\u2019s needs to be relevant and effective. Report length, technical depth, and reporting tools influence presentation but do not determine whether the message is understood or acted upon.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      180,
      183,
      182,
      184,
      185
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 357,
    "question": "Which term refers to the remaining risk after acceptance?",
    "choice_a": "Residual risk",
    "choice_b": "Inherent risk",
    "choice_c": "Secondary risk",
    "choice_d": "Mitigated risk",
    "correct_answer": "A",
    "explanation": "Residual risk is the risk that remains after treatment and may then be formally addressed.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      152,
      132,
      142,
      138,
      149
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 358,
    "question": "Which activity MOST reduces data loss risk during system migrations?",
    "choice_a": "Data classification",
    "choice_b": "Migration testing",
    "choice_c": "Access reviews",
    "choice_d": "Log analysis",
    "correct_answer": "B",
    "explanation": "Migration testing validates the integrity of data migration. Testing must confirm proper data transformation, as well as access and protection. Data classification informs handling requirements, but does not ensure migration integrity; access reviews verify permissions rather than data completeness; and log analysis detects events without preventing migration errors.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      216,
      215,
      223,
      206,
      194
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 359,
    "question": "Which mechanism MOST supports enterprise-wide risk visibility?",
    "choice_a": "Centralized risk register",
    "choice_b": "Local dashboards",
    "choice_c": "Incident response plans",
    "choice_d": "Asset inventories",
    "correct_answer": "A",
    "explanation": "Central risk registers provide enterprise visibility by including all risks in one place.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      123,
      124,
      125,
      127,
      120
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 360,
    "question": "Which factor MOST affects the credibility of risk dashboards used for management decision-making?",
    "choice_a": "Automation of data collection",
    "choice_b": "Use of summarized visualizations",
    "choice_c": "Alignment of thresholds to risk appetite",
    "choice_d": "Timeliness of underlying risk data",
    "correct_answer": "D",
    "explanation": "The timeliness of underlying risk data most affects dashboard credibility, as dashboards must reflect current risk conditions to support decision-making. Summarized visualizations improve comprehension, threshold alignment ensures relevance to appetite, and automation of data collection improves efficiency and consistency.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      183,
      182,
      179,
      180,
      185
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 361,
    "question": "Which factor MOST improves the accuracy of business impact assessments?",
    "choice_a": "Business owner validation",
    "choice_b": "Financial modeling",
    "choice_c": "Technical severity scores",
    "choice_d": "Control maturity ratings",
    "correct_answer": "A",
    "explanation": "As the personnel with the most knowledge of business processes, business owners validate statements of impact. Technical severity scores reflect system issues rather than business effects; financial modeling supports quantification but depends on accurate assumptions; and control maturity ratings assess safeguards rather than impact.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      151,
      138,
      154,
      136,
      142
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 362,
    "question": "Which control ensures that changes are authorized before implementation?",
    "choice_a": "Backup scheduling",
    "choice_b": "Incident response",
    "choice_c": "Vulnerability scanning",
    "choice_d": "Change control",
    "correct_answer": "D",
    "explanation": "The change management process authorizes changes made to business processes and information systems.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      193,
      214,
      230,
      229,
      225
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 363,
    "question": "Which practice MOST improves accountability for risk decisions?",
    "choice_a": "Informal approvals",
    "choice_b": "Audit frequency",
    "choice_c": "Documented decision authority",
    "choice_d": "Risk categorization",
    "correct_answer": "C",
    "explanation": "Documented authority clarifies accountability by identifying the roles or persons authorized to make risk decisions. Informal approvals obscure responsibility, audit frequency evaluates decisions after the fact, and risk categorization organizes risks without assigning accountability.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      117,
      119,
      120,
      125,
      123
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 364,
    "question": "Which activity MOST supports validation of risk mitigation effectiveness?",
    "choice_a": "Policy review",
    "choice_b": "Control testing",
    "choice_c": "Risk identification",
    "choice_d": "Asset valuation",
    "correct_answer": "B",
    "explanation": "Control testing confirms that the mitigation worked as intended by providing evidence that the implemented controls are operating as intended and achieving the desired risk reduction. Policy review assesses documentation, risk identification discovers exposures, and asset valuation estimates impact, but none confirm mitigation performance.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      179,
      177,
      178,
      186,
      184
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 365,
    "question": "Which issue MOST complicates risk comparisons across business units?",
    "choice_a": "Different asset values",
    "choice_b": "Inconsistent scoring methodologies",
    "choice_c": "Risk categorization",
    "choice_d": "Executive reporting",
    "correct_answer": "B",
    "explanation": "Method inconsistency prevents comparison. When risks are scored differently throughout a company, comparing them may yield misleading results. Different asset values are expected and can be normalized, risk categorization supports the organization rather than hindering comparison, and executive reporting summarizes results without causing inconsistency.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      147,
      142,
      146,
      149,
      144
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 366,
    "question": "Which practice MOST reduces risk from maintaining business records in perpetuity?",
    "choice_a": "Encryption",
    "choice_b": "Network monitoring",
    "choice_c": "Access controls",
    "choice_d": "Retention schedules",
    "correct_answer": "D",
    "explanation": "Retention schedules reduce data exposure by limiting how long various data types and datasets are retained. Encryption and access controls protect data while it exists, but do not address over-retention. Network monitoring detects activity without reducing the volume or lifespan of retained data.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      210,
      208,
      229,
      247,
      244
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 367,
    "question": "Which artifact defines roles and responsibilities for risk management?",
    "choice_a": "Risk register",
    "choice_b": "Risk policy",
    "choice_c": "Risk profile",
    "choice_d": "Audit report",
    "correct_answer": "B",
    "explanation": "The enterprise risk policy is the primary document that establishes roles and responsibilities for managing risk; supporting charters and procedures elaborate on these roles and responsibilities.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      119,
      117,
      123,
      125,
      116
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 368,
    "question": "Which factor MOST influences the frequency of KRI monitoring?",
    "choice_a": "Data volume",
    "choice_b": "Reporting tools",
    "choice_c": "Control ownership",
    "choice_d": "Risk volatility",
    "correct_answer": "D",
    "explanation": "Volatile risks require frequent monitoring. Dashboards may include indicators of volatile risks versus others. Data volume affects processing effort but not monitoring cadence, control ownership defines responsibility rather than frequency, and reporting tools enable monitoring without dictating how often it occurs.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      185,
      179,
      183,
      188,
      184
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 369,
    "question": "Which analysis MOST supports prioritization of control improvements?",
    "choice_a": "Asset valuation",
    "choice_b": "Loss history",
    "choice_c": "Gap analysis",
    "choice_d": "Scenario enumeration",
    "correct_answer": "C",
    "explanation": "Gap analysis highlights improvement needs. Loss history and asset valuation help an organization improve risk scores. Scenario enumeration identifies potential events without assessing control adequacy.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      134,
      135,
      152,
      146,
      147
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 370,
    "question": "Which issue MOST increases insider threat risk?",
    "choice_a": "Privilege creep",
    "choice_b": "Monitoring automation",
    "choice_c": "Access reviews",
    "choice_d": "Role separation",
    "correct_answer": "A",
    "explanation": "Privilege creep, the slow accumulation of access rights over time, expands insider capability. Role separation, monitoring automation, and access reviews are controls that limit or detect excessive access rather than increase it.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      232,
      195,
      230,
      237,
      194
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 371,
    "question": "Which practice MOST strengthens alignment between IT risk and ERM?",
    "choice_a": "Independent reporting lines",
    "choice_b": "Incident dashboards",
    "choice_c": "Local metrics",
    "choice_d": "Shared risk taxonomy",
    "correct_answer": "D",
    "explanation": "Shared taxonomy enables integration, as risks will be viewed and measured consistently across IT risk, enterprise risk management (ERM), and elsewhere. Independent reporting lines can fragment perspectives. Local metrics reduce comparability. Incident dashboards focus on events rather than integrated risk views.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      123,
      124,
      120,
      116,
      125
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 372,
    "question": "Which response option formally documents a risk that requires no action?",
    "choice_a": "Mitigation",
    "choice_b": "Acceptance",
    "choice_c": "Transfer",
    "choice_d": "Avoidance",
    "correct_answer": "B",
    "explanation": "Acceptance acknowledges and documents risks that are accepted as-is.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      161,
      160,
      181,
      171,
      180
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 373,
    "question": "Which factor MOST improves threat modeling accuracy?",
    "choice_a": "Asset count",
    "choice_b": "Reporting format",
    "choice_c": "Control maturity",
    "choice_d": "Attacker capability assumptions",
    "correct_answer": "D",
    "explanation": "Accurate capability assumptions improve modeling through a better understanding of what attackers are capable of. Asset count affects scope but not realism; control maturity evaluates defenses rather than attacker behavior; reporting format influences presentation only.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      133,
      132,
      142,
      144,
      148
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 374,
    "question": "Which activity MOST supports early detection of system failures?",
    "choice_a": "Capacity planning",
    "choice_b": "Continuous monitoring",
    "choice_c": "Change approval",
    "choice_d": "Backup testing",
    "correct_answer": "B",
    "explanation": "Monitoring detects failures earlier than the other methods listed, by providing real-time or near-real-time visibility into system performance and availability. Capacity planning anticipates future needs, backup testing validates recovery, and change approval governs modifications, but none of these others detect failures as they occur.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      194,
      225,
      226,
      199,
      193
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 375,
    "question": "Which governance issue MOST likely results in conflicting risk priorities?",
    "choice_a": "Undefined prioritization criteria",
    "choice_b": "Board reporting",
    "choice_c": "Formal risk appetite",
    "choice_d": "Central oversight",
    "correct_answer": "A",
    "explanation": "Without prioritization criteria, priorities are more likely to conflict with one another. Central oversight, board reporting, and formal risk appetite all promote alignment and coherence rather than conflict.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      116,
      123,
      126,
      119,
      115
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 376,
    "question": "Which artifact MOST supports tracking progress of remediation actions?",
    "choice_a": "Control frameworks",
    "choice_b": "Audit charters",
    "choice_c": "Incident logs",
    "choice_d": "Risk register updates",
    "correct_answer": "D",
    "explanation": "In addition to serving as a risk catalog, risk registers can also be used to record risk treatment decisions and track remediation status. Audit charters define audit scope and authority, incident logs record events, and control frameworks provide reference structures rather than execution tracking.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      181,
      160,
      161,
      180,
      167
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 377,
    "question": "Which term describes the probability of a risk event?",
    "choice_a": "Exposure",
    "choice_b": "Impact",
    "choice_c": "Likelihood",
    "choice_d": "Threat",
    "correct_answer": "C",
    "explanation": "Likelihood is the term representing the probability of a risk event.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      142,
      132,
      147,
      146,
      152
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 378,
    "question": "Which practice MOST reduces misconfiguration risk in virtual environments?",
    "choice_a": "Asset tagging",
    "choice_b": "Manual configuration",
    "choice_c": "Incident drills",
    "choice_d": "Standardized templates",
    "correct_answer": "D",
    "explanation": "Standard templates, when applied across assets, enforce consistent configurations. Manual configuration increases the likelihood of errors, incident drills test response rather than prevention, and asset tagging supports identification without controlling configuration.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      200,
      214,
      192,
      230,
      225
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 379,
    "question": "Which governance failure MOST undermines accountability for accepted risks?",
    "choice_a": "Periodic review",
    "choice_b": "Assigned ownership",
    "choice_c": "Missing acceptance documentation",
    "choice_d": "Risk thresholds",
    "correct_answer": "C",
    "explanation": "Without documentation, you don\u2019t know who authorized risk acceptance, undermining accountability. Periodic review, assigned ownership, and risk thresholds all support oversight and accountability rather than weaken it.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      120,
      117,
      119,
      123,
      125
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 380,
    "question": "Which factor MOST determines whether a risk treatment plan should be escalated?",
    "choice_a": "Control maturity level",
    "choice_b": "Audit schedule",
    "choice_c": "Reporting cadence",
    "choice_d": "Missed treatment milestones",
    "correct_answer": "D",
    "explanation": "Missed milestones indicate execution is faltering and require escalation because they indicate risk responses are not being executed as planned. Control maturity level reflects design strength; the audit schedule and reporting cadence govern oversight timing. Neither signals execution failure.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      181,
      180,
      167,
      179,
      166
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 381,
    "question": "Which document MOST clearly defines enterprise-level risk expectations?",
    "choice_a": "Risk appetite statement",
    "choice_b": "Risk register",
    "choice_c": "Control catalog",
    "choice_d": "Audit charter",
    "correct_answer": "A",
    "explanation": "An organization\u2019s risk appetite statement articulates enterprise expectations for risk-taking.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      126,
      116,
      123,
      124,
      125
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 382,
    "question": "Which practice MOST reduces risk from unmanaged system settings?",
    "choice_a": "Capacity planning",
    "choice_b": "Incident response testing",
    "choice_c": "Configuration baselines",
    "choice_d": "Log archiving",
    "correct_answer": "C",
    "explanation": "Baselines enforce approved configurations. Lacking managed configurations and configuration standards, organizations will find themselves rife with vulnerabilities and inconsistencies. Incident response testing validates readiness after failures occur, capacity planning addresses performance and growth, and log archiving supports investigation rather than prevention.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      214,
      193,
      225,
      224,
      234
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 383,
    "question": "Which factor MOST improves uniformity in how risk events are described, analyzed, and documented across an organization?",
    "choice_a": "Individual assessor expertise",
    "choice_b": "Number of in-scope assets",
    "choice_c": "Depth of control documentation",
    "choice_d": "Standardized analysis frameworks",
    "correct_answer": "D",
    "explanation": "Standardized analysis frameworks can most improve consistency by enforcing common structure, assumptions, terminology, and data elements when describing and analyzing risk events. Individual assessor expertise improves quality but introduces variability; the number of assets affects scope rather than method; and control documentation supports mitigation analysis, not event definition.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      144,
      145,
      132,
      139,
      149
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 384,
    "question": "Which failure MOST undermines confidence in risk response reporting?",
    "choice_a": "Use of qualitative ratings",
    "choice_b": "Automated dashboards",
    "choice_c": "Executive summaries",
    "choice_d": "Unclear link between actions and risk reduction",
    "correct_answer": "D",
    "explanation": "Responses must be clearly linked to reduced risk. Otherwise, response activity will appear to have little or no purpose. Qualitative ratings can be credible when applied consistently, executive summaries improve comprehension, and automated dashboards enhance visibility but depend on sound underlying logic.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      180,
      181,
      183,
      185,
      182
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 385,
    "question": "Which governance practice MOST supports accountability for cross-enterprise risks?",
    "choice_a": "Defined escalation authority",
    "choice_b": "Technical reporting",
    "choice_c": "Departmental dashboards",
    "choice_d": "Local risk ownership",
    "correct_answer": "A",
    "explanation": "Escalation authority ensures accountability beyond silos by elevating risks that span multiple functions to decision-makers with enterprise-wide responsibility. Local risk ownership, technical reporting, and departmental dashboards tend to reinforce silos and limit accountability to individual areas.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      117,
      123,
      125,
      120,
      119
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 386,
    "question": "Which principle ensures that systems are accessible when required?",
    "choice_a": "Confidentiality",
    "choice_b": "Integrity",
    "choice_c": "Availability",
    "choice_d": "Authenticity",
    "correct_answer": "C",
    "explanation": "Availability ensures timely access to systems and data. Availability is a part of the CIA triad (confidentiality, integrity, and availability), the three pillars of information security.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      223,
      240,
      194,
      230,
      227
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 387,
    "question": "Which issue MOST limits the reliability of forward-looking risk assessments?",
    "choice_a": "Rapid threat landscape changes",
    "choice_b": "Scenario prioritization",
    "choice_c": "Business impact modeling",
    "choice_d": "Executive validation",
    "correct_answer": "A",
    "explanation": "Rapid changes in threat landscape reduce predictive reliability, as it can be difficult to discern the impact and likelihood of emerging and changing threats. Scenario prioritization improves focus, business impact modeling refines consequence estimates, and executive validation strengthens alignment and credibility. None of the incorrect answers addresses the volatility of external threats.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      142,
      143,
      144,
      157,
      159
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 388,
    "question": "Which input is MOST critical when defining acceptable compensating controls?",
    "choice_a": "Risk reduction required",
    "choice_b": "Control ownership",
    "choice_c": "Control cost",
    "choice_d": "Reporting frequency",
    "correct_answer": "A",
    "explanation": "Compensating controls must reduce risk to acceptable levels, because the alternative control must reduce risk to a level comparable to the original requirement. Control costs and ownership affect feasibility and management, but do not determine adequacy; reporting frequency addresses oversight rather than effectiveness.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      173,
      176,
      171,
      181,
      177
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 389,
    "question": "Which governance weakness MOST likely results in delayed risk decisions?",
    "choice_a": "Defined escalation paths",
    "choice_b": "Excessive approval layers",
    "choice_c": "Formal oversight committees",
    "choice_d": "Regular reporting",
    "correct_answer": "B",
    "explanation": "Excessive bureaucracy will impede decision-making by introducing bureaucratic friction and slow handoffs between decision-makers. Defined escalation paths, formal oversight committees, and regular reporting are governance mechanisms intended to streamline clarity and oversight rather than impede action.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      117,
      115,
      119,
      123,
      125
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 390,
    "question": "Which practice MOST improves detection of anomalous user behavior?",
    "choice_a": "Patch management",
    "choice_b": "Behavioral monitoring",
    "choice_c": "Asset tagging",
    "choice_d": "Backup testing",
    "correct_answer": "B",
    "explanation": "Behavioral monitoring, commonly known as end-user behavior analytics (EUBA), identifies anomalies that may indicate compromise. Patch management reduces vulnerabilities, asset tagging supports inventory, and backup testing validates recovery capability, but none detect abnormal user actions.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      245,
      194,
      238,
      239,
      226
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 391,
    "question": "Which element represents the potential consequence of a risk event?",
    "choice_a": "Threat",
    "choice_b": "Vulnerability",
    "choice_c": "Impact",
    "choice_d": "Likelihood",
    "correct_answer": "C",
    "explanation": "Impact reflects the consequences of a risk event. Threat is the risk method; vulnerability is a weakness in a system or process; and likelihood is the probability of occurrence.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      132,
      142,
      148,
      138,
      152
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 392,
    "question": "Which artifact MOST supports monitoring of accepted risks?",
    "choice_a": "Incident response plan",
    "choice_b": "Audit charter",
    "choice_c": "Risk acceptance log",
    "choice_d": "Asset inventory",
    "correct_answer": "C",
    "explanation": "Acceptance logs track ongoing monitoring obligations by recording accepted risks, review dates, conditions, and responsible owners, enabling ongoing oversight. Audit charters define audit authority, and incident response plans guide event handling. Asset inventories support identification, but do not track accepted risk status.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      161,
      181,
      180,
      162,
      166
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 393,
    "question": "Which practice MOST strengthens consistency in governance decision-making?",
    "choice_a": "Informal approvals",
    "choice_b": "Individual discretion",
    "choice_c": "Documented decision criteria",
    "choice_d": "Technical dashboards",
    "correct_answer": "C",
    "explanation": "Documented criteria ensure consistency in governance decisions. Informal approvals and individual discretion weaken consistency. Technical dashboards provide information without guiding decisions.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      119,
      123,
      126,
      120,
      125
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 394,
    "question": "Which condition MOST complicates the enforcement of secure configuration standards?",
    "choice_a": "Heterogeneous platforms",
    "choice_b": "Centralized tooling",
    "choice_c": "Standardized templates",
    "choice_d": "Automated validation",
    "correct_answer": "A",
    "explanation": "Diverse platforms complicate standard enforcement, as standards must be developed for each platform type and version. The other choices simplify enforcement by promoting consistency and scalability.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      197,
      192,
      224,
      228,
      196
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 395,
    "question": "Which activity MOST improves identification of emerging attack techniques?",
    "choice_a": "Annual audits",
    "choice_b": "Threat intelligence feeds",
    "choice_c": "Control testing",
    "choice_d": "Impact scoring",
    "correct_answer": "B",
    "explanation": "Threat intelligence feeds improve the identification of emerging attack techniques by providing timely information on new vulnerabilities, adversary tactics, and attack methods. Annual audits and control testing assess internal controls after the fact, and impact scoring evaluates consequences rather than threat evolution.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      150,
      156,
      133,
      143,
      142
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 396,
    "question": "Which response option removes exposure by discontinuing the risky activity?",
    "choice_a": "Avoidance",
    "choice_b": "Mitigation",
    "choice_c": "Acceptance",
    "choice_d": "Transfer",
    "correct_answer": "A",
    "explanation": "Avoidance eliminates the source of risk by discontinuing the activity that introduced the risk.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      160,
      171,
      181,
      166,
      178
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 397,
    "question": "Which governance condition MOST limits the accuracy of enterprise-wide views of cumulative risk exposure?",
    "choice_a": "Inconsistent aggregation methodologies across risk domains",
    "choice_b": "Enterprise-approved risk appetite statements",
    "choice_c": "Periodic formal reporting cycles",
    "choice_d": "Independent assurance activities",
    "correct_answer": "C",
    "explanation": "Inconsistent aggregation methodologies most limit accurate views of cumulative exposure because risks cannot be reliably combined or compared when aggregation rules differ across domains. Formal reporting cycles improve visibility, approved risk appetite statements define acceptable boundaries, and independent assurance validates controls and processes.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      120,
      123,
      124,
      119,
      125
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 398,
    "question": "Which practice MOST reduces operational risk from legacy applications?",
    "choice_a": "Vulnerability scanning",
    "choice_b": "Application rationalization",
    "choice_c": "Access reviews",
    "choice_d": "Log monitoring",
    "correct_answer": "B",
    "explanation": "Rationalization is the process of addressing the ongoing maintenance of information systems, including strategic decisions such as upgrades, migrations, and retirements. Vulnerability scanning, log monitoring, and access reviews manage specific risks, but do not address the root problem of outdated applications.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      216,
      193,
      195,
      228,
      190
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 399,
    "question": "Which factor MOST influences the credibility of business impact analysis results?",
    "choice_a": "Validation by process owners",
    "choice_b": "Financial modeling techniques",
    "choice_c": "Risk scoring scales",
    "choice_d": "Control documentation",
    "correct_answer": "A",
    "explanation": "As experts in their respective processes, owners validate operational reality, thereby improving the quality and depth of information in a BIA. Financial modeling techniques support quantification, but rely on accurate inputs; risk scoring scales organize results; control documentation describes safeguards rather than impacts.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      151,
      136,
      154,
      142,
      146
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 400,
    "question": "Which condition MOST indicates ineffective design of KRIs?",
    "choice_a": "Thresholds aligned to appetite",
    "choice_b": "Metrics lagging risk events",
    "choice_c": "Periodic review cycles",
    "choice_d": "Automated data feeds",
    "correct_answer": "B",
    "explanation": "Lagging metrics fail to provide early warning. When KRIs only register after risk events have occurred, they lose their primary value as early warning tools. Thresholds aligned to appetite, periodic review cycles, and automated data feeds all strengthen KRI effectiveness by improving relevance, governance, and timeliness.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      185,
      179,
      184,
      182,
      180
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 401,
    "question": "Which function provides an independent evaluation of governance effectiveness?",
    "choice_a": "Risk management",
    "choice_b": "Compliance",
    "choice_c": "IT operations",
    "choice_d": "Internal audit",
    "correct_answer": "D",
    "explanation": "As the third layer in the Three Lines of Defense model, internal audit independently evaluates governance.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      125,
      123,
      117,
      115,
      119
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 402,
    "question": "Which activity MOST supports early identification of data quality issues?",
    "choice_a": "Backup testing",
    "choice_b": "Integrity monitoring",
    "choice_c": "Access reviews",
    "choice_d": "Capacity planning",
    "correct_answer": "B",
    "explanation": "Integrity monitoring detects unauthorized changes, corruption, and other data integrity issues as they occur. Backup testing validates recoverability rather than data correctness, access reviews assess permissions without monitoring data state, and capacity planning addresses performance and growth.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      194,
      208,
      223,
      210,
      232
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 403,
    "question": "Which issue MOST undermines the completeness of scenario-based risk identification?",
    "choice_a": "Excessive scenario detail",
    "choice_b": "Limited cross-functional participation",
    "choice_c": "Impact scaling",
    "choice_d": "Qualitative scoring",
    "correct_answer": "B",
    "explanation": "Limited participation in risk scenario discussions omits key perspectives and introduces blind spots by missing dependencies and non-technical risks. Excessive scenario detail may affect efficiency, qualitative scoring affects precision rather than coverage, and impact scaling structures analysis without limiting scope.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      140,
      138,
      136,
      133,
      131
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 404,
    "question": "Which practice MOST improves transparency of risk response trade-offs?",
    "choice_a": "Informal discussions",
    "choice_b": "Audit reporting",
    "choice_c": "Control automation",
    "choice_d": "Documented decision rationale",
    "correct_answer": "D",
    "explanation": "Transparency through documentation clarifies trade-offs and accountability by recording the trade-offs considered, the reasoning behind selected risk responses, and the authority involved. Informal discussions lack traceability, control automation improves execution rather than decision transparency, and audit reporting reviews decisions after the fact.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      161,
      181,
      180,
      167,
      171
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 405,
    "question": "Which mechanism MOST supports the timely escalation of high-risk issues?",
    "choice_a": "Control catalogs",
    "choice_b": "Incident logs",
    "choice_c": "Asset inventories",
    "choice_d": "Defined risk thresholds",
    "correct_answer": "D",
    "explanation": "Defined risk thresholds serve as escalation triggers in risk treatment and other risk management scenarios. Incident logs record events after they occur; asset inventories catalog resources; and control catalogs describe safeguards but do not drive escalation.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      120,
      127,
      124,
      126,
      119
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 406,
    "question": "Which information security practice MOST directly supports the reduction of residual risk after control implementation?",
    "choice_a": "Security awareness training",
    "choice_b": "Control design documentation",
    "choice_c": "Post-implementation control testing",
    "choice_d": "Threat landscape analysis",
    "correct_answer": "C",
    "explanation": "Post-implementation control testing most directly supports the reduction of residual risk by validating that implemented controls are operating effectively and achieving the intended risk reduction. Control design documentation describes intent but does not confirm performance; security awareness training influences behavior. However, it does not verify specific control outcomes, and threat landscape analysis informs risk identification rather than mitigation effectiveness.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      230,
      225,
      216,
      233,
      228
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 407,
    "question": "Which output BEST supports executive comparison of risk severity?",
    "choice_a": "Vulnerability lists",
    "choice_b": "Normalized risk scores",
    "choice_c": "Incident timelines",
    "choice_d": "Control descriptions",
    "correct_answer": "B",
    "explanation": "Normalized scores enable side-by-side comparisons of risks by converting diverse risks to a common scale, enabling executives to evaluate and prioritize them effectively. Vulnerability lists are too granular and technical, offering no aggregated view of business impact. Control descriptions explain how risks are managed but do not quantify severity or support comparison across domains. Incident timelines provide historical event sequencing, not forward\u2011looking severity assessments.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      147,
      142,
      149,
      138,
      146
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 408,
    "question": "Which activity MOST supports validation of ongoing risk acceptance?",
    "choice_a": "Initial approval",
    "choice_b": "Policy publication",
    "choice_c": "Periodic residual risk review",
    "choice_d": "Control design",
    "correct_answer": "C",
    "explanation": "Ongoing reviews confirm acceptability over time. Risks should never be accepted in perpetuity; instead, they should expire and be re-litigated. Initial approval is a one\u2011time decision and cannot ensure continued appropriateness as circumstances change. Policy publication communicates expectations but does nothing to verify whether an accepted risk is still justified. Control design focuses on mitigating risks, not on reassessing whether acceptance remains valid.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      161,
      180,
      179,
      166,
      167
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 409,
    "question": "Which governance condition MOST affects consistency in how risks are escalated across the organization?",
    "choice_a": "Regular board-level risk reporting",
    "choice_b": "Centralized oversight structures",
    "choice_c": "Clarity of escalation criteria and thresholds",
    "choice_d": "Formally approved risk appetite statements",
    "correct_answer": "C",
    "explanation": "Clarity of escalation criteria and thresholds most affects consistency because clearly defined triggers determine when and how risks are elevated. Centralized oversight, board reporting, and formal risk appetite all support governance but, by themselves, do not ensure uniform escalation behavior.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      119,
      123,
      125,
      126,
      117
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 410,
    "question": "Which control MOST directly improves configuration consistency across container deployments?",
    "choice_a": "Operational response exercises",
    "choice_b": "Resource identification labels",
    "choice_c": "Manual deployment procedures",
    "choice_d": "Pre-approved build artifacts",
    "correct_answer": "D",
    "explanation": "Pre-approved build artifacts most directly improve configuration consistency by embedding validated settings into images used repeatedly across deployments. Operational response exercises improve readiness but do not prevent configuration drift, manual deployment procedures introduce variability and human error, and resource identification labels support inventory without affecting configuration state.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      214,
      215,
      200,
      230,
      220
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 411,
    "question": "Which term describes the cause-and-effect narrative of a risk event?",
    "choice_a": "Threat model",
    "choice_b": "Impact statement",
    "choice_c": "Control objective",
    "choice_d": "Risk scenario",
    "correct_answer": "D",
    "explanation": "A risk scenario describes the cause and consequence of a particular risk.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      138,
      139,
      148,
      137,
      142
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 412,
    "question": "Which failure MOST undermines the effectiveness of risk treatment governance?",
    "choice_a": "Automated reporting",
    "choice_b": "Executive oversight",
    "choice_c": "Lack of ownership assignment",
    "choice_d": "Risk ranking",
    "correct_answer": "C",
    "explanation": "Risk and process ownership are essential for the execution of governance activities, including risk treatment, because without a clearly accountable individual, no one is responsible for driving remediation, monitoring progress, or escalating delays, causing treatments to stall or fail. Automated reporting can enhance governance by improving visibility, without inherently weakening treatment effectiveness. Executive oversight strengthens governance by ensuring alignment with strategy and enforcing accountability. Risk ranking helps prioritize actions and does not impede governance when used appropriately.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      162,
      181,
      180,
      167,
      171
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 413,
    "question": "Which practice MOST supports alignment between IT risk and enterprise strategy?",
    "choice_a": "Risk-informed strategic planning",
    "choice_b": "Local risk assessments",
    "choice_c": "Technical dashboards",
    "choice_d": "Incident reporting",
    "correct_answer": "A",
    "explanation": "Strategic planning must consider risk, or else there is a risk of rework and strategy revisions. Local risk assessments are useful but siloed, and they therefore cannot ensure enterprise\u2011level alignment. Technical dashboards provide operational visibility but rarely translate technical metrics into strategic insight. Incident reporting focuses on past events rather than forward\u2011looking strategic alignment.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      116,
      123,
      124,
      115,
      126
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 414,
    "question": "Which control MOST directly supports data appropriateness throughout processing?",
    "choice_a": "Encryption",
    "choice_b": "Input validation",
    "choice_c": "Access logging",
    "choice_d": "Backup retention",
    "correct_answer": "B",
    "explanation": "Input validation ensures that data is appropriate when introduced into a system, preventing downstream errors during processing. Encryption protects confidentiality and integrity in transit or at rest, but does not ensure that the data itself is appropriate or accurate. Access logging records who interacted with data, but does not influence whether the data being processed is valid. Backup retention preserves data for recovery purposes and does not affect the correctness of data flowing through operational processes.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      212,
      215,
      230,
      231,
      244
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 415,
    "question": "Which factor MOST complicates estimation of reputational impact?",
    "choice_a": "Financial loss modeling",
    "choice_b": "Asset valuation",
    "choice_c": "Control effectiveness",
    "choice_d": "Stakeholder perception variability",
    "correct_answer": "D",
    "explanation": "Reputation impact is difficult to measure and inherently subjective, because reputation depends on how different groups interpret an event, and those interpretations can shift rapidly and unpredictably. Financial loss modeling provides structured, quantifiable outputs and does not address subjective sentiment. Asset valuation helps determine business importance, but it does not capture how external audiences will react. Control effectiveness influences the likelihood or severity of incidents but does not determine how stakeholders perceive the organization afterward.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      147,
      142,
      146,
      138,
      151
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 416,
    "question": "Which role is accountable for monitoring residual risk levels?",
    "choice_a": "Risk owner",
    "choice_b": "Control owner",
    "choice_c": "Internal audit",
    "choice_d": "System administrator",
    "correct_answer": "A",
    "explanation": "Risk owners are accountable for monitoring residual risk.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      162,
      181,
      179,
      180,
      161
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 417,
    "question": "Which concept defines acceptable variation within established risk boundaries?",
    "choice_a": "Risk capacity",
    "choice_b": "Risk tolerance",
    "choice_c": "Risk profile",
    "choice_d": "Risk appetite",
    "correct_answer": "B",
    "explanation": "Tolerance defines acceptable variation from risk appetite, the baseline of acceptable risk.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      126,
      116,
      123,
      124,
      125
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 418,
    "question": "Which factor MOST influences an organization\u2019s exposure to unauthorized data disclosure?",
    "choice_a": "Consistent with data classification practices",
    "choice_b": "Granularity of access segmentation",
    "choice_c": "Use of encryption for data in transit",
    "choice_d": "Frequency of access reviews",
    "correct_answer": "B",
    "explanation": "The granularity of access segmentation most influences exposure to unauthorized data disclosure because overly broad access allows users to access data beyond business need. Consistent data classification supports protection decisions but does not enforce access, encryption in transit protects data during transmission rather than access control, and access reviews detect issues periodically but do not prevent excessive access by design.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      231,
      232,
      209,
      244,
      208
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 419,
    "question": "Which factor MOST influences prioritization of remediation activities?",
    "choice_a": "Number of findings",
    "choice_b": "Risk exposure level",
    "choice_c": "Control documentation",
    "choice_d": "Audit timing",
    "correct_answer": "B",
    "explanation": "The highest-risk exposures should be prioritized for remediation, as organizations must address the issues with the greatest potential impact and likelihood before allocating resources to lower\u2011risk items. The number of findings can create noise, but volume alone does not indicate severity; many low\u2011risk issues should not outrank a single high\u2011risk one. Control documentation affects clarity and auditability, but does not determine which risks require urgent action. Audit timing may influence scheduling, but should never override risk\u2011based prioritization.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      149,
      142,
      152,
      146,
      147
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 420,
    "question": "Which reporting attribute MOST supports proactive decision-making?",
    "choice_a": "Historical summaries",
    "choice_b": "Technical detail",
    "choice_c": "Forward-looking indicators",
    "choice_d": "Narrative length",
    "correct_answer": "C",
    "explanation": "Forward-looking indicators, also known as key risk indicators (KRIs), enable proactive action by signaling the risk of future incidents, allowing leaders to intervene before incidents occur. Historical summaries are useful for understanding past events, but cannot predict what is likely to happen next. Technical detail may be valuable for specialists, but they often obscure the strategic signals executives need to act early. Narrative length has no inherent relationship to decision quality and can even dilute key insights.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      185,
      179,
      183,
      184,
      182
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 421,
    "question": "Which organizational characteristic MOST affects the effectiveness of the Three Lines of Defense model?",
    "choice_a": "Degree of separation between risk ownership, oversight, and assurance",
    "choice_b": "Clarity of formal role definitions",
    "choice_c": "Independence of assurance activities",
    "choice_d": "Consistency of reporting relationships",
    "correct_answer": "A",
    "explanation": "The degree of separation between risk ownership, oversight, and assurance most affects effectiveness because the Three Lines of Defense rely on distinct responsibilities and independence. Formal role definitions, independent assurance, and consistent reporting relationships all strengthen the model.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      125,
      117,
      115,
      123,
      126
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 422,
    "question": "Which activity MOST validates recovery point objectives?",
    "choice_a": "Log monitoring",
    "choice_b": "Change approvals",
    "choice_c": "Backup testing",
    "choice_d": "Asset reviews",
    "correct_answer": "C",
    "explanation": "Backup testing confirms recovery point objectives (RPOs), which define the maximum tolerable data loss resulting from a disruptive incident or disaster. Change approvals ensure modifications are reviewed, but do not verify recoverability. Log monitoring supports detection and analysis, but provides no evidence that data can be restored to a specific point. Asset reviews help maintain inventory accuracy, but do not test backup performance.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      206,
      202,
      205,
      194,
      240
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 423,
    "question": "Which practice MOST improves the completeness of enterprise risk identification?",
    "choice_a": "Technical scanning",
    "choice_b": "Control assessments",
    "choice_c": "Business-led risk workshops",
    "choice_d": "Asset inventories",
    "correct_answer": "C",
    "explanation": "Risk workshops attended by key stakeholders broaden risk identification by bringing together stakeholders from across the enterprise who understand processes, dependencies, and emerging issues that technical tools cannot detect. Technical scanning identifies system vulnerabilities but misses business-process, third-party, and strategic risks. Control assessments evaluate how well existing controls function, but do not surface new or emerging risks outside the control environment. Asset inventories help catalog what needs protection, but do not identify the full range of risks affecting those assets.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      140,
      131,
      144,
      143,
      138
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 424,
    "question": "Which issue MOST undermines the usefulness of executive risk dashboards?",
    "choice_a": "Visual summaries",
    "choice_b": "Excessive metric density",
    "choice_c": "Appetite alignment",
    "choice_d": "Trend indicators",
    "correct_answer": "B",
    "explanation": "Too many metrics increase noise, making it harder for executives to understand key risks. Overcrowded displays bury the signal, forcing leaders to hunt for what matters instead of seeing priorities at a glance. Visual summaries actually enhance usefulness by distilling complex information into intuitive formats. Trend indicators strengthen decision\u2011making by showing whether risks are improving or worsening over time. Appetite alignment helps executives understand which risks exceed tolerance and therefore support, rather than harm, dashboard value.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      183,
      185,
      184,
      182,
      180
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 425,
    "question": "Which artifact MOST supports governance consistency across organizational units?",
    "choice_a": "Local procedures",
    "choice_b": "Asset inventories",
    "choice_c": "Incident response plans",
    "choice_d": "Enterprise risk policy",
    "correct_answer": "D",
    "explanation": "Enterprise policies, when applied across organizational units, ensure consistency by establishing uniform expectations, principles, and requirements that every unit must follow, creating a common foundation for risk management. Local procedures vary by team or function, thereby introducing inconsistency rather than eliminating it. Incident response plans guide actions during disruptions, but do not standardize broader governance practices across units. Asset inventories help track resources but have no role in aligning governance behaviors.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      119,
      123,
      116,
      118,
      125
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 426,
    "question": "Which practice ensures system states can be restored after failure?",
    "choice_a": "Patch management",
    "choice_b": "Log retention",
    "choice_c": "Access reviews",
    "choice_d": "Configuration backups",
    "correct_answer": "D",
    "explanation": "Configuration backups enable the restoration of systems after a failure.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      194,
      240,
      206,
      204,
      207
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 427,
    "question": "Which analysis BEST supports understanding attacker pathways?",
    "choice_a": "Business impact analysis",
    "choice_b": "Threat modeling",
    "choice_c": "Risk scoring",
    "choice_d": "Control testing",
    "correct_answer": "B",
    "explanation": "Threat modeling identifies attack scenarios and maps attacker paths by explicitly defining potential adversaries, their objectives, and the sequence of steps they might take to compromise systems, producing clear maps of attack vectors and chokepoints. Business impact analysis focuses on operational consequences, not on how an attacker would navigate the environment. Control testing evaluates whether controls function, but does not reveal how an attacker might bypass or chain weaknesses. Risk scoring provides prioritization but lacks the scenario detail needed to trace pathways.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      133,
      134,
      138,
      142,
      148
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 428,
    "question": "Which activity MOST supports continuous improvement of risk responses?",
    "choice_a": "Annual assessments",
    "choice_b": "Post-implementation reviews",
    "choice_c": "Policy publication",
    "choice_d": "Control automation",
    "correct_answer": "B",
    "explanation": "Post-implementation reviews, also known as after-action reviews (AARs), identify opportunities for improvement by evaluating how well a risk response performed, identifying gaps, and capturing lessons learned that can be applied to future treatments. Annual assessments are too infrequent to drive iterative improvement and often miss emerging issues. Policy publication communicates expectations but does not evaluate whether responses are effective in practice. Control automation can improve efficiency and consistency, but it does not assess whether the underlying risk response strategy needs refinement.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      179,
      177,
      181,
      180,
      167
    ],
    "source": "373666_PracticeExam2"
  },
  {
    "id": 429,
    "question": "Which outcome MOST strongly indicates mature risk governance?",
    "choice_a": "Extensive documentation",
    "choice_b": "Frequent audits",
    "choice_c": "Risk-informed strategic decisions",
    "choice_d": "Detailed control inventories",
    "correct_answer": "C",
    "explanation": "Mature governance programs integrate risk into strategy rather than reacting to risks after a strategy has been developed and implemented. Extensive documentation may reflect thoroughness, but can exist in immature, checkbox\u2011driven programs. Frequent audits improve oversight but do not guarantee that risk insights influence strategic choices. Detailed control inventories help track safeguards, but say nothing about whether leadership uses risk information to guide direction.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      116,
      123,
      126,
      115,
      124
    ],
    "source": "373666_PracticeExam2"
  }
];
